<template>
    <div class="section pt-1 mb-2">

        <!-- Page Tabs -->
        <div class="report-tabs">
            <button type="button" class="report-tab mal-text"
                :class="{ active: page === 'karad' }"
                @click="page='karad'">
                കരട് റിപ്പോർട്ട്
            </button>
            <button type="button" class="report-tab mal-text"
                :class="{ active: page === 'receipt' }"
                @click="page='receipt'">
                റസീപ്റ്റ് റിപ്പോർട്ട്
            </button>
            <button type="button" class="report-tab mal-text"
                :class="{ active: page === 'not_started' }"
                @click="page='not_started'">
                കളക്ഷൻ റിപ്പോർട്ട്
            </button>
            <button type="button" class="report-tab mal-text"
                :class="{ active: page === 'target' }"
                @click="page='target'">
                ടാർഗറ്റ് റിപ്പോർട്ട്
            </button>
            <button type="button" class="report-tab mal-text"
                :class="{ active: page === 'members' }"
                @click="page='members'">
                മെമ്പർ റിപ്പോർട്ട്
            </button>
            <button type="button" class="report-tab mal-text"
                :class="{ active: page === 'takeback' }"
                @click="page='takeback'">
                റസീറ്റ് തിരിച്ചു വാങ്ങൽ
            </button>
        </div>

        <!-- ══════════════════════ KARAD REPORT ══════════════════════ -->
        <template v-if="page === 'karad'">

            <!-- Filters -->
            <div class="card p-1 mb-1" style="border-radius:12px;margin-top:0!important;">
                <div style="display:flex;gap:8px;align-items:center;">
                    <select v-if="user_level === 1" v-model="district_id"
                        class="form-select form-select-sm" style="flex:1;"
                        @change="onDistrictChange">
                        <option value="">All Districts</option>
                        <option v-for="d in districts" :key="d.id" :value="d.id">{{ d.name }}</option>
                    </select>
                    <select v-if="user_level <= 2" v-model="zone_id"
                        class="form-select form-select-sm" style="flex:1;"
                        @change="onZoneChange">
                        <option value="">All Zones</option>
                        <option v-for="z in zones" :key="z.id" :value="z.id">{{ z.name }}</option>
                    </select>
                    <select v-if="user_level >= 2" v-model="unit_id" class="form-select form-select-sm" style="flex:1;">
                        <option value="">All Units</option>
                        <option v-for="u in unit_options" :key="u.id" :value="u.id">{{ u.name }}</option>
                    </select>
                    <button type="button" class="btn btn-primary btn-sm" @click="loadReport" style="padding:6px 14px;flex-shrink:0;">
                        <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                        <ion-icon v-show="!loading" name="search-outline"></ion-icon>
                    </button>
                </div>
            </div>
            <div v-if="karadFilterHeading" class="mal-text" style="text-align:center;font-size:17px;font-weight:800;color:#1a418c;margin:6px 0 8px;">
                {{ karadFilterHeading }}
            </div>
            <div v-if="noYouthOnly || noYouthUnitsList.length" class="mal-text"
                :style="{textAlign:'center',fontSize:'12px',fontWeight:'700',cursor:'pointer',borderRadius:'8px',padding:'6px 10px',margin:'0 0 8px',
                    color: noYouthOnly ? '#fff' : '#e67e22', background: noYouthOnly ? '#e67e22' : '#fff3e0', border:'1px solid #fde0b3'}"
                @click="noYouthOnly = !noYouthOnly">
                {{ noYouthOnly ? 'Showing No Youth Units only ✕' : 'No Youth Units: ' + noYouthUnitsList.length + ' ▸' }}
            </div>

            <div v-if="loading" class="text-center py-4">
                <div class="spinner-border text-primary"></div>
            </div>

            <template v-else-if="summary">
                <!-- Summary Card -->
                <div class="card mb-1" style="border-radius:14px;overflow:hidden;">
                    <div class="p-1">
                        <div style="display:grid;grid-template-columns:repeat(3,1fr);gap:6px;margin-bottom:6px;">
                            <div class="stat-card" style="background:#f4f7ff;">
                                <div class="stat-value" style="color:#1a418c;">{{ summary.members_in_karad + summary.non_members_count }}</div>
                                <div class="stat-label mal-text">ആകെ എണ്ണം</div>
                            </div>
                            <div class="stat-card" style="background:#f4f7ff;">
                                <div class="stat-value" style="color:#1a418c;">{{ summary.members_in_karad }}</div>
                                <div class="stat-label mal-text">മെമ്പർമാർ</div>
                            </div>
                            <div class="stat-card" style="background:#fff8f0;">
                                <div class="stat-value" style="color:#e67e22;">{{ summary.non_members_count }}</div>
                                <div class="stat-label mal-text">അല്ലാത്തവർ</div>
                            </div>
                        </div>
                        <div style="display:grid;grid-template-columns:repeat(2,1fr);gap:6px;margin-bottom:6px;">
                            <div class="stat-card" style="background:#f0fff6;">
                                <div class="stat-value" style="color:#1DCC70;">{{ summary.visited_members }}</div>
                                <div class="stat-label mal-text">മെമ്പർമാരിൽ നിന്നും വിസിറ്റ് ചെയ്തവർ</div>
                            </div>
                            <div class="stat-card" style="background:#fff5f5;">
                                <div class="stat-value" style="color:#e74c3c;">{{ summary.not_visited }}</div>
                                <div class="stat-label mal-text">ചെയ്യാത്തവർ</div>
                            </div>
                        </div>
                        <div style="display:grid;grid-template-columns:repeat(2,1fr);gap:6px;margin-bottom:6px;">
                            <div class="stat-card" style="background:#f0fff6;">
                                <div class="stat-value" style="color:#1DCC70;">{{ summary.visited_non_members }}</div>
                                <div class="stat-label mal-text">മെമ്പർ അല്ലാത്തവരിൽ നിന്നും വിസിറ്റ് ചെയ്തവർ</div>
                            </div>
                            <div class="stat-card" style="background:#fff5f5;">
                                <div class="stat-value" style="color:#e74c3c;">{{ summary.not_visited_non_members }}</div>
                                <div class="stat-label mal-text">ചെയ്യാത്തവർ</div>
                            </div>
                        </div>
                        <div style="display:grid;grid-template-columns:repeat(2,1fr);gap:6px;">
                            <div class="stat-card" style="background:#f0fff6;">
                                <div class="stat-value" style="color:#1DCC70;font-size:15px;">₹{{ summary.collected_members }}</div>
                                <div class="stat-label mal-text">മെമ്പർമാരിൽ നിന്നും കിട്ടിയത്</div>
                            </div>
                            <div class="stat-card" style="background:#f0fff6;">
                                <div class="stat-value" style="color:#1DCC70;font-size:15px;">₹{{ summary.collected_non_members }}</div>
                                <div class="stat-label mal-text">മെമ്പർ അല്ലാത്തവരിൽ നിന്നും കിട്ടിയത്</div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Karad sub-tabs -->
                <div style="display:flex;gap:6px;margin-bottom:8px;">
                    <button type="button"
                        :style="{flex:1,padding:'8px',borderRadius:'10px',border:'none',fontWeight:'700',fontSize:'12px',
                            background: tab==='not_added' ? '#e74c3c' : '#f0f0f0',
                            color: tab==='not_added' ? '#fff' : '#666'}"
                        @click="tab='not_added'" class="mal-text">
                        ചേർക്കാത്ത ({{ filteredNotAdded.length }})
                    </button>
                    <button type="button"
                        :style="{flex:1,padding:'8px',borderRadius:'10px',border:'none',fontWeight:'700',fontSize:'12px',
                            background: tab==='added' ? '#1DCC70' : '#f0f0f0',
                            color: tab==='added' ? '#fff' : '#666'}"
                        @click="tab='added'" class="mal-text">
                        ചേർത്തത് ({{ filteredAdded.length }})
                    </button>
                </div>

                <!-- Not Added grouped (district → zone → unit) when no zone filter -->
                <div v-if="tab === 'not_added'">
                    <div v-if="!not_added.length" class="text-center text-muted py-3 mal-text" style="font-size:13px;">
                        എല്ലാ യൂണിറ്റുകളും ചേർത്തിട്ടുണ്ട്
                    </div>
                    <!-- Grouped view -->
                    <template v-else-if="user_level <= 2 && !zone_id">
                        <template v-for="dg in karadNotAddedByDistrict" :key="'dna_' + dg.district_id">
                            <div v-if="user_level === 1"
                                style="padding:8px 4px 4px;font-size:12px;font-weight:800;color:#e74c3c;letter-spacing:0.5px;text-transform:uppercase;border-bottom:2px solid #fde8e8;margin-bottom:6px;margin-top:10px;">
                                {{ dg.district_name }} ({{ dg.zones.length }})
                            </div>
                            <div v-for="zg in dg.zones" :key="'zna_' + zg.zone_name" class="mb-2">
                                <div :style="{background:'#fff',border:'1px solid #e0e0e0',borderRadius: collapsedKaradZones['na_' + zg.zone_name] ? '10px' : '10px 10px 0 0',padding:'10px 14px',cursor:'pointer'}"
                                    @click="toggleKaradZone('na_' + zg.zone_name)">
                                    <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">
                                        <span style="font-size:13px;font-weight:700;color:#27173E;flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{ zg.zone_name }}</span>
                                        <div style="display:flex;align-items:center;gap:6px;flex-shrink:0;">
                                            <span style="font-size:10px;background:#fee;color:#e74c3c;padding:2px 8px;border-radius:8px;font-weight:700;border:1px solid #fdc5c5;white-space:nowrap;" class="mal-text">
                                                {{ zg.units.length }} ചേർക്കാത്തത്
                                            </span>
                                            <ion-icon :name="collapsedKaradZones['na_' + zg.zone_name] ? 'chevron-forward-outline' : 'chevron-down-outline'" style="font-size:15px;color:#aaa;flex-shrink:0;"></ion-icon>
                                        </div>
                                    </div>
                                </div>
                                <div v-show="!collapsedKaradZones['na_' + zg.zone_name]" style="border:1px solid #e0e0e0;border-top:none;border-radius:0 0 10px 10px;overflow:hidden;padding:6px 8px;background:#fafafa;">
                                    <div v-for="(u, idx) in zg.units" :key="u.id" :class="{ 'no-youth-row': u.no_youth }"
                                        style="display:flex;align-items:center;gap:8px;background:#fff;border-radius:8px;padding:8px 10px;margin-bottom:5px;border:1px solid #fde8e8;border-left:3px solid #e74c3c;">
                                        <span style="color:#ddd;font-size:11px;width:16px;flex-shrink:0;text-align:right;">{{ idx + 1 }}</span>
                                        <div style="flex:1;min-width:0;">
                                            <div style="font-size:12px;font-weight:700;color:#27173E;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ u.name }}</div>
                                            <span v-if="u.no_youth" style="display:inline-block;margin-top:2px;font-size:9px;background:#fff3e0;color:#e67e22;padding:1px 6px;border-radius:6px;font-weight:700;">No Youth</span>
                                        </div>
                                        <span style="font-size:10px;background:#fee;color:#e74c3c;padding:3px 8px;border-radius:8px;font-weight:700;flex-shrink:0;border:1px solid #fdc5c5;" class="mal-text">ചേർത്തിട്ടില്ല</span>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </template>
                    <!-- Flat list when zone selected or level 3 -->
                    <template v-else>
                        <div v-for="(u, idx) in filteredNotAdded" :key="u.id" :class="{ 'no-youth-row': u.no_youth }"
                            class="card mb-1" style="border-radius:10px;padding:10px 12px;display:flex;flex-direction:row;align-items:center;gap:10px;">
                            <span style="color:#ddd;font-size:12px;width:20px;flex-shrink:0;text-align:right;">{{ idx + 1 }}</span>
                            <div style="flex:1;min-width:0;">
                                <div style="font-size:13px;font-weight:700;color:#e74c3c;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ u.name }}</div>
                                <div style="font-size:10px;color:#aaa;margin-top:2px;">{{ u.zone_name }}
                                    <span v-if="u.no_youth" style="display:inline-block;margin-left:4px;font-size:9px;background:#fff3e0;color:#e67e22;padding:1px 6px;border-radius:6px;font-weight:700;">No Youth</span>
                                </div>
                            </div>
                            <span style="font-size:10px;background:#fee;color:#e74c3c;padding:3px 8px;border-radius:10px;font-weight:700;flex-shrink:0;">ചേർത്തിട്ടില്ല</span>
                        </div>
                    </template>
                </div>

                <!-- Added grouped (district → zone → unit) when no zone filter -->
                <div v-else>
                    <div v-if="!added.length" class="text-center text-muted py-3 mal-text" style="font-size:13px;">
                        ആരും ചേർത്തിട്ടില്ല
                    </div>
                    <!-- Grouped view -->
                    <template v-else-if="user_level <= 2 && !zone_id">
                        <template v-for="dg in karadAddedByDistrict" :key="'da_' + dg.district_id">
                            <div v-if="user_level === 1"
                                style="padding:8px 4px 4px;font-size:12px;font-weight:800;color:#1a418c;letter-spacing:0.5px;text-transform:uppercase;border-bottom:2px solid #e8eef8;margin-bottom:6px;margin-top:10px;">
                                {{ dg.district_name }} ({{ dg.zones.length }})
                            </div>
                            <div v-for="zg in dg.zones" :key="'za_' + zg.zone_name" class="mb-2">
                                <div :style="{background:'#fff',border:'1px solid #e0e0e0',borderRadius: collapsedKaradZones['aa_' + zg.zone_name] ? '10px' : '10px 10px 0 0',padding:'10px 14px',cursor:'pointer'}"
                                    @click="toggleKaradZone('aa_' + zg.zone_name)">
                                    <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">
                                        <span style="font-size:13px;font-weight:700;color:#27173E;flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{ zg.zone_name }}</span>
                                        <div style="display:flex;align-items:center;gap:6px;flex-shrink:0;">
                                            <span style="font-size:10px;background:#f0fff6;color:#1DCC70;padding:2px 8px;border-radius:8px;font-weight:700;border:1px solid #b7f5d0;white-space:nowrap;">
                                                {{ zg.units.length }} യൂണിറ്റ്
                                            </span>
                                            <ion-icon :name="collapsedKaradZones['aa_' + zg.zone_name] ? 'chevron-forward-outline' : 'chevron-down-outline'" style="font-size:15px;color:#aaa;flex-shrink:0;"></ion-icon>
                                        </div>
                                    </div>
                                </div>
                                <div v-show="!collapsedKaradZones['aa_' + zg.zone_name]" style="border:1px solid #e0e0e0;border-top:none;border-radius:0 0 10px 10px;overflow:hidden;padding:6px 8px;background:#fafafa;">
                                    <div v-for="(u, idx) in zg.units" :key="u.id" :class="{ 'no-youth-row': u.no_youth }"
                                        style="display:flex;align-items:center;gap:8px;background:#fff;border-radius:8px;padding:8px 10px;margin-bottom:5px;border:1px solid #e8f5ee;border-left:3px solid #1DCC70;">
                                        <span style="color:#ddd;font-size:11px;width:16px;flex-shrink:0;text-align:right;">{{ idx + 1 }}</span>
                                        <div style="flex:1;min-width:0;">
                                            <div style="font-size:12px;font-weight:700;color:#27173E;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ u.name }}</div>
                                            <span v-if="u.no_youth" style="display:inline-block;margin-top:2px;font-size:9px;background:#fff3e0;color:#e67e22;padding:1px 6px;border-radius:6px;font-weight:700;">No Youth</span>
                                        </div>
                                        <div style="display:flex;flex-direction:column;align-items:flex-end;gap:4px;flex-shrink:0;">
                                            <span style="font-size:18px;font-weight:900;color:#1a418c;line-height:1;">{{ u.total }}</span>
                                            <div style="display:flex;gap:4px;">
                                                <span style="font-size:11px;font-weight:700;background:#fee;color:#e74c3c;padding:2px 7px;border-radius:6px;border:1px solid #fdc5c5;">{{ u.pending }}</span>
                                                <span style="font-size:11px;font-weight:700;background:#f0fff6;color:#1DCC70;padding:2px 7px;border-radius:6px;border:1px solid #b7f5d0;">{{ u.collected }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </template>
                    <!-- Flat list when zone selected or level 3 -->
                    <template v-else>
                        <div v-for="(u, idx) in filteredAdded" :key="u.id" :class="{ 'no-youth-row': u.no_youth }"
                            class="card mb-1" style="border-radius:10px;padding:10px 12px;display:flex;flex-direction:row;align-items:center;gap:10px;">
                            <span style="color:#ddd;font-size:12px;width:20px;flex-shrink:0;text-align:right;">{{ idx + 1 }}</span>
                            <div style="flex:1;min-width:0;">
                                <div style="font-size:13px;font-weight:700;color:#27173E;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ u.name }}</div>
                                <div style="font-size:10px;color:#aaa;margin-top:2px;">{{ u.zone_name }}
                                    <span v-if="u.no_youth" style="display:inline-block;margin-left:4px;font-size:9px;background:#fff3e0;color:#e67e22;padding:1px 6px;border-radius:6px;font-weight:700;">No Youth</span>
                                </div>
                            </div>
                            <div style="text-align:right;flex-shrink:0;">
                                <div style="font-size:16px;font-weight:800;color:#1a418c;line-height:1;">{{ u.total }}</div>
                                <div style="font-size:10px;color:#aaa;margin-top:2px;">
                                    <span style="color:#e74c3c;">{{ u.pending }}</span>
                                    <span style="color:#ccc;"> / </span>
                                    <span style="color:#1DCC70;">{{ u.collected }}</span>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </template>
        </template>

        <!-- ══════════════════════ RECEIPT REPORT ══════════════════════ -->
        <template v-else-if="page === 'receipt'">

            <!-- Receipt filters -->
            <div class="card p-1 mb-1" style="border-radius:12px;margin-top:0!important;">
                <div style="display:flex;gap:8px;align-items:center;">
                    <select v-if="user_level === 1" v-model="r_district_id"
                        class="form-select form-select-sm" style="flex:1;"
                        @change="onReceiptDistrictChange">
                        <option value="">All Districts</option>
                        <option v-for="d in districts" :key="d.id" :value="d.id">{{ d.name }}</option>
                    </select>
                    <select v-if="user_level <= 2" v-model="r_zone_id"
                        class="form-select form-select-sm" style="flex:1;"
                        @change="onReceiptZoneChange">
                        <option value="">All Zones</option>
                        <option v-for="z in r_zones" :key="z.id" :value="z.id">{{ z.name }}</option>
                    </select>
                    <select v-if="user_level >= 2" v-model="r_unit_id" class="form-select form-select-sm" style="flex:1;">
                        <option value="">All Units</option>
                        <option v-for="u in r_unit_options" :key="u.id" :value="u.id">{{ u.name }}</option>
                    </select>
                    <button type="button" class="btn btn-primary btn-sm" @click="loadReceiptReport" style="padding:6px 14px;flex-shrink:0;">
                        <span v-show="r_loading" class="spinner-border spinner-border-sm"></span>
                        <ion-icon v-show="!r_loading" name="search-outline"></ion-icon>
                    </button>
                </div>
                <!-- Percentage pills — shown once data is loaded -->
                <div v-if="r_loaded && !r_loading" style="display:flex;gap:6px;margin-top:8px;">
                    <div v-if="user_level === 1"
                        :style="{
                            flex:1, textAlign:'center', padding:'6px 4px', borderRadius:'10px',
                            background: receiptDistrictPercent===100 ? '#f0fff6' : (receiptDistrictPercent===0 ? '#fff0f0' : '#fff8ed'),
                            border: '1.5px solid ' + (receiptDistrictPercent===100 ? '#1DCC70' : (receiptDistrictPercent===0 ? '#e74c3c' : '#f0a500'))
                        }">
                        <div :style="{fontSize:'16px',fontWeight:'900',lineHeight:'1',color: receiptDistrictPercent===100 ? '#1DCC70' : (receiptDistrictPercent===0 ? '#e74c3c' : '#f0a500')}">{{ receiptDistrictPercent }}%</div>
                        <div style="font-size:9px;color:#888;font-weight:600;margin-top:2px;line-height:1.2;" class="mal-text">ജില്ല</div>
                    </div>
                    <div :style="{
                            flex:1, textAlign:'center', padding:'6px 4px', borderRadius:'10px',
                            background: receiptZonePercent===100 ? '#f0fff6' : (receiptZonePercent===0 ? '#fff0f0' : '#fff8ed'),
                            border: '1.5px solid ' + (receiptZonePercent===100 ? '#1DCC70' : (receiptZonePercent===0 ? '#e74c3c' : '#f0a500'))
                        }">
                        <div :style="{fontSize:'16px',fontWeight:'900',lineHeight:'1',color: receiptZonePercent===100 ? '#1DCC70' : (receiptZonePercent===0 ? '#e74c3c' : '#f0a500')}">{{ receiptZonePercent }}%</div>
                        <div style="font-size:9px;color:#888;font-weight:600;margin-top:2px;line-height:1.2;" class="mal-text">മണ്ഡലം</div>
                    </div>
                    <div :style="{
                            flex:1, textAlign:'center', padding:'6px 4px', borderRadius:'10px',
                            background: receiptUnitPercent===100 ? '#f0fff6' : (receiptUnitPercent===0 ? '#fff0f0' : '#fff8ed'),
                            border: '1.5px solid ' + (receiptUnitPercent===100 ? '#1DCC70' : (receiptUnitPercent===0 ? '#e74c3c' : '#f0a500'))
                        }">
                        <div :style="{fontSize:'16px',fontWeight:'900',lineHeight:'1',color: receiptUnitPercent===100 ? '#1DCC70' : (receiptUnitPercent===0 ? '#e74c3c' : '#f0a500')}">{{ receiptUnitPercent }}%</div>
                        <div style="font-size:9px;color:#888;font-weight:600;margin-top:2px;line-height:1.2;" class="mal-text">ശാഖ</div>
                    </div>
                </div>
            </div>
            <div v-if="receiptFilterHeading" class="mal-text" style="text-align:center;font-size:17px;font-weight:800;color:#1a418c;margin:6px 0 8px;">
                {{ receiptFilterHeading }}
            </div>
            <div v-if="noYouthOnly || noYouthUnitsList.length" class="mal-text"
                :style="{textAlign:'center',fontSize:'12px',fontWeight:'700',cursor:'pointer',borderRadius:'8px',padding:'6px 10px',margin:'0 0 8px',
                    color: noYouthOnly ? '#fff' : '#e67e22', background: noYouthOnly ? '#e67e22' : '#fff3e0', border:'1px solid #fde0b3'}"
                @click="noYouthOnly = !noYouthOnly">
                {{ noYouthOnly ? 'Showing No Youth Units only ✕' : 'No Youth Units: ' + noYouthUnitsList.length + ' ▸' }}
            </div>

            <div v-if="r_loading" class="text-center py-4">
                <div class="spinner-border text-primary"></div>
            </div>

            <div v-else-if="!r_loaded" class="text-center py-5" style="color:#aaa;">
                <ion-icon name="receipt-outline" style="font-size:36px;margin-bottom:8px;display:block;"></ion-icon>
                <div class="mal-text" style="font-size:13px;">സെർച്ച് ബട്ടൺ അമർത്തുക</div>
            </div>

            <template v-else>

                <!-- Summary: unit/zone/district count rows -->
                <!-- Units -->
                <div style="display:grid;grid-template-columns:repeat(3,1fr);gap:6px;margin-bottom:5px;">
                    <div style="background:#f4f7ff;border-radius:12px;padding:10px 6px;text-align:center;">
                        <div style="font-size:18px;font-weight:800;color:#1a418c;line-height:1;">{{ receipt_received_list.length + receipt_not_received_list.length }}</div>
                        <div style="font-size:10px;color:#888;font-weight:600;margin-top:3px;" class="mal-text">ആകെ യൂണിറ്റ്</div>
                    </div>
                    <div style="background:#f0fff6;border-radius:12px;padding:10px 6px;text-align:center;">
                        <div style="font-size:18px;font-weight:800;color:#1DCC70;line-height:1;">{{ receipt_received_list.length }}</div>
                        <div style="font-size:10px;color:#888;font-weight:600;margin-top:3px;" class="mal-text">ലഭിച്ചത്</div>
                    </div>
                    <div style="background:#fff3e0;border-radius:12px;padding:10px 6px;text-align:center;">
                        <div style="font-size:18px;font-weight:800;color:#e67e22;line-height:1;">{{ receipt_not_received_list.length }}</div>
                        <div style="font-size:10px;color:#888;font-weight:600;margin-top:3px;" class="mal-text">ലഭിക്കാത്തത്</div>
                    </div>
                </div>
                <!-- Zones (only when viewing multiple zones) -->
                <div v-if="user_level <= 2 && !r_zone_id" style="display:grid;grid-template-columns:repeat(3,1fr);gap:6px;margin-bottom:5px;">
                    <div style="background:#f4f7ff;border-radius:12px;padding:10px 6px;text-align:center;">
                        <div style="font-size:18px;font-weight:800;color:#1a418c;line-height:1;">{{ zoneReceiptStats.total }}</div>
                        <div style="font-size:10px;color:#888;font-weight:600;margin-top:3px;" class="mal-text">ആകെ മണ്ഡലം</div>
                    </div>
                    <div style="background:#f0fff6;border-radius:12px;padding:10px 6px;text-align:center;">
                        <div style="font-size:18px;font-weight:800;color:#1DCC70;line-height:1;">{{ zoneReceiptStats.received }}</div>
                        <div style="font-size:10px;color:#888;font-weight:600;margin-top:3px;" class="mal-text">ലഭിച്ചത്</div>
                    </div>
                    <div style="background:#fff3e0;border-radius:12px;padding:10px 6px;text-align:center;">
                        <div style="font-size:18px;font-weight:800;color:#e67e22;line-height:1;">{{ zoneReceiptStats.not_received }}</div>
                        <div style="font-size:10px;color:#888;font-weight:600;margin-top:3px;" class="mal-text">ലഭിക്കാത്തത്</div>
                    </div>
                </div>
                <!-- Districts (only state admin viewing all) -->
                <div v-if="user_level === 1 && !r_district_id" style="display:grid;grid-template-columns:repeat(3,1fr);gap:6px;margin-bottom:6px;">
                    <div style="background:#f4f7ff;border-radius:12px;padding:10px 6px;text-align:center;">
                        <div style="font-size:18px;font-weight:800;color:#1a418c;line-height:1;">{{ districtReceiptStats.total }}</div>
                        <div style="font-size:10px;color:#888;font-weight:600;margin-top:3px;" class="mal-text">ആകെ ജില്ല</div>
                    </div>
                    <div style="background:#f0fff6;border-radius:12px;padding:10px 6px;text-align:center;">
                        <div style="font-size:18px;font-weight:800;color:#1DCC70;line-height:1;">{{ districtReceiptStats.received }}</div>
                        <div style="font-size:10px;color:#888;font-weight:600;margin-top:3px;" class="mal-text">ലഭിച്ചത്</div>
                    </div>
                    <div style="background:#fff3e0;border-radius:12px;padding:10px 6px;text-align:center;">
                        <div style="font-size:18px;font-weight:800;color:#e67e22;line-height:1;">{{ districtReceiptStats.not_received }}</div>
                        <div style="font-size:10px;color:#888;font-weight:600;margin-top:3px;" class="mal-text">ലഭിക്കാത്തത്</div>
                    </div>
                </div>

                <!-- T-number receipts not yet reassigned to the actual book leaf number -->
                <div class="card mb-1" style="border-radius:12px;padding:10px 14px;display:flex;flex-direction:row;align-items:center;justify-content:space-between;gap:8px;border:1.5px solid #f0a500;background:#fff8ed;cursor:pointer;"
                    @click="openTNumberListModal">
                    <div class="mal-text" style="font-size:12px;font-weight:700;color:#a15c00;">
                        T നമ്പർ റസീപ്റ്റുകൾ (യഥാർത്ഥ നമ്പറാക്കി മാറ്റാത്തത്)
                    </div>
                    <div style="font-size:20px;font-weight:900;color:#f0a500;line-height:1;flex-shrink:0;">{{ r_t_number_count }}</div>
                </div>

                <!-- T-number receipts — unit-wise count, highest first -->
                <div v-if="tList_show" style="position:fixed;inset:0;background:rgba(0,0,0,0.45);z-index:10000;display:flex;align-items:flex-end;justify-content:center;" @click.self="tList_show = false">
                    <div style="background:#fff;border-radius:16px 16px 0 0;width:100%;max-width:520px;max-height:80vh;display:flex;flex-direction:column;">
                        <div style="display:flex;align-items:center;justify-content:space-between;padding:14px 16px;border-bottom:1px solid #eee;">
                            <span class="mal-text" style="font-size:14px;font-weight:800;color:#a15c00;">T നമ്പർ റസീപ്റ്റുകൾ — യൂണിറ്റ് തിരിച്ച്</span>
                            <button type="button" style="border:none;background:none;font-size:20px;color:#888;" @click="tList_show = false">&times;</button>
                        </div>
                        <div style="overflow-y:auto;padding:10px 14px;">
                            <div v-if="tList_loading" class="text-center py-3">
                                <div class="spinner-border spinner-border-sm text-secondary"></div>
                            </div>
                            <div v-else-if="!tList_rows.length" class="text-center text-muted py-3 mal-text">ഡേറ്റ ഇല്ല</div>
                            <div v-else v-for="(row, index) in tList_rows" :key="row.unit_id"
                                style="display:flex;align-items:center;justify-content:space-between;gap:8px;padding:9px 6px;border-bottom:1px solid #f2f2f2;">
                                <div style="display:flex;align-items:center;gap:8px;min-width:0;">
                                    <span style="font-size:11px;font-weight:800;color:#fff;background:#c9c9c9;width:20px;height:20px;border-radius:50%;display:flex;align-items:center;justify-content:center;flex-shrink:0;">{{ index + 1 }}</span>
                                    <div style="min-width:0;">
                                        <div style="font-size:13px;font-weight:700;color:#1e293b;">{{ row.unit_name }}</div>
                                        <div class="mal-text" style="font-size:11px;color:#888;">{{ row.zone_name }}<template v-if="row.district_name"> — {{ row.district_name }}</template></div>
                                    </div>
                                </div>
                                <div style="font-size:16px;font-weight:900;color:#f0a500;flex-shrink:0;">{{ row.count }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- View toggle + pending sub-tabs, together in one card -->
                <div class="filter-card">
                    <div style="display:flex;gap:6px;">
                        <button type="button"
                            :style="{flex:1,padding:'8px',borderRadius:'10px',border:'none',fontWeight:'700',fontSize:'12px',
                                background: !r_show_pending_only ? '#1a418c' : '#f0f0f0',
                                color: !r_show_pending_only ? '#fff' : '#666'}"
                            @click="r_show_pending_only = false" class="mal-text">
                            എല്ലാം
                        </button>
                        <button type="button"
                            :style="{flex:1,padding:'8px',borderRadius:'10px',border:'none',fontWeight:'700',fontSize:'12px',
                                background: r_show_pending_only ? '#e74c3c' : '#f0f0f0',
                                color: r_show_pending_only ? '#fff' : '#666'}"
                            @click="r_show_pending_only = true; r_pending_level = 'unit'" class="mal-text">
                            ലഭിക്കാത്തത് ({{ receipt_not_received_list.length }})
                        </button>
                    </div>

                    <!-- Pending level sub-tabs (only shown in pending mode, multi-zone view) -->
                    <div v-if="r_show_pending_only && user_level <= 2 && !r_zone_id" class="pending-tabs">
                        <button v-if="user_level === 1" type="button" class="pending-tab mal-text"
                            :class="{ active: r_pending_level === 'district' }"
                            @click="r_pending_level='district'">
                            ജില്ല ({{ pendingDistrictsList.length }})
                        </button>
                        <button type="button" class="pending-tab mal-text"
                            :class="{ active: r_pending_level === 'zone' }"
                            @click="r_pending_level='zone'">
                            മണ്ഡലം ({{ pendingZonesList.length }})
                        </button>
                        <button type="button" class="pending-tab mal-text"
                            :class="{ active: r_pending_level === 'unit' }"
                            @click="r_pending_level='unit'">
                            ശാഖ ({{ receipt_not_received_list.length }})
                        </button>
                        <button type="button" class="pending-tab orange mal-text"
                            :class="{ active: r_pending_level === 'undistributed' }"
                            @click="r_pending_level='undistributed'; loadUndistributed()">
                            വിതരണം ചെയ്യാത്തവ ({{ ud_zones.length }})
                        </button>
                    </div>
                </div>

                <!-- Pending districts list -->
                <div v-if="r_show_pending_only && r_pending_level==='district' && user_level===1">
                    <div v-if="!pendingDistrictsList.length" class="text-center text-muted py-4 mal-text" style="font-size:13px;">
                        എല്ലാ ജില്ലകൾക്കും ലഭിച്ചിട്ടുണ്ട്
                    </div>
                    <div v-for="(d, idx) in pendingDistrictsList" :key="d.district_id || d.district_name"
                        style="display:flex;align-items:center;gap:10px;background:#fff;border-radius:10px;padding:10px 14px;margin-bottom:6px;border:1px solid #fde8e8;border-left:3px solid #e74c3c;">
                        <span style="color:#ddd;font-size:12px;width:20px;flex-shrink:0;text-align:right;">{{ idx + 1 }}</span>
                        <div style="font-size:13px;font-weight:700;color:#27173E;flex:1;">{{ d.district_name }}</div>
                        <span style="font-size:10px;background:#fee;color:#e74c3c;padding:3px 8px;border-radius:8px;font-weight:700;border:1px solid #fdc5c5;" class="mal-text">ലഭിച്ചിട്ടില്ല</span>
                    </div>
                </div>

                <!-- Pending zones list -->
                <div v-else-if="r_show_pending_only && r_pending_level==='zone'">
                    <div v-if="!pendingZonesList.length" class="text-center text-muted py-4 mal-text" style="font-size:13px;">
                        എല്ലാ മണ്ഡലങ്ങൾക്കും ലഭിച്ചിട്ടുണ്ട്
                    </div>
                    <template v-else>
                        <!-- District sub-header for state admin -->
                        <template v-if="user_level===1">
                            <div v-for="(dg, dIdx) in pendingZonesByDistrict" :key="'pzd_'+dIdx">
                                <div style="padding:8px 4px 4px;font-size:12px;font-weight:800;color:#e74c3c;letter-spacing:0.5px;text-transform:uppercase;border-bottom:2px solid #fde8e8;margin-bottom:6px;margin-top:10px;">
                                    {{ dg.district_name }} ({{ dg.zones.length }})
                                </div>
                                <div v-for="(z, idx) in dg.zones" :key="z.zone_id || z.zone_name"
                                    style="display:flex;align-items:center;gap:10px;background:#fff;border-radius:10px;padding:10px 14px;margin-bottom:6px;border:1px solid #fde8e8;border-left:3px solid #e74c3c;">
                                    <span style="color:#ddd;font-size:12px;width:20px;flex-shrink:0;text-align:right;">{{ idx + 1 }}</span>
                                    <div style="font-size:13px;font-weight:700;color:#27173E;flex:1;">{{ z.zone_name }}</div>
                                    <span style="font-size:10px;background:#fee;color:#e74c3c;padding:3px 8px;border-radius:8px;font-weight:700;border:1px solid #fdc5c5;" class="mal-text">ലഭിച്ചിട്ടില്ല</span>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div v-for="(z, idx) in pendingZonesList" :key="z.zone_id || z.zone_name"
                                style="display:flex;align-items:center;gap:10px;background:#fff;border-radius:10px;padding:10px 14px;margin-bottom:6px;border:1px solid #fde8e8;border-left:3px solid #e74c3c;">
                                <span style="color:#ddd;font-size:12px;width:20px;flex-shrink:0;text-align:right;">{{ idx + 1 }}</span>
                                <div style="font-size:13px;font-weight:700;color:#27173E;flex:1;">{{ z.zone_name }}</div>
                                <span style="font-size:10px;background:#fee;color:#e74c3c;padding:3px 8px;border-radius:8px;font-weight:700;border:1px solid #fdc5c5;" class="mal-text">ലഭിച്ചിട്ടില്ല</span>
                            </div>
                        </template>
                    </template>
                </div>

                <!-- Undistributed zones (reached but gave nothing to units), grouped by district -->
                <div v-else-if="r_show_pending_only && r_pending_level==='undistributed'">
                    <div v-if="ud_loading" class="text-center py-4">
                        <div class="spinner-border text-warning"></div>
                    </div>
                    <template v-else>
                        <div v-if="!ud_zones.length" class="text-center text-success py-4 mal-text" style="font-size:13px;">
                            ✓ എല്ലാ മണ്ഡലങ്ങളും ശാഖകൾക്ക് വിതരണം ചെയ്തിട്ടുണ്ട്
                        </div>
                        <div v-for="(dg, dIdx) in undistributedByDistrict" :key="'udd_'+dIdx">
                            <div style="padding:8px 4px 4px;font-size:12px;font-weight:800;color:#e67e22;letter-spacing:0.5px;text-transform:uppercase;border-bottom:2px solid #fdecd8;margin-bottom:6px;margin-top:10px;">
                                {{ dg.district_name }} ({{ dg.zones.length }})
                            </div>
                            <div v-for="(z, idx) in dg.zones" :key="z.zone_id"
                                style="display:flex;align-items:center;gap:10px;background:#fff;border-radius:10px;padding:10px 14px;margin-bottom:6px;border:1px solid #fdecd8;border-left:3px solid #e67e22;">
                                <span style="color:#ddd;font-size:12px;width:20px;flex-shrink:0;text-align:right;">{{ idx + 1 }}</span>
                                <div style="flex:1;min-width:0;">
                                    <div style="font-size:13px;font-weight:700;color:#27173E;">{{ z.zone_name }}</div>
                                    <div style="font-size:10px;color:#aab;" class="mal-text">{{ z.units_count }} ശാഖ</div>
                                </div>
                                <span style="font-size:10px;background:#fff8ed;color:#e67e22;padding:3px 8px;border-radius:8px;font-weight:700;border:1px solid #fde8b0;white-space:nowrap;">
                                    📕 {{ z.books_held }}
                                </span>
                            </div>
                        </div>
                    </template>
                </div>

                <!-- Zone-grouped by district (unit view) -->
                <div v-else-if="user_level <= 2 && !r_zone_id">
                    <div v-if="zonesByDistrict.length === 0" class="text-center text-muted py-4 mal-text" style="font-size:13px;">
                        എല്ലാ യൂണിറ്റുകൾക്കും റസീപ്റ്റ് ലഭിച്ചിട്ടുണ്ട്
                    </div>
                    <template v-for="dg in zonesByDistrict">
                        <!-- District header — only shown for state admin -->
                        <div v-if="user_level === 1" :key="'d_' + dg.district_name"
                            style="padding:8px 4px 4px;font-size:12px;font-weight:800;color:#1a418c;letter-spacing:0.5px;text-transform:uppercase;border-bottom:2px solid #e8eef8;margin-bottom:6px;margin-top:10px;">
                            {{ dg.district_name }} ({{ dg.zones.length }})
                        </div>
                    <div v-for="zg in dg.zones" :key="zg.zone_id" class="mb-2">
                        <!-- Zone header -->
                        <div :style="{background:'#fff',border:'1px solid #e0e0e0',borderRadius: collapsedZones[zg.zone_id] ? '10px' : '10px 10px 0 0',padding:'11px 14px',cursor:'pointer'}"
                            @click="toggleZone(zg.zone_id)">
                            <div style="display:flex;align-items:center;justify-content:space-between;">
                                <span style="font-size:14px;font-weight:700;color:#27173E;">{{ zg.zone_name }}</span>
                                <ion-icon :name="collapsedZones[zg.zone_id] ? 'chevron-forward-outline' : 'chevron-down-outline'" style="font-size:15px;color:#aaa;"></ion-icon>
                            </div>
                            <!-- Zone & Unit receipt status row -->
                            <div style="display:flex;gap:6px;margin-top:6px;flex-wrap:wrap;">
                                <!-- Zone receipt status -->
                                <span v-if="zg.zone_receipt_book_no"
                                    style="font-size:10px;background:#f0fff6;color:#1DCC70;padding:2px 9px;border-radius:8px;font-weight:700;border:1px solid #b7f5d0;">
                                    സോൺ: {{ zg.zone_receipt_book_no }}
                                </span>
                                <span v-else
                                    style="font-size:10px;background:#fff5f5;color:#e74c3c;padding:2px 9px;border-radius:8px;font-weight:700;border:1px solid #fdc5c5;" class="mal-text">
                                    സോൺ: ലഭിച്ചിട്ടില്ല
                                </span>
                                <!-- Units receipt summary -->
                                <span v-if="r_show_pending_only"
                                    style="font-size:10px;background:#fff5f5;color:#e74c3c;padding:2px 9px;border-radius:8px;font-weight:700;border:1px solid #fdc5c5;" class="mal-text">
                                    ലഭിക്കാത്തത്: {{ zg.units.length }} യൂണിറ്റ്
                                </span>
                                <!-- Zone not received → units can't have received either -->
                                <span v-else-if="!zg.zone_receipt_book_no"
                                    style="font-size:10px;background:#fff5f5;color:#e74c3c;padding:2px 9px;border-radius:8px;font-weight:700;border:1px solid #fdc5c5;" class="mal-text">
                                    ലഭിക്കാത്തത്: {{ zg.units.length }} യൂണിറ്റ്
                                </span>
                                <!-- Zone received → show unit-level progress -->
                                <span v-else
                                    :style="{
                                        fontSize:'10px', padding:'2px 9px', borderRadius:'8px', fontWeight:'700',
                                        background: zg.received_count === 0 ? '#fff5f5' : (zg.received_count === zg.units.length ? '#f0fff6' : '#fff8ed'),
                                        color:      zg.received_count === 0 ? '#e74c3c' : (zg.received_count === zg.units.length ? '#1DCC70' : '#f0a500'),
                                        border: '1px solid ' + (zg.received_count === 0 ? '#fdc5c5' : (zg.received_count === zg.units.length ? '#b7f5d0' : '#fde8b0'))
                                    }" class="mal-text">
                                    യൂണിറ്റ്: {{ zg.received_count }}/{{ zg.units.length }}
                                </span>
                                <!-- T-number receipts still pending reassignment in this zone —
                                     visible on the collapsed header so it's clear without opening it -->
                                <span v-if="zg.t_number_total"
                                    class="mal-text"
                                    style="font-size:10px;background:#fff8ed;color:#a15c00;padding:2px 9px;border-radius:8px;font-weight:700;border:1px solid #fde8b0;">
                                    T നമ്പർ: {{ zg.t_number_total }}
                                </span>
                            </div>
                        </div>
                        <!-- Units list -->
                        <div v-show="!collapsedZones[zg.zone_id]" style="border:1px solid #e0e0e0;border-top:none;border-radius:0 0 10px 10px;overflow:hidden;transition:all 0.2s;">
                            <!-- Pending mode: zone pending but all units received -->
                            <div v-if="r_show_pending_only && zg.units.length === 0"
                                style="padding:9px 14px;font-size:11px;color:#1DCC70;text-align:center;" class="mal-text">
                                എല്ലാ യൂണിറ്റുകൾക്കും ലഭിച്ചിട്ടുണ്ട്
                            </div>
                            <div v-for="(u, idx) in zg.units" :key="u.id" :class="{ 'no-youth-row': u.no_youth }"
                                :style="{
                                    padding:'9px 12px',
                                    display:'flex',
                                    flexDirection:'column',
                                    gap:'6px',
                                    background: u.receipt_book_no ? '#f4f7ff' : '#fff',
                                    borderTop: idx > 0 ? '1px solid #f0f0f0' : 'none',
                                    borderLeft: u.receipt_book_no ? '3px solid #1a418c' : '3px solid transparent'
                                }">
                                <!-- Top row: index + name + book badge -->
                                <div style="display:flex;align-items:center;gap:8px;width:100%;">
                                    <span style="color:#bbb;font-size:11px;width:18px;flex-shrink:0;text-align:right;">{{ idx + 1 }}</span>
                                    <div style="flex:1;min-width:0;">
                                        <div style="font-size:12px;font-weight:700;color:#27173E;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ u.name }}</div>
                                        <span v-if="u.no_youth" style="display:inline-block;margin-top:2px;font-size:9px;background:#fff3e0;color:#e67e22;padding:1px 6px;border-radius:6px;font-weight:700;">No Youth</span>
                                    </div>
                                    <span v-if="u.receipt_book_no" style="font-size:12px;background:#eef3ff;color:#1a418c;padding:3px 10px;border-radius:10px;font-weight:700;border:1px solid #d0dbff;flex-shrink:0;">
                                        {{ u.receipt_book_no }}
                                    </span>
                                    <span v-else style="font-size:10px;background:#fff5f5;color:#e74c3c;padding:3px 8px;border-radius:10px;font-weight:700;flex-shrink:0;border:1px solid #fdc5c5;" class="mal-text">
                                        ലഭിച്ചിട്ടില്ല
                                    </span>
                                </div>
                                <!-- Holder name full-width row -->
                                <div v-if="u.holder_name" style="display:flex;align-items:center;gap:5px;margin-left:26px;font-size:12px;font-weight:600;color:#1a418c;background:#eef3ff;border:1px solid #d0dbff;border-radius:8px;padding:4px 10px;">
                                    <ion-icon name="person-outline" style="font-size:13px;flex-shrink:0;"></ion-icon>
                                    <span>{{ u.holder_name }}</span>
                                </div>
                                <!-- T-number receipts not yet reassigned to the actual book leaf -->
                                <div v-if="u.t_number_count" class="mal-text" style="display:flex;align-items:center;gap:5px;margin-left:26px;font-size:11px;font-weight:700;color:#a15c00;background:#fff8ed;border:1px solid #fde8b0;border-radius:8px;padding:4px 10px;">
                                    T നമ്പർ: {{ u.t_number_count }}
                                </div>
                            </div>
                        </div>
                    </div>
                    </template>
                </div>

                <!-- Flat list when zone is selected or level 3 -->
                <div v-else>
                    <div v-for="(u, idx) in allUnitsFlat" :key="u.id" :class="{ 'no-youth-row': u.no_youth }"
                        class="card mb-1" style="border-radius:10px;padding:10px 12px;display:flex;flex-direction:column;gap:6px;">
                        <div style="display:flex;align-items:center;gap:10px;">
                            <span style="color:#ddd;font-size:12px;width:20px;flex-shrink:0;text-align:right;">{{ idx + 1 }}</span>
                            <div style="flex:1;min-width:0;">
                                <div :style="{fontSize:'13px',fontWeight:'700',color: u.receipt_book_no ? '#27173E' : '#e74c3c',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}">
                                    {{ u.name }}
                                </div>
                                <span v-if="u.no_youth" style="display:inline-block;margin-top:2px;font-size:9px;background:#fff3e0;color:#e67e22;padding:1px 6px;border-radius:6px;font-weight:700;">No Youth</span>
                            </div>
                            <span v-if="u.receipt_book_no" style="font-size:12px;background:#eef3ff;color:#1a418c;padding:3px 10px;border-radius:10px;font-weight:700;border:1px solid #d0dbff;flex-shrink:0;">
                                {{ u.receipt_book_no }}
                            </span>
                            <span v-else style="font-size:10px;background:#fee;color:#e74c3c;padding:3px 8px;border-radius:10px;font-weight:700;flex-shrink:0;" class="mal-text">
                                ലഭിച്ചിട്ടില്ല
                            </span>
                        </div>
                        <!-- Holder name full-width row -->
                        <div v-if="u.holder_name" style="display:flex;align-items:center;gap:5px;margin-left:30px;font-size:12px;font-weight:600;color:#1a418c;background:#eef3ff;border:1px solid #d0dbff;border-radius:8px;padding:4px 10px;">
                            <ion-icon name="person-outline" style="font-size:13px;flex-shrink:0;"></ion-icon>
                            <span>{{ u.holder_name }}</span>
                        </div>
                        <!-- T-number receipts not yet reassigned to the actual book leaf -->
                        <div v-if="u.t_number_count" class="mal-text" style="display:flex;align-items:center;gap:5px;margin-left:30px;font-size:11px;font-weight:700;color:#a15c00;background:#fff8ed;border:1px solid #fde8b0;border-radius:8px;padding:4px 10px;">
                            T നമ്പർ: {{ u.t_number_count }}
                        </div>
                    </div>
                </div>

            </template>
        </template>

        <!-- ══════════════════════ NOT STARTED REPORT ══════════════════════ -->
        <template v-else-if="page === 'not_started'">

            <!-- Filters -->
            <div class="card p-1 mb-1" style="border-radius:12px;margin-top:0!important;">
                <div style="display:flex;gap:8px;align-items:center;">
                    <select v-if="user_level === 1" v-model="ns_district_id"
                        class="form-select form-select-sm" style="flex:1;"
                        @change="onNsDistrictChange">
                        <option value="">All Districts</option>
                        <option v-for="d in districts" :key="d.id" :value="d.id">{{ d.name }}</option>
                    </select>
                    <select v-if="user_level <= 2" v-model="ns_zone_id"
                        class="form-select form-select-sm" style="flex:1;"
                        @change="onNsZoneChange">
                        <option value="">All Zones</option>
                        <option v-for="z in ns_zones" :key="z.id" :value="z.id">{{ z.name }}</option>
                    </select>
                    <select v-if="user_level >= 2" v-model="ns_unit_id" class="form-select form-select-sm" style="flex:1;">
                        <option value="">All Units</option>
                        <option v-for="u in ns_unit_options" :key="u.id" :value="u.id">{{ u.name }}</option>
                    </select>
                    <button type="button" class="btn btn-primary btn-sm" @click="loadNotStartedReport" style="padding:6px 14px;flex-shrink:0;">
                        <span v-show="ns_loading" class="spinner-border spinner-border-sm"></span>
                        <ion-icon v-show="!ns_loading" name="search-outline"></ion-icon>
                    </button>
                </div>
            </div>
            <div v-if="nsFilterHeading" class="mal-text" style="text-align:center;font-size:17px;font-weight:800;color:#1a418c;margin:6px 0 8px;">
                {{ nsFilterHeading }}
            </div>
            <div v-if="noYouthOnly || noYouthUnitsList.length" class="mal-text"
                :style="{textAlign:'center',fontSize:'12px',fontWeight:'700',cursor:'pointer',borderRadius:'8px',padding:'6px 10px',margin:'0 0 8px',
                    color: noYouthOnly ? '#fff' : '#e67e22', background: noYouthOnly ? '#e67e22' : '#fff3e0', border:'1px solid #fde0b3'}"
                @click="noYouthOnly = !noYouthOnly">
                {{ noYouthOnly ? 'Showing No Youth Units only ✕' : 'No Youth Units: ' + noYouthUnitsList.length + ' ▸' }}
            </div>

            <div v-if="ns_loading" class="text-center py-4">
                <div class="spinner-border text-primary"></div>
            </div>

            <div v-else-if="!ns_loaded" class="text-center py-5" style="color:#aaa;">
                <ion-icon name="hourglass-outline" style="font-size:36px;margin-bottom:8px;display:block;"></ion-icon>
                <div class="mal-text" style="font-size:13px;">സെർച്ച് ബട്ടൺ അമർത്തുക</div>
            </div>

            <template v-else>

                <!-- Summary counts -->
                <div style="display:grid;grid-template-columns:repeat(3,1fr);gap:6px;margin-bottom:5px;">
                    <div style="background:#f4f7ff;border-radius:12px;padding:10px 6px;text-align:center;">
                        <div style="font-size:18px;font-weight:800;color:#1a418c;line-height:1;">{{ ns_unit_total }}</div>
                        <div style="font-size:10px;color:#888;font-weight:600;margin-top:3px;" class="mal-text">ആകെ യൂണിറ്റ്</div>
                    </div>
                    <div style="background:#f0fff6;border-radius:12px;padding:10px 6px;text-align:center;">
                        <div style="font-size:18px;font-weight:800;color:#1DCC70;line-height:1;">{{ ns_unit_started.length }}</div>
                        <div style="font-size:10px;color:#888;font-weight:600;margin-top:3px;" class="mal-text">ആരംഭിച്ചത്</div>
                    </div>
                    <div style="background:#fff3e0;border-radius:12px;padding:10px 6px;text-align:center;">
                        <div style="font-size:18px;font-weight:800;color:#e74c3c;line-height:1;">{{ ns_unit_not_started.length }}</div>
                        <div style="font-size:10px;color:#888;font-weight:600;margin-top:3px;" class="mal-text">ആരംഭിക്കാത്തത്</div>
                    </div>
                </div>
                <div v-if="user_level === 1 && !ns_district_id" style="display:grid;grid-template-columns:repeat(2,1fr);gap:6px;margin-bottom:5px;">
                    <div style="background:#f4f7ff;border-radius:12px;padding:10px 6px;text-align:center;">
                        <div style="font-size:18px;font-weight:800;color:#1a418c;line-height:1;">{{ ns_district_total }}</div>
                        <div style="font-size:10px;color:#888;font-weight:600;margin-top:3px;" class="mal-text">ആകെ ജില്ല</div>
                    </div>
                    <div style="background:#fff3e0;border-radius:12px;padding:10px 6px;text-align:center;">
                        <div style="font-size:18px;font-weight:800;color:#e74c3c;line-height:1;">{{ ns_district_not_started.length }}</div>
                        <div style="font-size:10px;color:#888;font-weight:600;margin-top:3px;" class="mal-text">ആരംഭിക്കാത്ത ജില്ല</div>
                    </div>
                </div>
                <div v-if="user_level <= 2 && !ns_zone_id" style="display:grid;grid-template-columns:repeat(2,1fr);gap:6px;margin-bottom:6px;">
                    <div style="background:#f4f7ff;border-radius:12px;padding:10px 6px;text-align:center;">
                        <div style="font-size:18px;font-weight:800;color:#1a418c;line-height:1;">{{ ns_zone_total }}</div>
                        <div style="font-size:10px;color:#888;font-weight:600;margin-top:3px;" class="mal-text">ആകെ മണ്ഡലം</div>
                    </div>
                    <div style="background:#fff3e0;border-radius:12px;padding:10px 6px;text-align:center;">
                        <div style="font-size:18px;font-weight:800;color:#e74c3c;line-height:1;">{{ ns_zone_not_started.length }}</div>
                        <div style="font-size:10px;color:#888;font-weight:600;margin-top:3px;" class="mal-text">ആരംഭിക്കാത്ത മണ്ഡലം</div>
                    </div>
                </div>

                <!-- Consolidation Report -->
                <div class="mb-2" v-if="ns_breakdown">
                    <div class="consolidation-card">
                        <div class="cons-header" @click="consOpen = !consOpen">
                            <span class="cons-title">Consolidation Report</span>
                            <ion-icon name="chevron-down-outline" class="cons-chevron" :class="{ open: consOpen }"></ion-icon>
                        </div>
                        <transition name="cons-collapse">
                            <div v-show="consOpen" class="cons-body">
                                <div class="cons-row">
                                    <span class="cons-label mal-text"><ion-icon name="wallet-outline" style="color:#1a418c;"></ion-icon> യൂണിറ്റുകളുടെ കൈവശം</span>
                                    <span class="cons-val">₹{{ formatAmt(ns_breakdown.with_unit) }}</span>
                                </div>
                                <div class="cons-row">
                                    <span class="cons-label mal-text"><ion-icon name="globe-outline" style="color:#16a34a;"></ion-icon> ഓൺലൈൻ പേയ്മെന്റ്</span>
                                    <span class="cons-val">₹{{ formatAmt(ns_breakdown.online) }}</span>
                                </div>
                                <div class="cons-row">
                                    <span class="cons-label mal-text"><ion-icon name="business-outline" style="color:#b45309;"></ion-icon> QR / ഓഫീസ് (വെരിഫൈഡ്)</span>
                                    <span class="cons-val">₹{{ formatAmt(ns_breakdown.office) }}</span>
                                </div>
                            </div>
                        </transition>
                    </div>
                </div>

                <!-- Started / Not Started mode toggle -->
                <div style="display:flex;gap:6px;margin-bottom:8px;">
                    <button type="button"
                        :style="{flex:1,padding:'8px',borderRadius:'10px',border:'none',fontWeight:'700',fontSize:'12px',
                            background: ns_mode==='not_started' ? '#e74c3c' : '#f0f0f0',
                            color: ns_mode==='not_started' ? '#fff' : '#666'}"
                        @click="ns_mode='not_started'" class="mal-text">
                        ആരംഭിക്കാത്തത്
                    </button>
                    <button type="button"
                        :style="{flex:1,padding:'8px',borderRadius:'10px',border:'none',fontWeight:'700',fontSize:'12px',
                            background: ns_mode==='started' ? '#1DCC70' : '#f0f0f0',
                            color: ns_mode==='started' ? '#fff' : '#666'}"
                        @click="ns_mode='started'" class="mal-text">
                        ആരംഭിച്ചത് (%)
                    </button>
                </div>

                <!-- Level sub-tabs: District / Zone / Unit -->
                <div class="filter-card">
                    <div class="pending-tabs" :style="{gridTemplateColumns: 'repeat(' + (user_level === 1 ? 3 : (user_level <= 2 && !ns_zone_id ? 2 : 1)) + ',1fr)'}">
                        <button v-if="user_level === 1 && !ns_district_id" type="button" class="pending-tab mal-text"
                            :class="{ active: ns_level === 'district' }"
                            @click="ns_level='district'">
                            ജില്ല ({{ ns_mode === 'not_started' ? ns_district_not_started.length : ns_district_percent.length }})
                        </button>
                        <button v-if="user_level <= 2 && !ns_zone_id" type="button" class="pending-tab mal-text"
                            :class="{ active: ns_level === 'zone' }"
                            @click="ns_level='zone'">
                            മണ്ഡലം ({{ ns_mode === 'not_started' ? ns_zone_not_started.length : ns_zone_percent.length }})
                        </button>
                        <button type="button" class="pending-tab mal-text"
                            :class="{ active: ns_level === 'unit' }"
                            @click="ns_level='unit'">
                            യൂണിറ്റ് ({{ ns_mode === 'not_started' ? filteredNsNotStarted.length : filteredNsStarted.length }})
                        </button>
                    </div>
                </div>

                <!-- Percentage bucket filter — Started mode only. Each button is the RANGE
                     between the previous threshold and itself (e.g. "65–80%"), not "below X". -->
                <div v-if="ns_mode === 'started'" style="display:flex;gap:4px;margin-bottom:8px;overflow-x:auto;">
                    <button v-for="(th, i) in [20,40,65,80,100]" :key="'pf_'+th" type="button"
                        :style="{padding:'6px 10px',borderRadius:'8px',border:'none',fontWeight:'700',fontSize:'11px',whiteSpace:'nowrap',flexShrink:'0',
                            background: ns_percent_filter===th ? '#e74c3c' : '#f0f0f0',
                            color: ns_percent_filter===th ? '#fff' : '#666'}"
                        @click="ns_percent_filter = (ns_percent_filter === th ? null : th)">
                        {{ i > 0 ? [20,40,65,80,100][i-1] : 0 }}-{{ th }}%
                    </button>
                </div>

                <template v-if="ns_mode === 'not_started'">
                    <!-- District level -->
                    <div v-if="ns_level === 'district' && user_level === 1 && !ns_district_id">
                        <div v-if="!ns_district_not_started.length" class="text-center text-success py-4 mal-text" style="font-size:13px;">
                            ✓ എല്ലാ ജില്ലകളും ഫണ്ട് ശേഖരണം ആരംഭിച്ചിട്ടുണ്ട്
                        </div>
                        <div v-for="(d, idx) in notStartedDistrictsList" :key="d.id"
                            style="display:flex;align-items:center;gap:10px;background:#fff;border-radius:10px;padding:10px 14px;margin-bottom:6px;border:1px solid #fde8e8;border-left:3px solid #e74c3c;">
                            <span style="color:#ddd;font-size:12px;width:20px;flex-shrink:0;text-align:right;">{{ idx + 1 }}</span>
                            <div style="font-size:13px;font-weight:700;color:#27173E;flex:1;">{{ d.name }}</div>
                            <span style="font-size:10px;background:#fee;color:#e74c3c;padding:3px 8px;border-radius:8px;font-weight:700;border:1px solid #fdc5c5;" class="mal-text">ആരംഭിച്ചിട്ടില്ല</span>
                        </div>
                    </div>

                    <!-- Zone level, grouped by district -->
                    <div v-else-if="ns_level === 'zone' && user_level <= 2 && !ns_zone_id">
                        <div v-if="!ns_zone_not_started.length" class="text-center text-success py-4 mal-text" style="font-size:13px;">
                            ✓ എല്ലാ മണ്ഡലങ്ങളും ഫണ്ട് ശേഖരണം ആരംഭിച്ചിട്ടുണ്ട്
                        </div>
                        <template v-else>
                            <div v-for="(dg, dIdx) in notStartedZonesByDistrict" :key="'nzd_'+dIdx">
                                <div v-if="user_level === 1"
                                    style="padding:8px 4px 4px;font-size:12px;font-weight:800;color:#e74c3c;letter-spacing:0.5px;text-transform:uppercase;border-bottom:2px solid #fde8e8;margin-bottom:6px;margin-top:10px;">
                                    {{ dg.district_name }} ({{ dg.zones.length }})
                                </div>
                                <div v-for="(z, idx) in dg.zones" :key="z.id"
                                    style="display:flex;align-items:center;gap:10px;background:#fff;border-radius:10px;padding:10px 14px;margin-bottom:6px;border:1px solid #fde8e8;border-left:3px solid #e74c3c;">
                                    <span style="color:#ddd;font-size:12px;width:20px;flex-shrink:0;text-align:right;">{{ idx + 1 }}</span>
                                    <div style="font-size:13px;font-weight:700;color:#27173E;flex:1;">{{ z.name }}</div>
                                    <span style="font-size:10px;background:#fee;color:#e74c3c;padding:3px 8px;border-radius:8px;font-weight:700;border:1px solid #fdc5c5;" class="mal-text">ആരംഭിച്ചിട്ടില്ല</span>
                                </div>
                            </div>
                        </template>
                    </div>

                    <!-- Unit level, grouped by district → zone -->
                    <div v-else>
                        <div v-if="!ns_unit_not_started.length" class="text-center text-success py-4 mal-text" style="font-size:13px;">
                            ✓ എല്ലാ യൂണിറ്റുകളും ഫണ്ട് ശേഖരണം ആരംഭിച്ചിട്ടുണ്ട്
                        </div>
                        <!-- Grouped view -->
                        <template v-else-if="user_level <= 2 && !ns_zone_id">
                            <template v-for="dg in notStartedUnitsByDistrict" :key="'nud_' + dg.district_id">
                                <div v-if="user_level === 1"
                                    style="padding:8px 4px 4px;font-size:12px;font-weight:800;color:#e74c3c;letter-spacing:0.5px;text-transform:uppercase;border-bottom:2px solid #fde8e8;margin-bottom:6px;margin-top:10px;">
                                    {{ dg.district_name }} ({{ dg.zones.length }})
                                </div>
                                <div v-for="zg in dg.zones" :key="'nuz_' + zg.zone_name" class="mb-2">
                                    <div :style="{background:'#fff',border:'1px solid #e0e0e0',borderRadius: collapsedNsZones[zg.zone_name] ? '10px' : '10px 10px 0 0',padding:'10px 14px',cursor:'pointer'}"
                                        @click="toggleNsZone(zg.zone_name)">
                                        <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">
                                            <span style="font-size:13px;font-weight:700;color:#27173E;flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{ zg.zone_name }}</span>
                                            <div style="display:flex;align-items:center;gap:6px;flex-shrink:0;">
                                                <span style="font-size:10px;background:#fee;color:#e74c3c;padding:2px 8px;border-radius:8px;font-weight:700;border:1px solid #fdc5c5;white-space:nowrap;" class="mal-text">
                                                    {{ zg.units.length }} ആരംഭിക്കാത്തത്
                                                </span>
                                                <ion-icon :name="collapsedNsZones[zg.zone_name] ? 'chevron-forward-outline' : 'chevron-down-outline'" style="font-size:15px;color:#aaa;flex-shrink:0;"></ion-icon>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-show="!collapsedNsZones[zg.zone_name]" style="border:1px solid #e0e0e0;border-top:none;border-radius:0 0 10px 10px;overflow:hidden;padding:6px 8px;background:#fafafa;">
                                        <div v-for="(u, idx) in zg.units" :key="u.id" :class="{ 'no-youth-row': u.no_youth }"
                                            style="display:flex;align-items:center;gap:8px;background:#fff;border-radius:8px;padding:8px 10px;margin-bottom:5px;border:1px solid #fde8e8;border-left:3px solid #e74c3c;">
                                            <span style="color:#ddd;font-size:11px;width:16px;flex-shrink:0;text-align:right;">{{ idx + 1 }}</span>
                                            <div style="flex:1;min-width:0;">
                                                <div style="font-size:12px;font-weight:700;color:#27173E;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ u.name }}</div>
                                                <span v-if="u.no_youth" style="display:inline-block;margin-top:2px;font-size:9px;background:#fff3e0;color:#e67e22;padding:1px 6px;border-radius:6px;font-weight:700;">No Youth</span>
                                            </div>
                                            <button type="button" @click.stop="openFollowup(u)" style="border:none;background:#eef2ff;color:#4c51bf;width:24px;height:24px;border-radius:50%;display:flex;align-items:center;justify-content:center;flex-shrink:0;padding:0;">
                                                <ion-icon name="call-outline" style="font-size:13px;"></ion-icon>
                                            </button>
                                            <span style="font-size:10px;background:#fee;color:#e74c3c;padding:3px 8px;border-radius:8px;font-weight:700;flex-shrink:0;border:1px solid #fdc5c5;" class="mal-text">ആരംഭിച്ചിട്ടില്ല</span>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </template>
                        <!-- Flat list when zone selected or level 3 -->
                        <template v-else>
                            <div v-for="(u, idx) in filteredNsNotStarted" :key="u.id" :class="{ 'no-youth-row': u.no_youth }"
                                class="card mb-1" style="border-radius:10px;padding:10px 12px;display:flex;flex-direction:row;align-items:center;gap:10px;">
                                <span style="color:#ddd;font-size:12px;width:20px;flex-shrink:0;text-align:right;">{{ idx + 1 }}</span>
                                <div style="flex:1;min-width:0;">
                                    <div style="font-size:13px;font-weight:700;color:#e74c3c;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ u.name }}</div>
                                    <div style="font-size:10px;color:#aaa;margin-top:2px;">{{ u.zone_name }}
                                        <span v-if="u.no_youth" style="display:inline-block;margin-left:4px;font-size:9px;background:#fff3e0;color:#e67e22;padding:1px 6px;border-radius:6px;font-weight:700;">No Youth</span>
                                    </div>
                                </div>
                                <button type="button" @click.stop="openFollowup(u)" style="border:none;background:#eef2ff;color:#4c51bf;width:26px;height:26px;border-radius:50%;display:flex;align-items:center;justify-content:center;flex-shrink:0;padding:0;">
                                    <ion-icon name="call-outline" style="font-size:14px;"></ion-icon>
                                </button>
                                <span style="font-size:10px;background:#fee;color:#e74c3c;padding:3px 8px;border-radius:10px;font-weight:700;flex-shrink:0;">ആരംഭിച്ചിട്ടില്ല</span>
                            </div>
                        </template>
                    </div>
                </template>

                <!-- ══ Started (percentage) view ══ -->
                <template v-else>
                    <!-- District level -->
                    <div v-if="ns_level === 'district' && user_level === 1 && !ns_district_id">
                        <div v-if="!startedDistrictsList.length" class="text-center text-muted py-4 mal-text" style="font-size:13px;">
                            ഡാറ്റ ഇല്ല
                        </div>
                        <div v-for="(d, idx) in startedDistrictsList" :key="'dp_' + d.id"
                            style="background:#fff;border-radius:10px;padding:10px 14px;margin-bottom:6px;border:1px solid #e0e0e0;">
                            <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;margin-bottom:6px;">
                                <span style="color:#ddd;font-size:12px;width:20px;flex-shrink:0;text-align:right;">{{ idx + 1 }}</span>
                                <div style="font-size:13px;font-weight:700;color:#27173E;flex:1;">{{ d.name }}</div>
                                <span style="font-size:13px;font-weight:800;" :style="{color: d.percent >= 100 ? '#1DCC70' : (d.percent >= 50 ? '#f0a500' : '#e74c3c')}">{{ d.percent }}%</span>
                            </div>
                            <div class="progress" style="height:6px;">
                                <div class="progress-bar" :style="{width: d.percent + '%', background: d.percent >= 100 ? '#1DCC70' : (d.percent >= 50 ? '#f0a500' : '#e74c3c')}"></div>
                            </div>
                            <div style="font-size:10px;color:#aaa;margin-top:4px;" class="mal-text">{{ d.started_units }} / {{ d.total_units }} യൂണിറ്റ് ആരംഭിച്ചു</div>
                        </div>
                    </div>

                    <!-- Zone level, grouped by district -->
                    <div v-else-if="ns_level === 'zone' && user_level <= 2 && !ns_zone_id">
                        <div v-if="!ns_zone_percent.length" class="text-center text-muted py-4 mal-text" style="font-size:13px;">
                            ഡാറ്റ ഇല്ല
                        </div>
                        <template v-else>
                            <div v-for="(dg, dIdx) in startedZonesByDistrict" :key="'szd_'+dIdx">
                                <div v-if="user_level === 1"
                                    style="padding:8px 4px 4px;font-size:12px;font-weight:800;color:#1a418c;letter-spacing:0.5px;text-transform:uppercase;border-bottom:2px solid #e8eef8;margin-bottom:6px;margin-top:10px;">
                                    {{ dg.district_name }} ({{ dg.zones.length }})
                                </div>
                                <div v-for="(z, idx) in dg.zones" :key="'zp_' + z.id"
                                    style="background:#fff;border-radius:10px;padding:10px 14px;margin-bottom:6px;border:1px solid #e0e0e0;">
                                    <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;margin-bottom:6px;">
                                        <span style="color:#ddd;font-size:12px;width:20px;flex-shrink:0;text-align:right;">{{ idx + 1 }}</span>
                                        <div style="font-size:13px;font-weight:700;color:#27173E;flex:1;">{{ z.name }}</div>
                                        <span style="font-size:13px;font-weight:800;" :style="{color: z.percent >= 100 ? '#1DCC70' : (z.percent >= 50 ? '#f0a500' : '#e74c3c')}">{{ z.percent }}%</span>
                                    </div>
                                    <div class="progress" style="height:6px;">
                                        <div class="progress-bar" :style="{width: z.percent + '%', background: z.percent >= 100 ? '#1DCC70' : (z.percent >= 50 ? '#f0a500' : '#e74c3c')}"></div>
                                    </div>
                                    <div style="font-size:10px;color:#aaa;margin-top:4px;" class="mal-text">{{ z.started_units }} / {{ z.total_units }} യൂണിറ്റ് ആരംഭിച്ചു</div>
                                </div>
                            </div>
                        </template>
                    </div>

                    <!-- Unit level, grouped by district → zone -->
                    <div v-else>
                        <div v-if="!ns_unit_started.length" class="text-center text-muted py-4 mal-text" style="font-size:13px;">
                            ഒരു യൂണിറ്റും ആരംഭിച്ചിട്ടില്ല
                        </div>
                        <!-- Grouped view -->
                        <template v-else-if="user_level <= 2 && !ns_zone_id">
                            <template v-for="dg in startedUnitsByDistrict" :key="'sud_' + dg.district_id">
                                <div v-if="user_level === 1"
                                    style="padding:8px 4px 4px;font-size:12px;font-weight:800;color:#1a418c;letter-spacing:0.5px;text-transform:uppercase;border-bottom:2px solid #e8eef8;margin-bottom:6px;margin-top:10px;">
                                    {{ dg.district_name }} ({{ dg.zones.length }})
                                </div>
                                <div v-for="zg in dg.zones" :key="'suz_' + zg.zone_name" class="mb-2">
                                    <div :style="{background:'#fff',border:'1px solid #e0e0e0',borderRadius: collapsedNsZones[zg.zone_name] ? '10px' : '10px 10px 0 0',padding:'10px 14px',cursor:'pointer'}"
                                        @click="toggleNsZone(zg.zone_name)">
                                        <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">
                                            <span style="font-size:13px;font-weight:700;color:#27173E;flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{ zg.zone_name }}</span>
                                            <div style="display:flex;align-items:center;gap:6px;flex-shrink:0;">
                                                <span style="font-size:10px;background:#f0fff6;color:#1DCC70;padding:2px 8px;border-radius:8px;font-weight:700;border:1px solid #b7f5d0;white-space:nowrap;" class="mal-text">
                                                    {{ zg.units.length }} ആരംഭിച്ചത്
                                                </span>
                                                <ion-icon :name="collapsedNsZones[zg.zone_name] ? 'chevron-forward-outline' : 'chevron-down-outline'" style="font-size:15px;color:#aaa;flex-shrink:0;"></ion-icon>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-show="!collapsedNsZones[zg.zone_name]" style="border:1px solid #e0e0e0;border-top:none;border-radius:0 0 10px 10px;overflow:hidden;padding:6px 8px;background:#fafafa;">
                                        <div v-for="(u, idx) in zg.units" :key="u.id" :class="{ 'no-youth-row': u.no_youth }"
                                            style="background:#fff;border-radius:8px;padding:8px 10px;margin-bottom:5px;border:1px solid #e8f5ee;border-left:3px solid #1DCC70;">
                                            <div style="display:flex;align-items:center;gap:8px;margin-bottom:4px;">
                                                <span style="color:#ddd;font-size:11px;width:16px;flex-shrink:0;text-align:right;">{{ idx + 1 }}</span>
                                                <div style="flex:1;min-width:0;">
                                                    <div style="font-size:12px;font-weight:700;color:#27173E;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ u.name }}</div>
                                                    <span v-if="u.no_youth" style="display:inline-block;margin-top:2px;font-size:9px;background:#fff3e0;color:#e67e22;padding:1px 6px;border-radius:6px;font-weight:700;">No Youth</span>
                                                </div>
                                                <button type="button" @click.stop="openFollowup(u)" style="border:none;background:#eef2ff;color:#4c51bf;width:24px;height:24px;border-radius:50%;display:flex;align-items:center;justify-content:center;flex-shrink:0;padding:0;">
                                                    <ion-icon name="call-outline" style="font-size:13px;"></ion-icon>
                                                </button>
                                                <span style="font-size:12px;font-weight:800;flex-shrink:0;" :style="{color: u.percent >= 100 ? '#1DCC70' : (u.percent >= 50 ? '#f0a500' : '#e74c3c')}">{{ u.percent }}%</span>
                                            </div>
                                            <div class="progress" style="height:4px;">
                                                <div class="progress-bar" :style="{width: u.percent + '%', background: u.percent >= 100 ? '#1DCC70' : (u.percent >= 50 ? '#f0a500' : '#e74c3c')}"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </template>
                        <!-- Flat list when zone selected or level 3 -->
                        <template v-else>
                            <div v-for="(u, idx) in filteredNsStarted" :key="u.id" :class="{ 'no-youth-row': u.no_youth }"
                                class="card mb-1" style="border-radius:10px;padding:10px 12px;">
                                <div style="display:flex;align-items:center;gap:10px;margin-bottom:4px;">
                                    <span style="color:#ddd;font-size:12px;width:20px;flex-shrink:0;text-align:right;">{{ idx + 1 }}</span>
                                    <div style="flex:1;min-width:0;">
                                        <div style="font-size:13px;font-weight:700;color:#27173E;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ u.name }}</div>
                                        <div style="font-size:10px;color:#aaa;margin-top:2px;">{{ u.zone_name }}
                                            <span v-if="u.no_youth" style="display:inline-block;margin-left:4px;font-size:9px;background:#fff3e0;color:#e67e22;padding:1px 6px;border-radius:6px;font-weight:700;">No Youth</span>
                                        </div>
                                    </div>
                                    <button type="button" @click.stop="openFollowup(u)" style="border:none;background:#eef2ff;color:#4c51bf;width:26px;height:26px;border-radius:50%;display:flex;align-items:center;justify-content:center;flex-shrink:0;padding:0;">
                                        <ion-icon name="call-outline" style="font-size:14px;"></ion-icon>
                                    </button>
                                    <span style="font-size:13px;font-weight:800;flex-shrink:0;" :style="{color: u.percent >= 100 ? '#1DCC70' : (u.percent >= 50 ? '#f0a500' : '#e74c3c')}">{{ u.percent }}%</span>
                                </div>
                                <div class="progress" style="height:4px;">
                                    <div class="progress-bar" :style="{width: u.percent + '%', background: u.percent >= 100 ? '#1DCC70' : (u.percent >= 50 ? '#f0a500' : '#e74c3c')}"></div>
                                </div>
                            </div>
                        </template>
                    </div>
                </template>
            </template>
        </template>

        <!-- ══════════════════════ TARGET GIVEN REPORT ══════════════════════ -->
        <template v-else-if="page === 'target'">

            <!-- Filters -->
            <div class="card p-1 mb-1" style="border-radius:12px;margin-top:0!important;">
                <div style="display:flex;gap:8px;align-items:center;">
                    <select v-if="user_level === 1" v-model="tg_district_id"
                        class="form-select form-select-sm" style="flex:1;"
                        @change="onTargetDistrictChange">
                        <option value="">All Districts</option>
                        <option v-for="d in districts" :key="d.id" :value="d.id">{{ d.name }}</option>
                    </select>
                    <select v-if="user_level <= 2" v-model="tg_zone_id"
                        class="form-select form-select-sm" style="flex:1;"
                        @change="onTargetZoneChange">
                        <option value="">All Zones</option>
                        <option v-for="z in tg_zones" :key="z.id" :value="z.id">{{ z.name }}</option>
                    </select>
                    <select v-if="user_level >= 2" v-model="tg_unit_id" class="form-select form-select-sm" style="flex:1;">
                        <option value="">All Units</option>
                        <option v-for="u in tg_unit_options" :key="u.id" :value="u.id">{{ u.name }}</option>
                    </select>
                    <button type="button" class="btn btn-primary btn-sm" @click="loadTargetReport" style="padding:6px 14px;flex-shrink:0;">
                        <span v-show="tg_loading" class="spinner-border spinner-border-sm"></span>
                        <ion-icon v-show="!tg_loading" name="search-outline"></ion-icon>
                    </button>
                </div>
            </div>
            <div v-if="tgFilterHeading" class="mal-text" style="text-align:center;font-size:17px;font-weight:800;color:#1a418c;margin:6px 0 8px;">
                {{ tgFilterHeading }}
            </div>
            <div v-if="noYouthOnly || noYouthUnitsList.length" class="mal-text"
                :style="{textAlign:'center',fontSize:'12px',fontWeight:'700',cursor:'pointer',borderRadius:'8px',padding:'6px 10px',margin:'0 0 8px',
                    color: noYouthOnly ? '#fff' : '#e67e22', background: noYouthOnly ? '#e67e22' : '#fff3e0', border:'1px solid #fde0b3'}"
                @click="noYouthOnly = !noYouthOnly">
                {{ noYouthOnly ? 'Showing No Youth Units only ✕' : 'No Youth Units: ' + noYouthUnitsList.length + ' ▸' }}
            </div>

            <div v-if="tg_loading" class="text-center py-4">
                <div class="spinner-border text-primary"></div>
            </div>

            <div v-else-if="!tg_loaded" class="text-center py-5" style="color:#aaa;">
                <ion-icon name="flag-outline" style="font-size:36px;margin-bottom:8px;display:block;"></ion-icon>
                <div class="mal-text" style="font-size:13px;">സെർച്ച് ബട്ടൺ അമർത്തുക</div>
            </div>

            <template v-else-if="tg_summary">
                <!-- Summary -->
                <div class="card mb-1" style="border-radius:14px;overflow:hidden;">
                    <div class="p-1">
                        <div style="display:grid;grid-template-columns:repeat(3,1fr);gap:6px;">
                            <div class="stat-card" style="background:#f4f7ff;">
                                <div class="stat-value" style="color:#1a418c;">{{ tg_summary.total_units }}</div>
                                <div class="stat-label mal-text">ആകെ യൂണിറ്റ്</div>
                            </div>
                            <div class="stat-card" style="background:#f0fff6;">
                                <div class="stat-value" style="color:#1DCC70;">{{ tg_summary.given_count }}</div>
                                <div class="stat-label mal-text">ടാർഗറ്റ് കൊടുത്തത്</div>
                            </div>
                            <div class="stat-card" style="background:#fff5f5;">
                                <div class="stat-value" style="color:#e74c3c;">{{ tg_summary.not_given_count }}</div>
                                <div class="stat-label mal-text">കൊടുക്കാത്തത്</div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Sub-tabs -->
                <div style="display:flex;gap:6px;margin-bottom:8px;">
                    <button type="button"
                        :style="{flex:1,padding:'8px',borderRadius:'10px',border:'none',fontWeight:'700',fontSize:'12px',
                            background: tg_tab==='not_given' ? '#e74c3c' : '#f0f0f0',
                            color: tg_tab==='not_given' ? '#fff' : '#666'}"
                        @click="tg_tab='not_given'" class="mal-text">
                        കൊടുക്കാത്തത് ({{ filteredTargetNotGiven.length }})
                    </button>
                    <button type="button"
                        :style="{flex:1,padding:'8px',borderRadius:'10px',border:'none',fontWeight:'700',fontSize:'12px',
                            background: tg_tab==='given' ? '#1DCC70' : '#f0f0f0',
                            color: tg_tab==='given' ? '#fff' : '#666'}"
                        @click="tg_tab='given'" class="mal-text">
                        കൊടുത്തത് ({{ filteredTargetGiven.length }})
                    </button>
                </div>

                <!-- Not given grouped (district → zone → unit) when no zone filter -->
                <div v-if="tg_tab === 'not_given'">
                    <div v-if="!not_given.length" class="text-center text-muted py-3 mal-text" style="font-size:13px;">
                        എല്ലാ യൂണിറ്റുകൾക്കും ടാർഗറ്റ് കൊടുത്തിട്ടുണ്ട്
                    </div>
                    <template v-else-if="user_level <= 2 && !tg_zone_id">
                        <template v-for="dg in targetNotGivenByDistrict" :key="'dtng_' + dg.district_id">
                            <div v-if="user_level === 1"
                                style="padding:8px 4px 4px;font-size:12px;font-weight:800;color:#e74c3c;letter-spacing:0.5px;text-transform:uppercase;border-bottom:2px solid #fde8e8;margin-bottom:6px;margin-top:10px;">
                                {{ dg.district_name }} ({{ dg.zones.length }})
                            </div>
                            <div v-for="zg in dg.zones" :key="'ztng_' + zg.zone_name" class="mb-2">
                                <div :style="{background:'#fff',border:'1px solid #e0e0e0',borderRadius: collapsedTargetZones['tng_' + zg.zone_name] ? '10px' : '10px 10px 0 0',padding:'10px 14px',cursor:'pointer'}"
                                    @click="toggleTargetZone('tng_' + zg.zone_name)">
                                    <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">
                                        <span style="font-size:13px;font-weight:700;color:#27173E;flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{ zg.zone_name }}</span>
                                        <div style="display:flex;align-items:center;gap:6px;flex-shrink:0;">
                                            <span style="font-size:10px;background:#fee;color:#e74c3c;padding:2px 8px;border-radius:8px;font-weight:700;border:1px solid #fdc5c5;white-space:nowrap;" class="mal-text">
                                                {{ zg.units.length }} കൊടുക്കാത്തത്
                                            </span>
                                            <ion-icon :name="collapsedTargetZones['tng_' + zg.zone_name] ? 'chevron-forward-outline' : 'chevron-down-outline'" style="font-size:15px;color:#aaa;flex-shrink:0;"></ion-icon>
                                        </div>
                                    </div>
                                </div>
                                <div v-show="!collapsedTargetZones['tng_' + zg.zone_name]" style="border:1px solid #e0e0e0;border-top:none;border-radius:0 0 10px 10px;overflow:hidden;padding:6px 8px;background:#fafafa;">
                                    <div v-for="(u, idx) in zg.units" :key="u.id" :class="{ 'no-youth-row': u.no_youth }"
                                        style="display:flex;align-items:center;gap:8px;background:#fff;border-radius:8px;padding:8px 10px;margin-bottom:5px;border:1px solid #fde8e8;border-left:3px solid #e74c3c;">
                                        <span style="color:#ddd;font-size:11px;width:16px;flex-shrink:0;text-align:right;">{{ idx + 1 }}</span>
                                        <div style="flex:1;min-width:0;">
                                            <div style="font-size:12px;font-weight:700;color:#27173E;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ u.name }}</div>
                                            <span v-if="u.no_youth" style="display:inline-block;margin-top:2px;font-size:9px;background:#fff3e0;color:#e67e22;padding:1px 6px;border-radius:6px;font-weight:700;">No Youth</span>
                                        </div>
                                        <span style="font-size:10px;background:#fee;color:#e74c3c;padding:3px 8px;border-radius:8px;font-weight:700;flex-shrink:0;border:1px solid #fdc5c5;" class="mal-text">ടാർഗറ്റ് ഇല്ല</span>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </template>
                    <!-- Flat list when zone selected or level 3 -->
                    <template v-else>
                        <div v-for="(u, idx) in filteredTargetNotGiven" :key="u.id" :class="{ 'no-youth-row': u.no_youth }"
                            class="card mb-1" style="border-radius:10px;padding:10px 12px;display:flex;flex-direction:row;align-items:center;gap:10px;">
                            <span style="color:#ddd;font-size:12px;width:20px;flex-shrink:0;text-align:right;">{{ idx + 1 }}</span>
                            <div style="flex:1;min-width:0;">
                                <div style="font-size:13px;font-weight:700;color:#e74c3c;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ u.name }}</div>
                                <div style="font-size:10px;color:#aaa;margin-top:2px;">{{ u.zone_name }}
                                    <span v-if="u.no_youth" style="display:inline-block;margin-left:4px;font-size:9px;background:#fff3e0;color:#e67e22;padding:1px 6px;border-radius:6px;font-weight:700;">No Youth</span>
                                </div>
                            </div>
                            <span style="font-size:10px;background:#fee;color:#e74c3c;padding:3px 8px;border-radius:10px;font-weight:700;flex-shrink:0;">ടാർഗറ്റ് ഇല്ല</span>
                        </div>
                    </template>
                </div>

                <!-- Given grouped (district → zone → unit) when no zone filter -->
                <div v-else>
                    <div v-if="!given.length" class="text-center text-muted py-3 mal-text" style="font-size:13px;">
                        ആർക്കും ടാർഗറ്റ് കൊടുത്തിട്ടില്ല
                    </div>
                    <template v-else-if="user_level <= 2 && !tg_zone_id">
                        <template v-for="dg in targetGivenByDistrict" :key="'dtg_' + dg.district_id">
                            <div v-if="user_level === 1"
                                style="padding:8px 4px 4px;font-size:12px;font-weight:800;color:#1a418c;letter-spacing:0.5px;text-transform:uppercase;border-bottom:2px solid #e8eef8;margin-bottom:6px;margin-top:10px;">
                                {{ dg.district_name }} ({{ dg.zones.length }})
                            </div>
                            <div v-for="zg in dg.zones" :key="'ztg_' + zg.zone_name" class="mb-2">
                                <div :style="{background:'#fff',border:'1px solid #e0e0e0',borderRadius: collapsedTargetZones['tg_' + zg.zone_name] ? '10px' : '10px 10px 0 0',padding:'10px 14px',cursor:'pointer'}"
                                    @click="toggleTargetZone('tg_' + zg.zone_name)">
                                    <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">
                                        <span style="font-size:13px;font-weight:700;color:#27173E;flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{ zg.zone_name }}</span>
                                        <div style="display:flex;align-items:center;gap:6px;flex-shrink:0;">
                                            <span style="font-size:10px;background:#f0fff6;color:#1DCC70;padding:2px 8px;border-radius:8px;font-weight:700;border:1px solid #b7f5d0;white-space:nowrap;">
                                                {{ zg.units.length }} യൂണിറ്റ്
                                            </span>
                                            <ion-icon :name="collapsedTargetZones['tg_' + zg.zone_name] ? 'chevron-forward-outline' : 'chevron-down-outline'" style="font-size:15px;color:#aaa;flex-shrink:0;"></ion-icon>
                                        </div>
                                    </div>
                                </div>
                                <div v-show="!collapsedTargetZones['tg_' + zg.zone_name]" style="border:1px solid #e0e0e0;border-top:none;border-radius:0 0 10px 10px;overflow:hidden;padding:6px 8px;background:#fafafa;">
                                    <div v-for="(u, idx) in zg.units" :key="u.id" :class="{ 'no-youth-row': u.no_youth }"
                                        style="display:flex;align-items:center;gap:8px;background:#fff;border-radius:8px;padding:8px 10px;margin-bottom:5px;border:1px solid #e8f5ee;border-left:3px solid #1DCC70;">
                                        <span style="color:#ddd;font-size:11px;width:16px;flex-shrink:0;text-align:right;">{{ idx + 1 }}</span>
                                        <div style="flex:1;min-width:0;">
                                            <div style="font-size:12px;font-weight:700;color:#27173E;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ u.name }}</div>
                                            <span v-if="u.no_youth" style="display:inline-block;margin-top:2px;font-size:9px;background:#fff3e0;color:#e67e22;padding:1px 6px;border-radius:6px;font-weight:700;">No Youth</span>
                                        </div>
                                        <span style="font-size:15px;font-weight:900;color:#1a418c;flex-shrink:0;">₹{{ u.target }}</span>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </template>
                    <!-- Flat list when zone selected or level 3 -->
                    <template v-else>
                        <div v-for="(u, idx) in filteredTargetGiven" :key="u.id" :class="{ 'no-youth-row': u.no_youth }"
                            class="card mb-1" style="border-radius:10px;padding:10px 12px;display:flex;flex-direction:row;align-items:center;gap:10px;">
                            <span style="color:#ddd;font-size:12px;width:20px;flex-shrink:0;text-align:right;">{{ idx + 1 }}</span>
                            <div style="flex:1;min-width:0;">
                                <div style="font-size:13px;font-weight:700;color:#27173E;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ u.name }}</div>
                                <div style="font-size:10px;color:#aaa;margin-top:2px;">{{ u.zone_name }}
                                    <span v-if="u.no_youth" style="display:inline-block;margin-left:4px;font-size:9px;background:#fff3e0;color:#e67e22;padding:1px 6px;border-radius:6px;font-weight:700;">No Youth</span>
                                </div>
                            </div>
                            <div style="font-size:15px;font-weight:800;color:#1a418c;flex-shrink:0;">₹{{ u.target }}</div>
                        </div>
                    </template>
                </div>
            </template>
        </template>

        <!-- ══════════════════════ MEMBERS REPORT (Youth Wing) ══════════════════════ -->
        <template v-else-if="page === 'members'">

            <!-- Filters -->
            <div class="card p-1 mb-1" style="border-radius:12px;margin-top:0!important;">
                <div style="display:flex;gap:8px;align-items:center;">
                    <select v-if="user_level === 1" v-model="mr_district_id"
                        class="form-select form-select-sm" style="flex:1;"
                        @change="onMembersDistrictChange">
                        <option value="">All Districts</option>
                        <option v-for="d in districts" :key="d.id" :value="d.id">{{ d.name }}</option>
                    </select>
                    <select v-if="user_level <= 2" v-model="mr_zone_id"
                        class="form-select form-select-sm" style="flex:1;"
                        @change="onMembersZoneChange">
                        <option value="">All Zones</option>
                        <option v-for="z in mr_zones" :key="z.id" :value="z.id">{{ z.name }}</option>
                    </select>
                    <select v-if="user_level >= 2 && !(mr_category === 'executives' && mr_exec_level < 4)" v-model="mr_unit_id" class="form-select form-select-sm" style="flex:1;">
                        <option value="">All Units</option>
                        <option v-for="u in mr_unit_options" :key="u.id" :value="u.id">{{ u.name }}</option>
                    </select>
                    <button type="button" class="btn btn-primary btn-sm" @click="loadMembersReport" style="padding:6px 14px;flex-shrink:0;">
                        <span v-show="mr_loading" class="spinner-border spinner-border-sm"></span>
                        <ion-icon v-show="!mr_loading" name="search-outline"></ion-icon>
                    </button>
                </div>
            </div>
            <!-- Shows which district/zone/unit the results below are filtered to, so a
                 screenshot of just the list (filter card scrolled off) is still self-explanatory. -->
            <div v-if="mrFilterHeading" class="mal-text" style="text-align:center;font-size:17px;font-weight:800;color:#1a418c;margin:6px 0 8px;">
                {{ mrFilterHeading }}
            </div>
            <div v-if="noYouthOnly || noYouthUnitsList.length" class="mal-text"
                :style="{textAlign:'center',fontSize:'12px',fontWeight:'700',cursor:'pointer',borderRadius:'8px',padding:'6px 10px',margin:'0 0 8px',
                    color: noYouthOnly ? '#fff' : '#e67e22', background: noYouthOnly ? '#e67e22' : '#fff3e0', border:'1px solid #fde0b3'}"
                @click="noYouthOnly = !noYouthOnly">
                {{ noYouthOnly ? 'Showing No Youth Units only ✕' : 'No Youth Units: ' + noYouthUnitsList.length + ' ▸' }}
            </div>

            <div v-if="mr_loading" class="text-center py-4">
                <div class="spinner-border text-primary"></div>
            </div>

            <div v-else-if="!mr_loaded" class="text-center py-5" style="color:#aaa;">
                <ion-icon name="people-outline" style="font-size:36px;margin-bottom:8px;display:block;"></ion-icon>
                <div class="mal-text" style="font-size:13px;">സെർച്ച് ബട്ടൺ അമർത്തുക</div>
            </div>

            <template v-else-if="mr_summary">
                <!-- Summary -->
                <div class="card mb-1" style="border-radius:14px;overflow:hidden;">
                    <div class="p-1">
                        <div style="display:grid;grid-template-columns:repeat(3,1fr);gap:6px;">
                            <div class="stat-card" style="background:#f4f7ff;">
                                <div class="stat-value" style="color:#1a418c;">{{ mr_summary.total_members }}</div>
                                <div class="stat-label mal-text">{{ mrTotalLabel }}</div>
                            </div>
                            <div class="stat-card" style="background:#f0fff6;">
                                <div class="stat-value" style="color:#1DCC70;">{{ mr_summary.collected_count }}</div>
                                <div class="stat-label mal-text">കൊടുത്തത്</div>
                            </div>
                            <div class="stat-card" style="background:#fff5f5;">
                                <div class="stat-value" style="color:#e74c3c;">{{ mr_summary.not_collected_count }}</div>
                                <div class="stat-label mal-text">കൊടുക്കാത്തത്</div>
                            </div>
                        </div>
                        <button v-if="mr_category === 'members'" type="button" :disabled="mr_exporting"
                            @click="exportNotCollectedMembers"
                            style="width:100%;margin-top:8px;padding:8px;border:none;border-radius:10px;background:#1a418c;color:#fff;font-weight:700;font-size:12px;display:flex;align-items:center;justify-content:center;gap:6px;">
                            <span v-if="mr_exporting" class="spinner-border spinner-border-sm"></span>
                            <ion-icon v-else name="download-outline"></ion-icon>
                            <span class="mal-text">കൊടുക്കാത്തവരുടെ ലിസ്റ്റ് Excel ആയി എടുക്കുക</span>
                        </button>
                    </div>
                </div>

                <!-- Executive category / level / sub-category selectors, grouped in one card -->
                <div class="card p-2 mb-1" style="border-radius:14px;display:flex;flex-direction:column;gap:8px;">
                    <!-- Members / Executives category toggle -->
                    <div style="display:flex;gap:6px;">
                        <button type="button"
                            :style="{flex:1,padding:'8px',borderRadius:'10px',border:'none',fontWeight:'700',fontSize:'12px',
                                background: mr_category==='members' ? '#1a418c' : '#f0f0f0',
                                color: mr_category==='members' ? '#fff' : '#666'}"
                            @click="mr_category='members'; loadMembersReport()" class="mal-text">
                            മെമ്പർമാർ
                        </button>
                        <button type="button"
                            :style="{flex:1,padding:'8px',borderRadius:'10px',border:'none',fontWeight:'700',fontSize:'12px',
                                background: mr_category==='executives' ? '#1a418c' : '#f0f0f0',
                                color: mr_category==='executives' ? '#fff' : '#666'}"
                            @click="mr_category='executives'; loadMembersReport()" class="mal-text">
                            എക്സിക്യൂട്ടീവ്സ്
                        </button>
                    </div>

                    <!-- Wing filter — Members category only. "എല്ലാം" covers Org + Youth + Lajna,
                         the same three wings the karad list's കാണേണ്ടത് headline counts, so the
                         total here reconciles with that figure. -->
                    <div v-if="mr_category === 'members'" style="display:flex;gap:4px;">
                        <button v-for="w in mr_wing_options" :key="'wing_' + w.v" type="button"
                            :style="{flex:1,padding:'6px 4px',borderRadius:'8px',border:'none',fontWeight:'700',fontSize:'11px',
                                background: mr_wing === w.v ? '#1DCC70' : '#f0f0f0',
                                color: mr_wing === w.v ? '#fff' : '#666'}"
                            @click="mr_wing = w.v; loadMembersReport()" class="mal-text">
                            {{ w.l }}
                        </button>
                    </div>

                    <!-- Exec level filter — Executives category only, state/district admins only -->
                    <div v-if="mr_category === 'executives' && user_level <= 2" style="display:flex;gap:4px;">
                        <button v-for="lvl in [{v:4,l:'Unit'},{v:3,l:'Zone'},{v:2,l:'District'},{v:1,l:'State'}]" :key="'exl_'+lvl.v"
                            type="button"
                            :style="{flex:1,padding:'6px 4px',borderRadius:'8px',border:'none',fontWeight:'700',fontSize:'11px',
                                background: mr_exec_level===lvl.v ? '#1DCC70' : '#f0f0f0',
                                color: mr_exec_level===lvl.v ? '#fff' : '#666'}"
                            @click="mr_exec_level = lvl.v; loadMembersReport()">
                            {{ lvl.l }} Level
                        </button>
                    </div>

                    <!-- Exec sub-category filter — Secretariat / Executive Members / Councilors -->
                    <div v-if="mr_category === 'executives'" style="display:flex;gap:4px;">
                        <button v-for="sc in [{v:null,l:'എല്ലാം'},{v:'secretariat',l:'സെക്രട്ടേറിയറ്റ്'},{v:'executive',l:'എക്സിക്യൂട്ടീവ് അംഗങ്ങൾ'},{v:'councilor',l:'കൗൺസിലർമാർ'}]" :key="'exsc_'+sc.v"
                            type="button"
                            :style="{flex:1,padding:'6px 2px',borderRadius:'8px',border:'none',fontWeight:'700',fontSize:'9.5px',lineHeight:'1.2',
                                background: mr_exec_subcategory===sc.v ? '#e67e22' : '#f0f0f0',
                                color: mr_exec_subcategory===sc.v ? '#fff' : '#666'}"
                            @click="mr_exec_subcategory = sc.v; loadMembersReport()" class="mal-text">
                            {{ sc.l }}
                        </button>
                    </div>
                </div>

                <!-- MODE: units (district/zone overview — no unit selected) -->
                <div v-if="mr_mode === 'units'">
                    <div v-if="!mr_units.length" class="text-center text-muted py-3 mal-text" style="font-size:13px;">
                        യൂത്ത് വിംഗ് മെമ്പർമാർ ഇല്ല
                    </div>
                    <template v-else-if="user_level <= 2 && !mr_zone_id">
                        <template v-for="dg in membersUnitsByDistrict" :key="'dmr_' + dg.district_id">
                            <div v-if="user_level === 1"
                                style="padding:8px 4px 4px;font-size:12px;font-weight:800;color:#1a418c;letter-spacing:0.5px;text-transform:uppercase;border-bottom:2px solid #e8eef8;margin-bottom:6px;margin-top:10px;">
                                {{ dg.district_name }} ({{ dg.zones.length }})
                            </div>
                            <div v-for="zg in dg.zones" :key="'zmr_' + zg.zone_name" class="mb-2">
                                <div :style="{background:'#fff',border:'1px solid #e0e0e0',borderRadius: collapsedMembersZones['mr_' + zg.zone_name] ? '10px' : '10px 10px 0 0',padding:'10px 14px',cursor:'pointer'}"
                                    @click="toggleMembersZone('mr_' + zg.zone_name)">
                                    <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">
                                        <span style="font-size:13px;font-weight:700;color:#27173E;flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{ zg.zone_name }}</span>
                                        <div style="display:flex;align-items:center;gap:6px;flex-shrink:0;">
                                            <span style="font-size:10px;background:#f0fff6;color:#1DCC70;padding:2px 8px;border-radius:8px;font-weight:700;border:1px solid #b7f5d0;white-space:nowrap;">
                                                {{ zg.units.length }} യൂണിറ്റ്
                                            </span>
                                            <ion-icon :name="collapsedMembersZones['mr_' + zg.zone_name] ? 'chevron-forward-outline' : 'chevron-down-outline'" style="font-size:15px;color:#aaa;flex-shrink:0;"></ion-icon>
                                        </div>
                                    </div>
                                </div>
                                <div v-show="!collapsedMembersZones['mr_' + zg.zone_name]" style="border:1px solid #e0e0e0;border-top:none;border-radius:0 0 10px 10px;overflow:hidden;padding:6px 8px;background:#fafafa;">
                                    <div v-for="(u, idx) in zg.units" :key="u.id" :class="{ 'no-youth-row': u.no_youth }"
                                        style="display:flex;align-items:center;gap:8px;background:#fff;border-radius:8px;padding:8px 10px;margin-bottom:5px;border:1px solid #e8f5ee;border-left:3px solid #1DCC70;">
                                        <span style="color:#ddd;font-size:11px;width:16px;flex-shrink:0;text-align:right;">{{ idx + 1 }}</span>
                                        <div style="flex:1;min-width:0;">
                                            <div style="font-size:12px;font-weight:700;color:#27173E;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ u.name }}</div>
                                            <span v-if="u.no_youth" style="display:inline-block;margin-top:2px;font-size:9px;background:#fff3e0;color:#e67e22;padding:1px 6px;border-radius:6px;font-weight:700;">No Youth</span>
                                        </div>
                                        <div style="display:flex;flex-direction:column;align-items:flex-end;gap:4px;flex-shrink:0;">
                                            <span style="font-size:18px;font-weight:900;color:#1a418c;line-height:1;">{{ u.total }}</span>
                                            <div style="display:flex;gap:4px;">
                                                <span style="font-size:11px;font-weight:700;background:#f0fff6;color:#1DCC70;padding:2px 7px;border-radius:6px;border:1px solid #b7f5d0;">{{ u.collected }}</span>
                                                <span style="font-size:11px;font-weight:700;background:#fee;color:#e74c3c;padding:2px 7px;border-radius:6px;border:1px solid #fdc5c5;">{{ u.not_collected }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </template>
                    <!-- Flat list when zone selected or level 3 -->
                    <template v-else>
                        <div v-for="(u, idx) in filteredMrUnits" :key="u.id" :class="{ 'no-youth-row': u.no_youth }"
                            class="card mb-1" style="border-radius:10px;padding:10px 12px;display:flex;flex-direction:row;align-items:center;gap:10px;">
                            <span style="color:#ddd;font-size:12px;width:20px;flex-shrink:0;text-align:right;">{{ idx + 1 }}</span>
                            <div style="flex:1;min-width:0;">
                                <div style="font-size:13px;font-weight:700;color:#27173E;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ u.name }}</div>
                                <div style="font-size:10px;color:#aaa;margin-top:2px;">{{ u.zone_name }}
                                    <span v-if="u.no_youth" style="display:inline-block;margin-left:4px;font-size:9px;background:#fff3e0;color:#e67e22;padding:1px 6px;border-radius:6px;font-weight:700;">No Youth</span>
                                </div>
                            </div>
                            <div style="text-align:right;flex-shrink:0;">
                                <div style="font-size:16px;font-weight:800;color:#1a418c;line-height:1;">{{ u.total }}</div>
                                <div style="font-size:10px;color:#aaa;margin-top:2px;">
                                    <span style="color:#1DCC70;">{{ u.collected }}</span>
                                    <span style="color:#ccc;"> / </span>
                                    <span style="color:#e74c3c;">{{ u.not_collected }}</span>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>

                <!-- MODE: members (a specific unit was selected) -->
                <div v-else>
                    <div style="display:flex;gap:6px;margin-bottom:8px;">
                        <button type="button"
                            :style="{flex:1,padding:'8px',borderRadius:'10px',border:'none',fontWeight:'700',fontSize:'12px',
                                background: mr_tab==='not_collected' ? '#e74c3c' : '#f0f0f0',
                                color: mr_tab==='not_collected' ? '#fff' : '#666'}"
                            @click="mr_tab='not_collected'" class="mal-text">
                            കൊടുക്കാത്തത് ({{ mr_not_collected.length }})
                        </button>
                        <button type="button"
                            :style="{flex:1,padding:'8px',borderRadius:'10px',border:'none',fontWeight:'700',fontSize:'12px',
                                background: mr_tab==='collected' ? '#1DCC70' : '#f0f0f0',
                                color: mr_tab==='collected' ? '#fff' : '#666'}"
                            @click="mr_tab='collected'" class="mal-text">
                            കൊടുത്തത് ({{ mr_collected.length }})
                        </button>
                    </div>

                    <div v-if="mr_tab === 'not_collected'">
                        <div v-if="!mr_not_collected.length" class="text-center text-muted py-3 mal-text" style="font-size:13px;">
                            എല്ലാവരും കൊടുത്തിട്ടുണ്ട്
                        </div>
                        <!-- Executives, no zone picked yet — grouped district → zone (like the other report tabs) -->
                        <template v-else-if="mr_category === 'executives' && user_level <= 2 && !mr_zone_id">
                            <template v-for="dg in execNotCollectedByDistrict" :key="'end_' + (dg.district_id || dg.district_name)">
                                <div v-if="user_level === 1"
                                    style="padding:8px 4px 4px;font-size:12px;font-weight:800;color:#e74c3c;letter-spacing:0.5px;text-transform:uppercase;border-bottom:2px solid #fde8e8;margin-bottom:6px;margin-top:10px;">
                                    {{ dg.district_name }} ({{ dg.zones.length }})
                                </div>
                                <!-- Zone/Unit level executives have real zone data — show a collapsible zone accordion -->
                                <template v-if="mr_exec_level >= 3">
                                    <div v-for="zg in dg.zones" :key="'enz_' + zg.zone_name" class="mb-2">
                                        <div :style="{background:'#fff',border:'1px solid #e0e0e0',borderRadius: collapsedMembersZones['exz_' + zg.zone_name] ? '10px' : '10px 10px 0 0',padding:'10px 14px',cursor:'pointer'}"
                                            @click="toggleMembersZone('exz_' + zg.zone_name)">
                                            <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">
                                                <span style="font-size:13px;font-weight:700;color:#27173E;flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{ zg.zone_name }}</span>
                                                <div style="display:flex;align-items:center;gap:6px;flex-shrink:0;">
                                                    <span style="font-size:10px;background:#fee;color:#e74c3c;padding:2px 8px;border-radius:8px;font-weight:700;border:1px solid #fdc5c5;white-space:nowrap;" class="mal-text">
                                                        {{ zg.units.length }} കൊടുക്കാത്തത്
                                                    </span>
                                                    <ion-icon :name="collapsedMembersZones['exz_' + zg.zone_name] ? 'chevron-forward-outline' : 'chevron-down-outline'" style="font-size:15px;color:#aaa;flex-shrink:0;"></ion-icon>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-show="!collapsedMembersZones['exz_' + zg.zone_name]" style="border:1px solid #e0e0e0;border-top:none;border-radius:0 0 10px 10px;overflow:hidden;padding:6px 8px;background:#fafafa;">
                                            <div v-for="(m, idx) in zg.units" :key="m.id"
                                                class="card mb-1" style="border-radius:10px;padding:10px 12px;display:flex;flex-direction:row;align-items:center;gap:10px;">
                                                <span style="color:#ddd;font-size:12px;width:20px;flex-shrink:0;text-align:right;">{{ idx + 1 }}</span>
                                                <div style="flex:1;min-width:0;">
                                                    <div style="font-size:13px;font-weight:700;color:#27173E;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ m.name }}</div>
                                                    <div style="font-size:10px;color:#aaa;margin-top:2px;">{{ m.mobile }}</div>
                                                    <div style="font-size:10px;color:#1a418c;margin-top:2px;">
                                                        {{ m.designation }}
                                                        <span v-if="m.unit_name"> · {{ m.unit_name }}</span>
                                                    </div>
                                                </div>
                                                <a v-if="m.mobile" :href="'tel:' + m.mobile" style="width:30px;height:30px;border-radius:50%;background:#eaf3ff;color:#1a418c;display:flex;align-items:center;justify-content:center;flex-shrink:0;">
                                                    <ion-icon name="call-outline" style="font-size:15px;"></ion-icon>
                                                </a>
                                                <span style="font-size:10px;background:#fee;color:#e74c3c;padding:3px 8px;border-radius:10px;font-weight:700;flex-shrink:0;">കൊടുത്തിട്ടില്ല</span>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <!-- State/District level executives have no real zone — flat cards under the district header -->
                                <template v-else>
                                    <div v-for="zg in dg.zones" :key="'end2_' + zg.zone_name">
                                        <div v-for="(m, idx) in zg.units" :key="m.id"
                                            class="card mb-1" style="border-radius:10px;padding:10px 12px;display:flex;flex-direction:row;align-items:center;gap:10px;">
                                            <span style="color:#ddd;font-size:12px;width:20px;flex-shrink:0;text-align:right;">{{ idx + 1 }}</span>
                                            <div style="flex:1;min-width:0;">
                                                <div style="font-size:13px;font-weight:700;color:#27173E;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ m.name }}</div>
                                                <div style="font-size:10px;color:#aaa;margin-top:2px;">{{ m.mobile }}</div>
                                                <div style="font-size:10px;color:#1a418c;margin-top:2px;">
                                                    {{ m.designation }}
                                                    <span v-if="m.district_name"> · {{ m.district_name }}</span>
                                                </div>
                                            </div>
                                            <a v-if="m.mobile" :href="'tel:' + m.mobile" style="width:30px;height:30px;border-radius:50%;background:#eaf3ff;color:#1a418c;display:flex;align-items:center;justify-content:center;flex-shrink:0;">
                                                <ion-icon name="call-outline" style="font-size:15px;"></ion-icon>
                                            </a>
                                            <span style="font-size:10px;background:#fee;color:#e74c3c;padding:3px 8px;border-radius:10px;font-weight:700;flex-shrink:0;">കൊടുത്തിട്ടില്ല</span>
                                        </div>
                                    </div>
                                </template>
                            </template>
                        </template>
                        <!-- Flat list: plain members, or executives with a zone already picked -->
                        <template v-else>
                            <div v-for="(m, idx) in mr_not_collected" :key="m.id"
                                class="card mb-1" style="border-radius:10px;padding:10px 12px;display:flex;flex-direction:row;align-items:center;gap:10px;">
                                <span style="color:#ddd;font-size:12px;width:20px;flex-shrink:0;text-align:right;">{{ idx + 1 }}</span>
                                <div style="flex:1;min-width:0;">
                                    <div style="font-size:13px;font-weight:700;color:#27173E;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ m.name }}</div>
                                    <div style="font-size:10px;color:#aaa;margin-top:2px;">{{ m.mobile }}</div>
                                    <div v-if="mr_category === 'executives'" style="font-size:10px;color:#1a418c;margin-top:2px;">
                                        {{ m.designation }}
                                        <span v-if="m.unit_name"> · {{ m.unit_name }}</span>
                                        <span v-else-if="m.zone_name"> · {{ m.zone_name }}</span>
                                        <span v-else-if="m.district_name"> · {{ m.district_name }}</span>
                                    </div>
                                </div>
                                <a v-if="m.mobile" :href="'tel:' + m.mobile" style="width:30px;height:30px;border-radius:50%;background:#eaf3ff;color:#1a418c;display:flex;align-items:center;justify-content:center;flex-shrink:0;">
                                    <ion-icon name="call-outline" style="font-size:15px;"></ion-icon>
                                </a>
                                <span style="font-size:10px;background:#fee;color:#e74c3c;padding:3px 8px;border-radius:10px;font-weight:700;flex-shrink:0;">കൊടുത്തിട്ടില്ല</span>
                            </div>
                        </template>
                    </div>
                    <div v-else>
                        <div v-if="!mr_collected.length" class="text-center text-muted py-3 mal-text" style="font-size:13px;">
                            ആരും കൊടുത്തിട്ടില്ല
                        </div>
                        <!-- Executives, no zone picked yet — grouped district → zone (like the other report tabs) -->
                        <template v-else-if="mr_category === 'executives' && user_level <= 2 && !mr_zone_id">
                            <template v-for="dg in execCollectedByDistrict" :key="'ecd_' + (dg.district_id || dg.district_name)">
                                <div v-if="user_level === 1"
                                    style="padding:8px 4px 4px;font-size:12px;font-weight:800;color:#1a418c;letter-spacing:0.5px;text-transform:uppercase;border-bottom:2px solid #e8eef8;margin-bottom:6px;margin-top:10px;">
                                    {{ dg.district_name }} ({{ dg.zones.length }})
                                </div>
                                <!-- Zone/Unit level executives have real zone data — show a collapsible zone accordion -->
                                <template v-if="mr_exec_level >= 3">
                                    <div v-for="zg in dg.zones" :key="'ecz_' + zg.zone_name" class="mb-2">
                                        <div :style="{background:'#fff',border:'1px solid #e0e0e0',borderRadius: collapsedMembersZones['exz_' + zg.zone_name] ? '10px' : '10px 10px 0 0',padding:'10px 14px',cursor:'pointer'}"
                                            @click="toggleMembersZone('exz_' + zg.zone_name)">
                                            <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">
                                                <span style="font-size:13px;font-weight:700;color:#27173E;flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{ zg.zone_name }}</span>
                                                <div style="display:flex;align-items:center;gap:6px;flex-shrink:0;">
                                                    <span style="font-size:10px;background:#f0fff6;color:#1DCC70;padding:2px 8px;border-radius:8px;font-weight:700;border:1px solid #b7f5d0;white-space:nowrap;" class="mal-text">
                                                        {{ zg.units.length }} കൊടുത്തത്
                                                    </span>
                                                    <ion-icon :name="collapsedMembersZones['exz_' + zg.zone_name] ? 'chevron-forward-outline' : 'chevron-down-outline'" style="font-size:15px;color:#aaa;flex-shrink:0;"></ion-icon>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-show="!collapsedMembersZones['exz_' + zg.zone_name]" style="border:1px solid #e0e0e0;border-top:none;border-radius:0 0 10px 10px;overflow:hidden;padding:6px 8px;background:#fafafa;">
                                            <div v-for="(m, idx) in zg.units" :key="m.id"
                                                class="card mb-1" style="border-radius:10px;padding:10px 12px;display:flex;flex-direction:row;align-items:center;gap:10px;">
                                                <span style="color:#ddd;font-size:12px;width:20px;flex-shrink:0;text-align:right;">{{ idx + 1 }}</span>
                                                <div style="flex:1;min-width:0;">
                                                    <div style="font-size:13px;font-weight:700;color:#27173E;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ m.name }}</div>
                                                    <div style="font-size:10px;color:#aaa;margin-top:2px;">{{ m.mobile }}</div>
                                                    <div style="font-size:10px;color:#1a418c;margin-top:2px;">
                                                        {{ m.designation }}
                                                        <span v-if="m.unit_name"> · {{ m.unit_name }}</span>
                                                    </div>
                                                </div>
                                                <a v-if="m.mobile" :href="'tel:' + m.mobile" style="width:30px;height:30px;border-radius:50%;background:#eaf3ff;color:#1a418c;display:flex;align-items:center;justify-content:center;flex-shrink:0;">
                                                    <ion-icon name="call-outline" style="font-size:15px;"></ion-icon>
                                                </a>
                                                <span style="font-size:10px;background:#f0fff6;color:#1DCC70;padding:3px 8px;border-radius:10px;font-weight:700;flex-shrink:0;">കൊടുത്തു</span>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <!-- State/District level executives have no real zone — flat cards under the district header -->
                                <template v-else>
                                    <div v-for="zg in dg.zones" :key="'ecd2_' + zg.zone_name">
                                        <div v-for="(m, idx) in zg.units" :key="m.id"
                                            class="card mb-1" style="border-radius:10px;padding:10px 12px;display:flex;flex-direction:row;align-items:center;gap:10px;">
                                            <span style="color:#ddd;font-size:12px;width:20px;flex-shrink:0;text-align:right;">{{ idx + 1 }}</span>
                                            <div style="flex:1;min-width:0;">
                                                <div style="font-size:13px;font-weight:700;color:#27173E;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ m.name }}</div>
                                                <div style="font-size:10px;color:#aaa;margin-top:2px;">{{ m.mobile }}</div>
                                                <div style="font-size:10px;color:#1a418c;margin-top:2px;">
                                                    {{ m.designation }}
                                                    <span v-if="m.district_name"> · {{ m.district_name }}</span>
                                                </div>
                                            </div>
                                            <a v-if="m.mobile" :href="'tel:' + m.mobile" style="width:30px;height:30px;border-radius:50%;background:#eaf3ff;color:#1a418c;display:flex;align-items:center;justify-content:center;flex-shrink:0;">
                                                <ion-icon name="call-outline" style="font-size:15px;"></ion-icon>
                                            </a>
                                            <span style="font-size:10px;background:#f0fff6;color:#1DCC70;padding:3px 8px;border-radius:10px;font-weight:700;flex-shrink:0;">കൊടുത്തു</span>
                                        </div>
                                    </div>
                                </template>
                            </template>
                        </template>
                        <!-- Flat list: plain members, or executives with a zone already picked -->
                        <template v-else>
                            <div v-for="(m, idx) in mr_collected" :key="m.id"
                                class="card mb-1" style="border-radius:10px;padding:10px 12px;display:flex;flex-direction:row;align-items:center;gap:10px;">
                                <span style="color:#ddd;font-size:12px;width:20px;flex-shrink:0;text-align:right;">{{ idx + 1 }}</span>
                                <div style="flex:1;min-width:0;">
                                    <div style="font-size:13px;font-weight:700;color:#27173E;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ m.name }}</div>
                                    <div style="font-size:10px;color:#aaa;margin-top:2px;">{{ m.mobile }}</div>
                                    <div v-if="mr_category === 'executives'" style="font-size:10px;color:#1a418c;margin-top:2px;">
                                        {{ m.designation }}
                                        <span v-if="m.unit_name"> · {{ m.unit_name }}</span>
                                        <span v-else-if="m.zone_name"> · {{ m.zone_name }}</span>
                                        <span v-else-if="m.district_name"> · {{ m.district_name }}</span>
                                    </div>
                                </div>
                                <a v-if="m.mobile" :href="'tel:' + m.mobile" style="width:30px;height:30px;border-radius:50%;background:#eaf3ff;color:#1a418c;display:flex;align-items:center;justify-content:center;flex-shrink:0;">
                                    <ion-icon name="call-outline" style="font-size:15px;"></ion-icon>
                                </a>
                                <span style="font-size:10px;background:#f0fff6;color:#1DCC70;padding:3px 8px;border-radius:10px;font-weight:700;flex-shrink:0;">കൊടുത്തു</span>
                            </div>
                        </template>
                    </div>
                </div>
            </template>
        </template>

        <!-- ══════════════════════ RECEIPT TAKE-BACK REPORT ══════════════════════ -->
        <template v-else-if="page === 'takeback'">

            <!-- Filters -->
            <div class="card p-1 mb-1" style="border-radius:12px;margin-top:0!important;">
                <div style="display:flex;gap:8px;align-items:center;">
                    <select v-if="user_level === 1" v-model="tb_district_id"
                        class="form-select form-select-sm" style="flex:1;"
                        @change="onTbDistrictChange">
                        <option value="">All Districts</option>
                        <option v-for="d in districts" :key="d.id" :value="d.id">{{ d.name }}</option>
                    </select>
                    <select v-if="user_level <= 2" v-model="tb_zone_id"
                        class="form-select form-select-sm" style="flex:1;"
                        @change="onTbZoneChange">
                        <option value="">All Zones</option>
                        <option v-for="z in tb_zones" :key="z.id" :value="z.id">{{ z.name }}</option>
                    </select>
                    <select v-if="user_level >= 2" v-model="tb_unit_id" class="form-select form-select-sm" style="flex:1;">
                        <option value="">All Units</option>
                        <option v-for="u in tb_unit_options" :key="u.id" :value="u.id">{{ u.name }}</option>
                    </select>
                    <button type="button" class="btn btn-primary btn-sm" @click="loadTakebackReport" style="padding:6px 14px;flex-shrink:0;">
                        <span v-show="tb_loading" class="spinner-border spinner-border-sm"></span>
                        <ion-icon v-show="!tb_loading" name="search-outline"></ion-icon>
                    </button>
                </div>
            </div>

            <div v-if="tb_loading" class="text-center py-4">
                <div class="spinner-border text-primary"></div>
            </div>

            <div v-else-if="!tb_loaded" class="text-center py-5" style="color:#aaa;">
                <ion-icon name="archive-outline" style="font-size:36px;margin-bottom:8px;display:block;"></ion-icon>
                <div class="mal-text" style="font-size:13px;">സെർച്ച് ബട്ടൺ അമർത്തുക</div>
            </div>

            <template v-else>
                <!-- Overall completion — % of units where all 3 criteria are done -->
                <div class="mb-1" :style="{borderRadius:'12px',padding:'10px 14px',
                        background: tbOverallCompletionPercent===100 ? '#f0fff6' : (tbOverallCompletionPercent===0 ? '#fff0f0' : '#fff8ed'),
                        border: '1.5px solid ' + (tbOverallCompletionPercent===100 ? '#1DCC70' : (tbOverallCompletionPercent===0 ? '#e74c3c' : '#f0a500'))}">
                    <div style="display:flex;align-items:center;justify-content:space-between;">
                        <span class="mal-text" style="font-size:12px;font-weight:700;color:#666;">മൊത്തം പൂർത്തീകരണം</span>
                        <span :style="{fontSize:'18px',fontWeight:'900',color: tbOverallCompletionPercent===100 ? '#1DCC70' : (tbOverallCompletionPercent===0 ? '#e74c3c' : '#f0a500')}">{{ tbOverallCompletionPercent }}%</span>
                    </div>
                    <div style="background:#fff;border-radius:6px;height:6px;margin-top:6px;overflow:hidden;">
                        <div :style="{width: tbOverallCompletionPercent + '%', height:'100%', background: tbOverallCompletionPercent===100 ? '#1DCC70' : (tbOverallCompletionPercent===0 ? '#e74c3c' : '#f0a500')}"></div>
                    </div>
                </div>

                <!-- Summary cards — always unit-level ground truth, each clickable to jump there -->
                <div style="display:grid;grid-template-columns:repeat(2,1fr);gap:6px;margin-bottom:5px;">
                    <div class="stat-card" style="background:#f4f7ff;cursor:pointer;" @click="tb_level='unit'; tb_status_filter='all'">
                        <div class="stat-value" style="color:#1a418c;">{{ tbUnitStatsList.length }}</div>
                        <div class="stat-label mal-text">ആകെ യൂണിറ്റ്</div>
                    </div>
                    <div class="stat-card" style="background:#f4f7ff;">
                        <div class="stat-value" style="color:#1a418c;">{{ tbTotalBooksCount }}</div>
                        <div class="stat-label mal-text">ആകെ റസീപ്റ്റ്</div>
                    </div>
                    <div class="stat-card" style="background:#f0fff6;cursor:pointer;" @click="tb_level='unit'; tb_status_filter='books_done'">
                        <div class="stat-value" style="color:#1DCC70;">{{ tbBooksDoneCount }}</div>
                        <div class="stat-label mal-text">ബുക്ക് തിരിച്ചേൽപ്പിച്ചത്</div>
                    </div>
                    <div class="stat-card" style="background:#f0fff6;cursor:pointer;" @click="tb_level='unit'; tb_status_filter='inspection_done'">
                        <div class="stat-value" style="color:#1DCC70;">{{ tbInspectionDoneCount }}</div>
                        <div class="stat-label mal-text">ഇൻസ്പെക്ഷൻ പൂർത്തിയായത്</div>
                    </div>
                    <div class="stat-card" style="background:#f0fff6;cursor:pointer;grid-column:span 2;" @click="tb_level='unit'; tb_status_filter='share_accepted'">
                        <div class="stat-value" style="color:#1DCC70;">{{ tbShareAcceptedCount }}</div>
                        <div class="stat-label mal-text">വിഹിതം സ്വീകരിച്ചത്</div>
                    </div>
                </div>

                <!-- Level selector: District / Zone / Unit — a zone's own row shows how many of
                     its units have handed the book back, a district's row rolls that up further,
                     since book+cash flows Unit → Zone → District → State. -->
                <div class="filter-card" style="margin-bottom:8px;">
                    <div class="pending-tabs" :style="{gridTemplateColumns: 'repeat(' + (user_level === 1 && !tb_district_id ? 3 : (user_level <= 2 && !tb_zone_id ? 2 : 1)) + ',1fr)'}">
                        <button v-if="user_level === 1 && !tb_district_id" type="button" class="pending-tab mal-text"
                            :class="{ active: tb_level === 'district' }"
                            @click="setTbLevel('district')">
                            ജില്ല ({{ tb_districts_list.length }})
                        </button>
                        <button v-if="user_level <= 2 && !tb_zone_id" type="button" class="pending-tab mal-text"
                            :class="{ active: tb_level === 'zone' }"
                            @click="setTbLevel('zone')">
                            മണ്ഡലം ({{ tb_zones_list.length }})
                        </button>
                        <button type="button" class="pending-tab mal-text"
                            :class="{ active: tb_level === 'unit' }"
                            @click="setTbLevel('unit')">
                            യൂണിറ്റ് ({{ tb_list.length }})
                        </button>
                    </div>
                </div>

                <!-- Sub-tabs -->
                <div style="display:flex;gap:4px;margin-bottom:8px;">
                    <button type="button"
                        :style="{flex:1,padding:'6px 2px',borderRadius:'8px',border:'none',fontWeight:'700',fontSize:'10.5px',
                            background: tb_status_filter==='all' ? '#1a418c' : '#f0f0f0',
                            color: tb_status_filter==='all' ? '#fff' : '#666'}"
                        @click="tb_status_filter='all'" class="mal-text">
                        എല്ലാം
                    </button>
                    <button type="button"
                        :style="{flex:1,padding:'6px 2px',borderRadius:'8px',border:'none',fontWeight:'700',fontSize:'10.5px',
                            background: tb_status_filter==='complete' ? '#1DCC70' : '#f0f0f0',
                            color: tb_status_filter==='complete' ? '#fff' : '#666'}"
                        @click="tb_status_filter='complete'" class="mal-text">
                        പൂർത്തിയായത്
                    </button>
                    <button type="button"
                        :style="{flex:1,padding:'6px 2px',borderRadius:'8px',border:'none',fontWeight:'700',fontSize:'10.5px',
                            background: tb_status_filter==='incomplete' ? '#e74c3c' : '#f0f0f0',
                            color: tb_status_filter==='incomplete' ? '#fff' : '#666'}"
                        @click="tb_status_filter='incomplete'" class="mal-text">
                        പൂർത്തിയാകാത്തത്
                    </button>
                </div>

                <!-- Active card-filter chip — shown only when a stat-card shortcut is applied -->
                <div v-if="tbCardFilterLabel" class="mal-text"
                    style="text-align:center;font-size:11px;font-weight:700;cursor:pointer;border-radius:8px;padding:5px 10px;margin:0 0 8px;color:#fff;background:#1a418c;"
                    @click="tb_status_filter='all'">
                    {{ tbCardFilterLabel }} ✕
                </div>

                <div v-if="!tbFilteredList.length" class="text-center text-muted py-3 mal-text" style="font-size:13px;">
                    ഡേറ്റ ഇല്ല
                </div>

                <!-- ═══ UNIT level ═══ -->
                <template v-else-if="tb_level === 'unit'">
                    <!-- Grouped view (district → zone) when no zone filter -->
                    <template v-if="user_level <= 2 && !tb_zone_id">
                        <template v-for="dg in tbByDistrict" :key="'tbd_' + dg.district_id">
                            <div v-if="user_level === 1 && !tb_district_id"
                                style="padding:8px 4px 4px;font-size:12px;font-weight:800;color:#1a418c;letter-spacing:0.5px;text-transform:uppercase;border-bottom:2px solid #e8eef8;margin-bottom:6px;margin-top:10px;">
                                {{ dg.district_name }} ({{ dg.zones.length }})
                            </div>
                            <div v-for="zg in dg.zones" :key="'tbz_' + zg.zone_name" class="mb-2">
                                <div :style="{background:'#fff',border:'1px solid #e0e0e0',borderRadius: collapsedTbZones[zg.zone_name] ? '10px' : '10px 10px 0 0',padding:'10px 14px',cursor:'pointer'}"
                                    @click="toggleTbZone(zg.zone_name)">
                                    <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">
                                        <span style="font-size:13px;font-weight:700;color:#27173E;flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{ zg.zone_name }}</span>
                                        <div style="display:flex;align-items:center;gap:6px;flex-shrink:0;">
                                            <span style="font-size:10px;background:#eef0f5;color:#64748b;padding:2px 8px;border-radius:8px;font-weight:700;white-space:nowrap;">
                                                {{ zg.units.length }} യൂണിറ്റ്
                                            </span>
                                            <ion-icon :name="collapsedTbZones[zg.zone_name] ? 'chevron-forward-outline' : 'chevron-down-outline'" style="font-size:15px;color:#aaa;flex-shrink:0;"></ion-icon>
                                        </div>
                                    </div>
                                </div>
                                <div v-show="!collapsedTbZones[zg.zone_name]" style="border:1px solid #e0e0e0;border-top:none;border-radius:0 0 10px 10px;overflow:hidden;padding:8px;background:#fafafa;">
                                    <div v-for="u in zg.units" :key="u.id" class="card mb-1" style="border-radius:10px;padding:10px 12px;">
                                        <div style="font-size:13px;font-weight:700;color:#27173E;">{{ u.name }}</div>
                                        <div style="display:flex;flex-direction:column;gap:6px;margin-top:8px;">
                                            <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">
                                                <span style="font-size:11px;color:#666;" class="mal-text">ബുക്ക് തിരിച്ചേൽപ്പിക്കൽ</span>
                                                <span :style="tbBookBadgeStyle(u)">{{ u.books_taken_back }}/{{ u.books_total }}</span>
                                            </div>
                                            <div v-if="u.taken_back_by_name" style="font-size:10px;color:#aaa;margin-top:-3px;">{{ u.taken_back_by_name }} · {{ u.taken_back_at }}</div>

                                            <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">
                                                <span style="font-size:11px;color:#666;" class="mal-text">അക്കൗണ്ട്സ് ഇൻസ്പെക്ഷൻ</span>
                                                <span :style="tbBadgeStyle(u.inspection_done ? 'accepted' : 'not_marked')" class="mal-text">{{ u.inspection_done ? 'പൂർത്തിയായി' : 'ചെയ്തിട്ടില്ല' }}</span>
                                            </div>
                                            <div v-if="u.inspected_by_name" style="font-size:10px;color:#aaa;margin-top:-3px;">{{ u.inspected_by_name }} · {{ u.inspected_at }}</div>

                                            <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">
                                                <span style="font-size:11px;color:#666;" class="mal-text">വിഹിതം കൈപ്പറ്റൽ</span>
                                                <span :style="tbBadgeStyle(u.share_taken_status)" class="mal-text">{{ tbStatusLabel(u.share_taken_status) }}</span>
                                            </div>
                                            <div v-if="u.share_taken_by_name" style="font-size:10px;color:#aaa;margin-top:-3px;">{{ u.share_taken_by_name }} · {{ u.share_taken_at }}</div>
                                            <div v-if="u.share_taken_reviewed_by_name" style="font-size:10px;color:#aaa;margin-top:-3px;">Reviewed: {{ u.share_taken_reviewed_by_name }} · {{ u.share_taken_reviewed_at }}</div>

                                            <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">
                                                <span style="font-size:11px;color:#666;" class="mal-text">ഫണ്ട് ഷെയർ റിക്വസ്റ്റ്</span>
                                                <span :style="tbBadgeStyle(u.share_request_status || 'none')" class="mal-text">{{ u.share_request_status ? tbStatusLabel(u.share_request_status) : 'ഇല്ല' }}</span>
                                            </div>
                                            <div v-if="u.share_request_status" style="font-size:10px;color:#aaa;margin-top:-3px;">₹{{ u.share_request_amount }} · {{ u.share_request_created_at }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </template>

                    <!-- Flat list when zone selected or level 3 -->
                    <template v-else>
                        <div v-for="u in tbFilteredList" :key="u.id" class="card mb-1" style="border-radius:10px;padding:10px 12px;">
                            <div style="font-size:13px;font-weight:700;color:#27173E;">{{ u.name }}</div>
                            <div style="font-size:10px;color:#aaa;margin-top:2px;">{{ u.zone_name }}</div>
                            <div style="display:flex;flex-direction:column;gap:6px;margin-top:8px;">
                                <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">
                                    <span style="font-size:11px;color:#666;" class="mal-text">ബുക്ക് തിരിച്ചേൽപ്പിക്കൽ</span>
                                    <span :style="tbBookBadgeStyle(u)">{{ u.books_taken_back }}/{{ u.books_total }}</span>
                                </div>
                                <div v-if="u.taken_back_by_name" style="font-size:10px;color:#aaa;margin-top:-3px;">{{ u.taken_back_by_name }} · {{ u.taken_back_at }}</div>

                                <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">
                                    <span style="font-size:11px;color:#666;" class="mal-text">അക്കൗണ്ട്സ് ഇൻസ്പെക്ഷൻ</span>
                                    <span :style="tbBadgeStyle(u.inspection_done ? 'accepted' : 'not_marked')" class="mal-text">{{ u.inspection_done ? 'പൂർത്തിയായി' : 'ചെയ്തിട്ടില്ല' }}</span>
                                </div>
                                <div v-if="u.inspected_by_name" style="font-size:10px;color:#aaa;margin-top:-3px;">{{ u.inspected_by_name }} · {{ u.inspected_at }}</div>

                                <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">
                                    <span style="font-size:11px;color:#666;" class="mal-text">വിഹിതം കൈപ്പറ്റൽ</span>
                                    <span :style="tbBadgeStyle(u.share_taken_status)" class="mal-text">{{ tbStatusLabel(u.share_taken_status) }}</span>
                                </div>
                                <div v-if="u.share_taken_by_name" style="font-size:10px;color:#aaa;margin-top:-3px;">{{ u.share_taken_by_name }} · {{ u.share_taken_at }}</div>
                                <div v-if="u.share_taken_reviewed_by_name" style="font-size:10px;color:#aaa;margin-top:-3px;">Reviewed: {{ u.share_taken_reviewed_by_name }} · {{ u.share_taken_reviewed_at }}</div>

                                <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">
                                    <span style="font-size:11px;color:#666;" class="mal-text">ഫണ്ട് ഷെയർ റിക്വസ്റ്റ്</span>
                                    <span :style="tbBadgeStyle(u.share_request_status || 'none')" class="mal-text">{{ u.share_request_status ? tbStatusLabel(u.share_request_status) : 'ഇല്ല' }}</span>
                                </div>
                                <div v-if="u.share_request_status" style="font-size:10px;color:#aaa;margin-top:-3px;">₹{{ u.share_request_amount }} · {{ u.share_request_created_at }}</div>
                            </div>
                        </div>
                    </template>
                </template>

                <!-- ═══ ZONE level ═══ -->
                <template v-else-if="tb_level === 'zone'">
                    <!-- Grouped by district when state admin viewing all districts -->
                    <template v-if="user_level === 1 && !tb_district_id">
                        <template v-for="dg in tbZonesByDistrict" :key="'tbzd_' + dg.district_id">
                            <div style="padding:8px 4px 4px;font-size:12px;font-weight:800;color:#1a418c;letter-spacing:0.5px;text-transform:uppercase;border-bottom:2px solid #e8eef8;margin-bottom:6px;margin-top:10px;">
                                {{ dg.district_name }} ({{ dg.zones.length }})
                            </div>
                            <div v-for="z in dg.zones" :key="z.id" class="card mb-1" style="border-radius:10px;padding:10px 12px;">
                                <div style="font-size:13px;font-weight:700;color:#27173E;">{{ z.name }}</div>
                                <div style="display:flex;flex-direction:column;gap:6px;margin-top:8px;">
                                    <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">
                                        <span style="font-size:11px;color:#666;" class="mal-text">ബുക്ക് ലഭിച്ചത് (യൂണിറ്റിൽ നിന്ന്)</span>
                                        <span :style="tbPercentBadgeStyle(z.books_percent)">{{ z.units_books_done }}/{{ z.units_total }} ({{ z.books_percent }}%)</span>
                                    </div>
                                    <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">
                                        <span style="font-size:11px;color:#666;" class="mal-text">ഇൻസ്പെക്ഷൻ പൂർത്തിയായത്</span>
                                        <span :style="tbPercentBadgeStyle(z.inspection_percent)">{{ z.units_inspection_done }}/{{ z.units_total }} ({{ z.inspection_percent }}%)</span>
                                    </div>
                                    <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">
                                        <span style="font-size:11px;color:#666;" class="mal-text">ആകെ പിരിച്ചത്</span>
                                        <span style="font-size:13px;font-weight:800;color:#1a418c;">₹{{ formatAmt(z.total_collected) }}</span>
                                    </div>
                                    <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">
                                        <span style="font-size:11px;color:#666;" class="mal-text">വിഹിതം കൈപ്പറ്റൽ (ജില്ലയിലേക്ക്)</span>
                                        <span :style="tbBadgeStyle(z.share_taken_status)" class="mal-text">{{ tbStatusLabel(z.share_taken_status) }}</span>
                                    </div>
                                    <div v-if="z.share_taken_by_name" style="font-size:10px;color:#aaa;margin-top:-3px;">{{ z.share_taken_by_name }} · {{ z.share_taken_at }}</div>
                                    <div v-if="z.share_taken_reviewed_by_name" style="font-size:10px;color:#aaa;margin-top:-3px;">Reviewed: {{ z.share_taken_reviewed_by_name }} · {{ z.share_taken_reviewed_at }}</div>
                                    <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">
                                        <span style="font-size:11px;color:#666;" class="mal-text">ഫണ്ട് ഷെയർ റിക്വസ്റ്റ്</span>
                                        <span :style="tbBadgeStyle(z.share_request_status || 'none')" class="mal-text">{{ z.share_request_status ? tbStatusLabel(z.share_request_status) : 'ഇല്ല' }}</span>
                                    </div>
                                    <div v-if="z.share_request_status" style="font-size:10px;color:#aaa;margin-top:-3px;">₹{{ z.share_request_amount }} · {{ z.share_request_created_at }}</div>
                                </div>
                            </div>
                        </template>
                    </template>

                    <!-- Flat list -->
                    <template v-else>
                        <div v-for="z in tbFilteredList" :key="z.id" class="card mb-1" style="border-radius:10px;padding:10px 12px;">
                            <div style="font-size:13px;font-weight:700;color:#27173E;">{{ z.name }}</div>
                            <div v-if="z.district_name" style="font-size:10px;color:#aaa;margin-top:2px;">{{ z.district_name }}</div>
                            <div style="display:flex;flex-direction:column;gap:6px;margin-top:8px;">
                                <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">
                                    <span style="font-size:11px;color:#666;" class="mal-text">ബുക്ക് ലഭിച്ചത് (യൂണിറ്റിൽ നിന്ന്)</span>
                                    <span :style="tbPercentBadgeStyle(z.books_percent)">{{ z.units_books_done }}/{{ z.units_total }} ({{ z.books_percent }}%)</span>
                                </div>
                                <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">
                                    <span style="font-size:11px;color:#666;" class="mal-text">ഇൻസ്പെക്ഷൻ പൂർത്തിയായത്</span>
                                    <span :style="tbPercentBadgeStyle(z.inspection_percent)">{{ z.units_inspection_done }}/{{ z.units_total }} ({{ z.inspection_percent }}%)</span>
                                </div>
                                <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">
                                    <span style="font-size:11px;color:#666;" class="mal-text">ആകെ പിരിച്ചത്</span>
                                    <span style="font-size:13px;font-weight:800;color:#1a418c;">₹{{ formatAmt(z.total_collected) }}</span>
                                </div>
                                <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">
                                    <span style="font-size:11px;color:#666;" class="mal-text">വിഹിതം കൈപ്പറ്റൽ (ജില്ലയിലേക്ക്)</span>
                                    <span :style="tbBadgeStyle(z.share_taken_status)" class="mal-text">{{ tbStatusLabel(z.share_taken_status) }}</span>
                                </div>
                                <div v-if="z.share_taken_by_name" style="font-size:10px;color:#aaa;margin-top:-3px;">{{ z.share_taken_by_name }} · {{ z.share_taken_at }}</div>
                                <div v-if="z.share_taken_reviewed_by_name" style="font-size:10px;color:#aaa;margin-top:-3px;">Reviewed: {{ z.share_taken_reviewed_by_name }} · {{ z.share_taken_reviewed_at }}</div>
                                <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">
                                    <span style="font-size:11px;color:#666;" class="mal-text">ഫണ്ട് ഷെയർ റിക്വസ്റ്റ്</span>
                                    <span :style="tbBadgeStyle(z.share_request_status || 'none')" class="mal-text">{{ z.share_request_status ? tbStatusLabel(z.share_request_status) : 'ഇല്ല' }}</span>
                                </div>
                                <div v-if="z.share_request_status" style="font-size:10px;color:#aaa;margin-top:-3px;">₹{{ z.share_request_amount }} · {{ z.share_request_created_at }}</div>
                            </div>
                        </div>
                    </template>
                </template>

                <!-- ═══ DISTRICT level ═══ -->
                <template v-else>
                    <div v-for="d in tbFilteredList" :key="d.id" class="card mb-1" style="border-radius:10px;padding:10px 12px;">
                        <div style="font-size:13px;font-weight:700;color:#27173E;">{{ d.name }}</div>
                        <div v-if="d.zones_total" style="font-size:10px;color:#aaa;margin-top:2px;">{{ d.zones_total }} മണ്ഡലം</div>
                        <div style="display:flex;flex-direction:column;gap:6px;margin-top:8px;">
                            <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">
                                <span style="font-size:11px;color:#666;" class="mal-text">ബുക്ക് ലഭിച്ചത് (യൂണിറ്റിൽ നിന്ന്)</span>
                                <span :style="tbPercentBadgeStyle(d.books_percent)">{{ d.units_books_done }}/{{ d.units_total }} ({{ d.books_percent }}%)</span>
                            </div>
                            <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">
                                <span style="font-size:11px;color:#666;" class="mal-text">ഇൻസ്പെക്ഷൻ പൂർത്തിയായത്</span>
                                <span :style="tbPercentBadgeStyle(d.inspection_percent)">{{ d.units_inspection_done }}/{{ d.units_total }} ({{ d.inspection_percent }}%)</span>
                            </div>
                            <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">
                                <span style="font-size:11px;color:#666;" class="mal-text">ആകെ പിരിച്ചത്</span>
                                <span style="font-size:13px;font-weight:800;color:#1a418c;">₹{{ formatAmt(d.total_collected) }}</span>
                            </div>
                            <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">
                                <span style="font-size:11px;color:#666;" class="mal-text">വിഹിതം കൈപ്പറ്റൽ (സ്റ്റേറ്റിലേക്ക്)</span>
                                <span :style="tbBadgeStyle(d.share_taken_status)" class="mal-text">{{ tbStatusLabel(d.share_taken_status) }}</span>
                            </div>
                            <div v-if="d.share_taken_by_name" style="font-size:10px;color:#aaa;margin-top:-3px;">{{ d.share_taken_by_name }} · {{ d.share_taken_at }}</div>
                            <div v-if="d.share_taken_reviewed_by_name" style="font-size:10px;color:#aaa;margin-top:-3px;">Reviewed: {{ d.share_taken_reviewed_by_name }} · {{ d.share_taken_reviewed_at }}</div>
                            <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">
                                <span style="font-size:11px;color:#666;" class="mal-text">ഫണ്ട് ഷെയർ റിക്വസ്റ്റ്</span>
                                <span :style="tbBadgeStyle(d.share_request_status || 'none')" class="mal-text">{{ d.share_request_status ? tbStatusLabel(d.share_request_status) : 'ഇല്ല' }}</span>
                            </div>
                            <div v-if="d.share_request_status" style="font-size:10px;color:#aaa;margin-top:-3px;">₹{{ d.share_request_amount }} · {{ d.share_request_created_at }}</div>
                        </div>
                    </div>
                </template>
            </template>
        </template>

        <!-- Call & Follow-up bottom sheet — rendered outside the page-tab switch so it's
             always in the DOM regardless of which report tab is currently active -->
        <div v-if="followupShow" style="position:fixed;inset:0;background:rgba(0,0,0,0.45);z-index:10000;display:flex;align-items:flex-end;justify-content:center;" @click.self="followupShow = false">
            <div style="background:#fff;border-radius:16px 16px 0 0;width:100%;max-width:520px;max-height:85vh;display:flex;flex-direction:column;">
                <div style="display:flex;align-items:center;justify-content:space-between;padding:14px 16px;border-bottom:1px solid #eee;">
                    <span class="mal-text" style="font-size:14px;font-weight:800;color:#27173E;">{{ followupUnit ? followupUnit.name : '' }} — വിളിച്ച് ഫോളോ ചെയ്യുക</span>
                    <button type="button" style="border:none;background:none;font-size:20px;color:#888;" @click="followupShow = false">&times;</button>
                </div>
                <div style="overflow-y:auto;padding:12px 16px;">
                    <div class="mal-text" style="font-size:11px;font-weight:800;color:#888;text-transform:uppercase;letter-spacing:0.5px;margin-bottom:6px;">ഭാരവാഹികളുടെ വിവരങ്ങൾ</div>
                    <div v-if="followupBearersLoading" class="text-center py-2">
                        <div class="spinner-border spinner-border-sm text-secondary"></div>
                    </div>
                    <div v-else-if="!followupBearers.length" class="text-center text-muted py-2 mal-text" style="font-size:12px;">ഭാരവാഹികളുടെ വിവരം ലഭ്യമല്ല</div>
                    <div v-else v-for="(b, idx) in followupBearers" :key="idx"
                        style="display:flex;align-items:center;justify-content:space-between;gap:8px;padding:8px 10px;border:1px solid #eee;border-radius:10px;margin-bottom:6px;">
                        <div style="min-width:0;">
                            <div class="mal-text" style="font-size:11px;color:#a15c00;font-weight:700;">{{ b.designation }}</div>
                            <div style="font-size:13px;font-weight:700;color:#27173E;">{{ b.name }}</div>
                        </div>
                        <a href="javascript:void(0)" @click="dial(b)" style="border:none;background:#1DCC70;color:#fff;width:34px;height:34px;border-radius:50%;display:flex;align-items:center;justify-content:center;flex-shrink:0;">
                            <ion-icon name="call" style="font-size:16px;"></ion-icon>
                        </a>
                    </div>

                    <div class="mal-text" style="font-size:11px;font-weight:800;color:#888;text-transform:uppercase;letter-spacing:0.5px;margin:14px 0 6px;">ഫോളോ അപ്പ് നോട്ടുകൾ</div>
                    <div v-if="followupNotesLoading" class="text-center py-2">
                        <div class="spinner-border spinner-border-sm text-secondary"></div>
                    </div>
                    <div v-else-if="!followupNotes.length" class="text-center text-muted py-2 mal-text" style="font-size:12px;">നോട്ടുകൾ ഒന്നും ഇല്ല</div>
                    <div v-else v-for="n in followupNotes" :key="n.id" style="padding:8px 10px;border-bottom:1px solid #f2f2f2;">
                        <div style="font-size:13px;color:#333;white-space:pre-wrap;">{{ n.note }}</div>
                        <div style="font-size:10px;color:#aaa;margin-top:3px;">{{ n.added_by_name }} · {{ n.created_at }}</div>
                    </div>

                    <div style="margin-top:10px;">
                        <textarea v-model="newFollowupNote" rows="2" class="form-control mal-text" placeholder="നോട്ട് എഴുതുക..." style="font-size:13px;resize:none;"></textarea>
                        <button type="button" class="btn btn-primary mal-text" :disabled="savingFollowupNote || !newFollowupNote.trim()" @click="saveFollowupNote" style="width:100%;margin-top:8px;font-size:13px;font-weight:700;">
                            {{ savingFollowupNote ? 'സേവ് ചെയ്യുന്നു...' : '+ നോട്ട് ചേർക്കുക' }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<style scoped>
/* Units with zero youth-wing members — tinted amber (matching their "No Youth" badge) so
   they're recognisable at a glance in every report list, and so the list is obviously a
   different set when the "No Youth Units" filter narrows it down to just these.
   !important is required because these rows carry their own inline background/border. */
.no-youth-row {
    background: #fff8ed !important;
    border-left: 3px solid #e67e22 !important;
}

/* Segmented report tabs — equal width, single line, compact for 375px */
.report-tabs {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 4px;
    margin-bottom: 10px;
    background: #f0f0f0;
    border-radius: 12px;
    padding: 4px;
}
.report-tab {
    flex: 1;
    min-width: 0;
    padding: 8px 4px;
    border: none;
    border-radius: 9px;
    background: transparent;
    color: #666;
    font-weight: 700;
    font-size: 12px;
    line-height: 1.2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
}
.report-tab.active {
    background: #1a418c;
    color: #fff;
    box-shadow: 0 2px 6px rgba(26, 65, 140, 0.25);
}

/* Card wrapping the view toggle + pending sub-tabs */
.filter-card {
    background: #fff;
    border: 1px solid #eef0f5;
    border-radius: 12px;
    padding: 10px;
    margin-bottom: 10px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
}

/* Pending-level sub-tabs — equal 2-column grid, uniform height, compact for 375px */
.pending-tabs {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 5px;
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid #f0f0f0;
}
.pending-tab {
    padding: 8px 6px;
    border: none;
    border-radius: 8px;
    background: #f0f0f0;
    color: #666;
    font-weight: 700;
    font-size: 11px;
    line-height: 1.2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
}
.pending-tab.active {
    background: #e74c3c;
    color: #fff;
}
.pending-tab.orange.active {
    background: #e67e22;
}

.stat-card {
    border-radius: 10px;
    padding: 10px 6px;
    text-align: center;
}
.stat-value {
    font-size: 20px;
    font-weight: 800;
    line-height: 1.1;
}
.stat-label {
    font-size: 11px;
    color: #888;
    font-weight: 600;
    margin-top: 3px;
    line-height: 1.3;
}

/* ── Collection consolidation card ─────────────────────────────── */
.consolidation-card {
    background: #fff;
    border: 1px solid #eef0f5;
    border-radius: 14px;
    padding: 4px 16px;
    box-shadow: 0 2px 10px rgba(0,0,0,.04);
}
.cons-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 0;
    cursor: pointer;
    user-select: none;
}
.cons-title {
    font-size: 13px;
    font-weight: 800;
    color: #27173E;
    letter-spacing: 0.02em;
}
.cons-chevron {
    font-size: 18px;
    color: #94a3b8;
    transition: transform .28s ease;
}
.cons-chevron.open {
    transform: rotate(180deg);
}
.cons-body {
    padding-bottom: 8px;
}
.cons-collapse-enter-active,
.cons-collapse-leave-active {
    transition: max-height .28s ease, opacity .28s ease;
    overflow: hidden;
}
.cons-collapse-enter-from,
.cons-collapse-leave-to {
    max-height: 0;
    opacity: 0;
}
.cons-collapse-enter-to,
.cons-collapse-leave-from {
    max-height: 240px;
    opacity: 1;
}
.cons-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 9px 0;
    border-top: 1px solid #f3f4f8;
}
.cons-row:first-of-type { border-top: none; }
.cons-label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    color: #475569;
    font-weight: 600;
}
.cons-label ion-icon { font-size: 18px; }
.cons-val {
    font-size: 15px;
    font-weight: 800;
    color: #27173E;
}
</style>

<script>
import { mapGetters } from 'vuex'
import UserService from '../../services/user.service'

export default {
    name: 'KaradListReport',
    data() {
        return {
            page: 'karad',

            // Shared across every report tab — when on, narrows whichever list is currently
            // showing down to units with zero youth-wing members (server-flagged `no_youth`).
            noYouthOnly: false,

            // Karad report
            loading: false,
            user_level: 0,
            districts: [],
            zones: [],
            district_id: '',
            zone_id: '',
            unit_id: '',
            unit_options: [],
            summary: null,
            added: [],
            not_added: [],
            tab: 'not_added',

            collapsedKaradZones: {},

            // Receipt report
            r_loading: false,
            r_loaded: false,
            r_district_id: '',
            r_zone_id: '',
            r_zones: [],
            r_unit_id: '',
            r_unit_options: [],
            receipt_received_list: [],
            receipt_not_received_list: [],
            collapsedZones: {},
            r_show_pending_only: false,
            r_pending_level: 'unit',
            r_t_number_count: 0,
            tList_show: false,
            tList_loading: false,
            tList_rows: [],

            // Call & Follow-up bottom sheet (not-started / started unit rows on the karad report)
            followupShow: false,
            followupUnit: null,
            followupBearersLoading: false,
            followupBearers: [],
            newFollowupNote: '',
            followupNotesLoading: false,
            followupNotes: [],
            savingFollowupNote: false,


            // Zones reached but not distributed to units
            ud_loading: false,
            ud_loaded: false,
            ud_district_id: '',
            ud_zones: [],

            // Not Started report
            ns_loading: false,
            ns_loaded: false,
            ns_district_id: '',
            ns_zone_id: '',
            ns_zones: [],
            ns_unit_id: '',
            ns_unit_options: [],
            ns_level: 'unit',
            ns_mode: 'not_started',
            ns_unit_started: [],
            ns_unit_not_started: [],
            ns_unit_total: 0,
            ns_zone_not_started: [],
            ns_zone_percent: [],
            ns_zone_total: 0,
            ns_district_not_started: [],
            ns_district_percent: [],
            ns_district_total: 0,
            ns_percent_filter: null,
            ns_breakdown: null,
            consOpen: false,
            collapsedNsZones: {},

            // Target given report
            tg_loading: false,
            tg_loaded: false,
            tg_district_id: '',
            tg_zone_id: '',
            tg_zones: [],
            tg_unit_id: '',
            tg_unit_options: [],
            tg_summary: null,
            tg_tab: 'not_given',
            given: [],
            not_given: [],
            collapsedTargetZones: {},

            // Members report (youth wing)
            mr_loading: false,
            mr_loaded: false,
            mr_exporting: false,
            mr_category: 'members',
            // '' = all three wings the fund is collected from (matches the karad
            // need-to-visit total); 1 = Org, 2 = Youth, 4 = Lajna.
            mr_wing: '',
            mr_wing_options: [
                { v: '', l: 'എല്ലാം' },
                { v: 1, l: 'വിസ്‌ഡം' },
                { v: 2, l: 'യൂത്ത്' },
                { v: 4, l: 'വുമൺ' },
            ],
            mr_exec_level: 4,
            mr_exec_subcategory: null,
            mr_district_id: '',
            mr_zone_id: '',
            mr_zones: [],
            mr_unit_id: '',
            mr_unit_options: [],
            mr_summary: null,
            mr_mode: 'units',
            mr_tab: 'not_collected',
            mr_units: [],
            mr_collected: [],
            mr_not_collected: [],
            collapsedMembersZones: {},

            // Receipt Take-Back report
            tb_loading: false,
            tb_loaded: false,
            tb_district_id: '',
            tb_zone_id: '',
            tb_zones: [],
            tb_unit_id: '',
            tb_unit_options: [],
            tb_list: [],
            tb_zones_list: [],
            tb_districts_list: [],
            tb_level: 'unit',
            tb_status_filter: 'all',
            collapsedTbZones: {},
        }
    },
    computed: {
        ...mapGetters({ currentUser: 'currentUser' }),
        // District display order: Kerala south→north (1-14), Malappuram South (26) after Malappuram (10), other-state districts (15+) at end
        districtSortKey() {
            const ORDER = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 26, 11, 12, 13, 14, 15, 16, 17]
            const map = {}
            ORDER.forEach((id, idx) => { map[id] = idx })
            return (districtId) => map[districtId] !== undefined ? map[districtId] : 999
        },
        // "No Youth Units" breakdown — which raw unit list to scan depends on whichever
        // report tab is currently open (each tab's units carry the same `no_youth` flag).
        noYouthSourceList() {
            switch (this.page) {
                case 'karad':        return [...this.added, ...this.not_added]
                case 'receipt':      return [...this.receipt_received_list, ...this.receipt_not_received_list]
                case 'not_started':  return [...this.ns_unit_started, ...this.ns_unit_not_started]
                case 'target':       return [...this.given, ...this.not_given]
                case 'members':      return this.mr_units
                default:             return []
            }
        },
        noYouthUnitsList() {
            return this.noYouthSourceList.filter(u => u.no_youth)
        },
        filteredNotAdded() {
            const list = this.unit_id ? this.not_added.filter(u => u.id == this.unit_id) : this.not_added
            return this.noYouthOnly ? list.filter(u => u.no_youth) : list
        },
        filteredAdded() {
            const list = this.unit_id ? this.added.filter(u => u.id == this.unit_id) : this.added
            return this.noYouthOnly ? list.filter(u => u.no_youth) : list
        },
        // Karad "not added" units grouped by district → zone
        karadNotAddedByDistrict() {
            return this._karadGroupByDistrict(this.filteredNotAdded)
        },
        // Karad "added" units grouped by district → zone
        karadAddedByDistrict() {
            return this._karadGroupByDistrict(this.filteredAdded)
        },
        // Receipt Take-Back report — District/Zone/Unit level pills (ജില്ല/മണ്ഡലം/യൂണിറ്റ്), same
        // idea as the Collection Report's ns_level, since a unit's take-back status alone doesn't
        // show whether a ZONE has passed its consolidated book+cash up to its district, or a
        // DISTRICT up to the state — each level has its own upward share-taken/request flow.
        tbLevelSourceList() {
            return this.tb_level === 'district' ? this.tb_districts_list
                : this.tb_level === 'zone' ? this.tb_zones_list
                : this.tb_list
        },
        // Summary cards stay unit-level ground truth regardless of which level pill is active —
        // District/Zone/Unit all filter reactively client-side against the already-loaded list.
        tbUnitStatsList() {
            let list = this.tb_list
            if (this.tb_district_id) list = list.filter(u => u.district_id == this.tb_district_id)
            if (this.tb_zone_id)     list = list.filter(u => u.zone_id == this.tb_zone_id)
            if (this.tb_unit_id)     list = list.filter(u => u.id == this.tb_unit_id)
            return list
        },
        tbLocationFilteredList() {
            let list = this.tbLevelSourceList
            if (this.tb_level === 'unit') {
                if (this.tb_district_id) list = list.filter(u => u.district_id == this.tb_district_id)
                if (this.tb_zone_id)     list = list.filter(u => u.zone_id == this.tb_zone_id)
                if (this.tb_unit_id)     list = list.filter(u => u.id == this.tb_unit_id)
            } else if (this.tb_level === 'zone') {
                if (this.tb_district_id) list = list.filter(z => z.district_id == this.tb_district_id)
                if (this.tb_zone_id)     list = list.filter(z => z.id == this.tb_zone_id)
            } else if (this.tb_level === 'district') {
                if (this.tb_district_id) list = list.filter(d => d.id == this.tb_district_id)
            }
            return list
        },
        tbIncompleteList() {
            return this.tbLocationFilteredList.filter(row => this._tbIsIncomplete(row))
        },
        tbCompleteList() {
            return this.tbLocationFilteredList.filter(row => !this._tbIsIncomplete(row))
        },
        tbFilteredList() {
            switch (this.tb_status_filter) {
                case 'incomplete':      return this.tbIncompleteList
                case 'complete':        return this.tbCompleteList
                case 'books_done':      return this.tbUnitStatsList.filter(u => u.books_taken_back === u.books_total)
                case 'inspection_done': return this.tbUnitStatsList.filter(u => u.inspection_done)
                case 'share_accepted':  return this.tbUnitStatsList.filter(u => u.share_taken_status === 'accepted')
                default:                return this.tbLocationFilteredList
            }
        },
        tbZonesByDistrict() {
            return this._groupZonesByDistrict(this.tbFilteredList)
        },
        // Label for the dismissible chip shown when a stat-card shortcut (rather than the
        // three main sub-tabs) is the active filter — these 3 always jump to the Unit level,
        // since the summary cards themselves are unit-level ground truth.
        tbCardFilterLabel() {
            const labels = {
                books_done: 'ബുക്ക് തിരിച്ചേൽപ്പിച്ചത്',
                inspection_done: 'ഇൻസ്പെക്ഷൻ പൂർത്തിയായത്',
                share_accepted: 'വിഹിതം സ്വീകരിച്ചത്',
            }
            return labels[this.tb_status_filter] || null
        },
        tbByDistrict() {
            return this._karadGroupByDistrict(this.tbFilteredList)
        },
        tbBooksDoneCount() {
            return this.tbUnitStatsList.filter(u => u.books_taken_back === u.books_total).length
        },
        tbInspectionDoneCount() {
            return this.tbUnitStatsList.filter(u => u.inspection_done).length
        },
        tbShareAcceptedCount() {
            return this.tbUnitStatsList.filter(u => u.share_taken_status === 'accepted').length
        },
        // Total receipt books issued across the units in scope (not unit count — a unit can
        // hold more than one book).
        tbTotalBooksCount() {
            return this.tbUnitStatsList.reduce((sum, u) => sum + (u.books_total || 0), 0)
        },
        // Overall completion — % of units where all 3 criteria (book taken back, inspection
        // done, share accepted) are done.
        tbOverallCompletionPercent() {
            const total = this.tbUnitStatsList.length
            if (!total) return 0
            const complete = this.tbUnitStatsList.filter(u => !this._tbIsIncomplete(u)).length
            return Math.round(complete / total * 100)
        },
        // Target given report
        filteredTargetNotGiven() {
            const list = this.tg_unit_id ? this.not_given.filter(u => u.id == this.tg_unit_id) : this.not_given
            return this.noYouthOnly ? list.filter(u => u.no_youth) : list
        },
        filteredTargetGiven() {
            const list = this.tg_unit_id ? this.given.filter(u => u.id == this.tg_unit_id) : this.given
            return this.noYouthOnly ? list.filter(u => u.no_youth) : list
        },
        targetNotGivenByDistrict() {
            return this._karadGroupByDistrict(this.filteredTargetNotGiven)
        },
        targetGivenByDistrict() {
            return this._karadGroupByDistrict(this.filteredTargetGiven)
        },
        // Members report (youth wing) — unit-level counts grouped by district → zone
        filteredMrUnits() {
            return this.noYouthOnly ? this.mr_units.filter(u => u.no_youth) : this.mr_units
        },
        membersUnitsByDistrict() {
            return this._karadGroupByDistrict(this.filteredMrUnits)
        },
        // Selected District/Zone/Unit names, shown under each report's filter card so a
        // screenshot of the results is self-explanatory about what it's filtered to.
        karadFilterHeading() {
            return this._filterHeading(this.district_id, this.zone_id, this.zones, this.unit_id, this.unit_options)
        },
        receiptFilterHeading() {
            return this._filterHeading(this.r_district_id, this.r_zone_id, this.r_zones, this.r_unit_id, this.r_unit_options)
        },
        nsFilterHeading() {
            return this._filterHeading(this.ns_district_id, this.ns_zone_id, this.ns_zones, this.ns_unit_id, this.ns_unit_options)
        },
        tgFilterHeading() {
            return this._filterHeading(this.tg_district_id, this.tg_zone_id, this.tg_zones, this.tg_unit_id, this.tg_unit_options)
        },
        mrFilterHeading() {
            return this._filterHeading(this.mr_district_id, this.mr_zone_id, this.mr_zones, this.mr_unit_id, this.mr_unit_options)
        },
        // Headline stat label — names the wing actually being counted, so the number is never
        // ambiguous (it used to always read "യൂത്ത്" even though it now covers all wings).
        mrTotalLabel() {
            if (this.mr_category === 'executives') return 'ആകെ എക്സിക്യൂട്ടീവ്സ്'
            const w = this.mr_wing_options.find(o => o.v === this.mr_wing)
            return this.mr_wing === '' ? 'ആകെ മെമ്പർമാർ' : 'ആകെ ' + (w ? w.l : '') + ' മെമ്പർമാർ'
        },
        // Executives — collected/not-collected lists grouped by district → zone
        execNotCollectedByDistrict() {
            return this._karadGroupByDistrict(this.mr_not_collected)
        },
        execCollectedByDistrict() {
            return this._karadGroupByDistrict(this.mr_collected)
        },
        // Not Started report
        filteredNsNotStarted() {
            const list = this.ns_unit_id ? this.ns_unit_not_started.filter(u => u.id == this.ns_unit_id) : this.ns_unit_not_started
            return this.noYouthOnly ? list.filter(u => u.no_youth) : list
        },
        notStartedUnitsByDistrict() {
            return this._karadGroupByDistrict(this.filteredNsNotStarted)
        },
        notStartedZonesByDistrict() {
            const distMap = {}
            this.ns_zone_not_started.forEach(z => {
                const key = z.district_id || ('n_' + z.district_name)
                if (!distMap[key]) distMap[key] = { district_id: z.district_id, district_name: z.district_name, zones: [] }
                distMap[key].zones.push(z)
            })
            return Object.values(distMap).sort((a, b) =>
                this.districtSortKey(a.district_id) - this.districtSortKey(b.district_id) || (a.district_name || '').localeCompare(b.district_name || '')
            )
        },
        notStartedDistrictsList() {
            return [...this.ns_district_not_started].sort((a, b) =>
                this.districtSortKey(a.id) - this.districtSortKey(b.id) || (a.name || '').localeCompare(b.name || '')
            )
        },
        // Started report (percentage view)
        filteredNsStarted() {
            let list = this.ns_unit_id ? this.ns_unit_started.filter(u => u.id == this.ns_unit_id) : this.ns_unit_started
            if (this.ns_percent_filter) list = list.filter(u => this.matchesPercentBucket(u.percent))
            return this.noYouthOnly ? list.filter(u => u.no_youth) : list
        },
        startedUnitsByDistrict() {
            return this._karadGroupByDistrict(this.filteredNsStarted)
        },
        startedZonesByDistrict() {
            const source = this.ns_percent_filter
                ? this.ns_zone_percent.filter(z => this.matchesPercentBucket(z.percent))
                : this.ns_zone_percent
            const distMap = {}
            source.forEach(z => {
                const key = z.district_id || ('n_' + z.district_name)
                if (!distMap[key]) distMap[key] = { district_id: z.district_id, district_name: z.district_name, zones: [] }
                distMap[key].zones.push(z)
            })
            return Object.values(distMap).sort((a, b) =>
                this.districtSortKey(a.district_id) - this.districtSortKey(b.district_id) || (a.district_name || '').localeCompare(b.district_name || '')
            )
        },
        startedDistrictsList() {
            const source = this.ns_percent_filter
                ? this.ns_district_percent.filter(d => this.matchesPercentBucket(d.percent))
                : this.ns_district_percent
            return [...source].sort((a, b) =>
                this.districtSortKey(a.id) - this.districtSortKey(b.id) || (a.name || '').localeCompare(b.name || '')
            )
        },
        // All units merged (received + not received), grouped by zone
        allUnitsByZone() {
            const map = {}
            let all = [
                ...this.receipt_received_list,
                ...this.receipt_not_received_list,
            ].filter(u => !this.r_unit_id || u.id == this.r_unit_id)
            if (this.noYouthOnly) all = all.filter(u => u.no_youth)
            all.forEach(u => {
                // Skip units whose zone no longer exists (stale zone_id, no zone_name)
                if (u.zone_id && !u.zone_name) return
                const key = u.zone_id || 0
                if (!map[key]) {
                    map[key] = {
                        zone_id: key,
                        zone_name: u.zone_name || 'Unknown',
                        district_id: u.district_id || 0,
                        district_name: u.district_name || '',
                        zone_receipt_book_no: u.zone_receipt_book_no || null,
                        units: [],
                        received_count: 0,
                        t_number_total: 0,
                    }
                }
                map[key].units.push(u)
                if (u.receipt_book_no) map[key].received_count++
                map[key].t_number_total += u.t_number_count || 0
                if (u.zone_receipt_book_no && !map[key].zone_receipt_book_no) {
                    map[key].zone_receipt_book_no = u.zone_receipt_book_no
                }
            })
            return Object.values(map)
                .sort((a, b) => this.districtSortKey(a.district_id) - this.districtSortKey(b.district_id) || a.zone_id - b.zone_id)
                .map(zg => ({ ...zg, units: zg.units.sort((a, b) => a.name.localeCompare(b.name)) }))
        },
        // Zones grouped by district for display
        zonesByDistrict() {
            const distMap = {}
            const zones = this.r_show_pending_only ? this.pendingOnlyZones : this.allUnitsByZone
            zones.forEach(zg => {
                const key = zg.district_id || 0
                if (!distMap[key]) {
                    distMap[key] = { district_id: key, district_name: zg.district_name || 'Unknown', zones: [] }
                }
                distMap[key].zones.push(zg)
            })
            return Object.values(distMap).sort((a, b) => this.districtSortKey(a.district_id) - this.districtSortKey(b.district_id))
        },
        // Only zones/units that haven't received
        pendingOnlyZones() {
            return this.allUnitsByZone
                .map(zg => {
                    const pendingUnits = zg.units.filter(u => !u.receipt_book_no)
                    return {
                        ...zg,
                        units: pendingUnits,
                        pending_unit_count: pendingUnits.length,
                    }
                })
                // Show zone if zone itself is pending OR has pending units
                .filter(zg => !zg.zone_receipt_book_no || zg.pending_unit_count > 0)
        },
        // Flat merged list for zone-selected view
        allUnitsFlat() {
            const all = this.noYouthOnly
                ? [...this.receipt_received_list, ...this.receipt_not_received_list].filter(u => u.no_youth)
                : [...this.receipt_received_list, ...this.receipt_not_received_list]
            return all.sort((a, b) => a.name.localeCompare(b.name))
        },
        pendingDistrictsList() {
            const map = {}
            const all = [...this.receipt_received_list, ...this.receipt_not_received_list]
            all.forEach(u => {
                const key = u.district_id || ('n_' + u.district_name)
                if (!map[key]) map[key] = { district_id: u.district_id, district_name: u.district_name, received: false }
                if (u.district_receipt_book_no) map[key].received = true
            })
            return Object.values(map).filter(d => !d.received)
                .sort((a, b) => this.districtSortKey(a.district_id) - this.districtSortKey(b.district_id) || a.district_name.localeCompare(b.district_name))
        },
        pendingZonesList() {
            const map = {}
            const all = [...this.receipt_received_list, ...this.receipt_not_received_list]
            all.forEach(u => {
                // Skip units whose zone reference is stale/blank (no zone name) — avoids blank cards
                if (!(u.zone_name || '').trim()) return
                const key = u.zone_id || ('n_' + u.zone_name)
                if (!map[key]) map[key] = { zone_id: u.zone_id, zone_name: u.zone_name, district_id: u.district_id, district_name: u.district_name, received: false }
                if (u.zone_receipt_book_no) map[key].received = true
            })
            return Object.values(map).filter(z => !z.received)
                .sort((a, b) => this.districtSortKey(a.district_id) - this.districtSortKey(b.district_id) || a.zone_name.localeCompare(b.zone_name))
        },
        pendingZonesByDistrict() {
            const distMap = {}
            this.pendingZonesList.forEach(z => {
                const key = z.district_id || ('n_' + z.district_name)
                if (!distMap[key]) distMap[key] = { district_id: z.district_id, district_name: z.district_name, zones: [] }
                distMap[key].zones.push(z)
            })
            return Object.values(distMap).sort((a, b) =>
                this.districtSortKey(a.district_id) - this.districtSortKey(b.district_id) || a.district_name.localeCompare(b.district_name)
            )
        },
        zoneReceiptStats() {
            const map = {}
            const all = [...this.receipt_received_list, ...this.receipt_not_received_list]
            all.forEach(u => {
                // Skip stale/blank zones so the count matches the visible list
                if (!(u.zone_name || '').trim()) return
                const key = u.zone_id || ('n_' + u.zone_name)
                if (!map[key]) map[key] = { received: false }
                if (u.zone_receipt_book_no) map[key].received = true
            })
            const zones = Object.values(map)
            const received = zones.filter(z => z.received).length
            return { total: zones.length, received, not_received: zones.length - received }
        },
        districtReceiptStats() {
            const map = {}
            const all = [...this.receipt_received_list, ...this.receipt_not_received_list]
            all.forEach(u => {
                const key = u.district_id || ('n_' + u.district_name)
                if (!map[key]) map[key] = { received: false }
                if (u.district_receipt_book_no) map[key].received = true
            })
            const districts = Object.values(map)
            const received = districts.filter(d => d.received).length
            return { total: districts.length, received, not_received: districts.length - received }
        },
        receiptDistrictPercent() {
            const all = [...this.receipt_received_list, ...this.receipt_not_received_list]
            const districtMap = {}
            all.forEach(u => {
                const key = u.district_id || 0
                if (!districtMap[key]) districtMap[key] = { total: 0, received: false }
                districtMap[key].total++
                if (u.district_receipt_book_no) districtMap[key].received = true
            })
            const entries = Object.values(districtMap)
            if (!entries.length) return 0
            const receivedCount = entries.filter(d => d.received).length
            return Math.round((receivedCount / entries.length) * 100)
        },
        receiptZonePercent() {
            const zones = this.allUnitsByZone
            if (!zones.length) return 0
            const received = zones.filter(zg => !!zg.zone_receipt_book_no).length
            return Math.round((received / zones.length) * 100)
        },
        receiptUnitPercent() {
            const total = this.receipt_received_list.length + this.receipt_not_received_list.length
            if (!total) return 0
            return Math.round((this.receipt_received_list.length / total) * 100)
        },
        // Undistributed zones grouped by district
        undistributedByDistrict() {
            const distMap = {}
            this.ud_zones.forEach(z => {
                const key = z.district_id || ('n_' + z.district_name)
                if (!distMap[key]) distMap[key] = { district_id: z.district_id, district_name: z.district_name || 'Unknown', zones: [] }
                distMap[key].zones.push(z)
            })
            return Object.values(distMap)
                .map(dg => ({ ...dg, zones: dg.zones.sort((a, b) => (a.zone_name || '').localeCompare(b.zone_name || '')) }))
                .sort((a, b) => this.districtSortKey(a.district_id) - this.districtSortKey(b.district_id) || (a.district_name || '').localeCompare(b.district_name || ''))
        },
    },
    watch: {
        zone_id() {
            this.unit_id = ''
            this.unit_options = []
        },
        ns_zone_id() {
            this.ns_unit_id = ''
            this.ns_unit_options = []
        },
        mr_zone_id() {
            this.mr_unit_id = ''
            this.mr_unit_options = []
        },
        page(val) {
            if (val === 'receipt' && !this.r_loaded && !this.r_loading) {
                this.loadReceiptReport()
            }
            if (val === 'not_started' && !this.ns_loaded && !this.ns_loading) {
                this.loadNotStartedReport()
            }
            if (val === 'target' && !this.tg_loaded && !this.tg_loading) {
                this.loadTargetReport()
            }
            if (val === 'members' && !this.mr_loaded && !this.mr_loading) {
                this.loadMembersReport()
            }
            if (val === 'takeback' && !this.tb_loaded && !this.tb_loading) {
                this.loadTakebackReport()
            }
        },
    },
    mounted() {
        this.user_level = parseInt(this.$route.params.sub_level)
        if (this.user_level === 1) {
            this.loadDistricts()
        } else if (this.user_level === 2) {
            this.district_id   = parseInt(this.$route.params.id)
            this.r_district_id = parseInt(this.$route.params.id)
            this.ns_district_id = parseInt(this.$route.params.id)
            this.tg_district_id = parseInt(this.$route.params.id)
            this.mr_district_id = parseInt(this.$route.params.id)
            this.tb_district_id = parseInt(this.$route.params.id)
            this.loadZones(this.district_id)
            this.loadReceiptZones(this.r_district_id)
            this.loadNsZones(this.ns_district_id)
            this.loadTargetZones(this.tg_district_id)
            this.loadMembersZones(this.mr_district_id)
            this.loadTbZones(this.tb_district_id)
        } else if (this.user_level === 3) {
            this.zone_id   = parseInt(this.$route.params.id)
            this.r_zone_id = parseInt(this.$route.params.id)
            this.ns_zone_id = parseInt(this.$route.params.id)
            this.tg_zone_id = parseInt(this.$route.params.id)
            this.mr_zone_id = parseInt(this.$route.params.id)
            this.tb_zone_id = parseInt(this.$route.params.id)
        }
        this.loadReport()
    },
    methods: {
        formatAmt(v) {
            const n = parseFloat(v || 0)
            return n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        // ns_percent_filter is one of the bucket upper bounds [20,40,65,80,100] — matches the
        // RANGE between the previous threshold and this one (e.g. clicking "< 80%" means
        // 65%–80%, not "anything below 80%", which would just include almost everything).
        matchesPercentBucket(percent) {
            const thresholds = [20, 40, 65, 80, 100]
            const idx = thresholds.indexOf(this.ns_percent_filter)
            if (idx === -1) return true
            const lower = idx > 0 ? thresholds[idx - 1] : 0
            const upper = thresholds[idx]
            return upper === 100 ? (percent >= lower && percent <= upper) : (percent >= lower && percent < upper)
        },
        toggleZone(zoneId) {
            this.collapsedZones = { ...this.collapsedZones, [zoneId]: !this.collapsedZones[zoneId] }
        },
        toggleKaradZone(key) {
            this.collapsedKaradZones = { ...this.collapsedKaradZones, [key]: !this.collapsedKaradZones[key] }
        },
        toggleTargetZone(key) {
            this.collapsedTargetZones = { ...this.collapsedTargetZones, [key]: !this.collapsedTargetZones[key] }
        },
        toggleMembersZone(key) {
            this.collapsedMembersZones = { ...this.collapsedMembersZones, [key]: !this.collapsedMembersZones[key] }
        },
        // Builds "District - Zone - Unit" from selected filter ids, skipping any that aren't picked.
        _filterHeading(districtId, zoneId, zonesArr, unitId, unitsArr) {
            const parts = []
            if (districtId) {
                const d = (this.districts || []).find(x => x.id == districtId)
                if (d) parts.push(d.name)
            }
            if (zoneId) {
                const z = (zonesArr || []).find(x => x.id == zoneId)
                if (z) parts.push(z.name)
            }
            if (unitId) {
                const u = (unitsArr || []).find(x => x.id == unitId)
                if (u) parts.push(u.name)
            }
            return parts.join(' - ')
        },
        _tbIsIncomplete(row) {
            // Zone/district rollup rows carry percentages instead of a single unit's own state.
            if (Object.prototype.hasOwnProperty.call(row, 'books_percent')) {
                return !(row.books_percent === 100 && row.inspection_percent === 100 && row.share_taken_status === 'accepted')
            }
            return !(row.books_taken_back === row.books_total
                && row.inspection_done
                && row.share_taken_status === 'accepted')
        },
        // Group zone-level rollup rows by district (one level, unlike _karadGroupByDistrict which
        // groups unit-level rows by district THEN zone).
        _groupZonesByDistrict(zones) {
            const distMap = {}
            zones.forEach(z => {
                const dKey = z.district_id || ('n_' + z.district_name)
                if (!distMap[dKey]) distMap[dKey] = { district_id: z.district_id || 0, district_name: z.district_name || '', zones: [] }
                distMap[dKey].zones.push(z)
            })
            return Object.values(distMap)
                .sort((a, b) => this.districtSortKey(a.district_id) - this.districtSortKey(b.district_id))
                .map(dg => ({ ...dg, zones: dg.zones.sort((a, b) => a.name.localeCompare(b.name)) }))
        },
        tbPercentBadgeStyle(percent) {
            const status = percent === 100 ? 'accepted' : percent > 0 ? 'pending' : 'not_marked'
            return this.tbBadgeStyle(status)
        },
        _karadGroupByDistrict(units) {
            // Build name-based sort key from the already-correctly-sorted districts list
            const districtNameOrder = {}
            this.districts.forEach((d, idx) => { districtNameOrder[d.name] = idx })
            const distSort = (id, name) => {
                if (id && this.districtSortKey(id) !== 999) return this.districtSortKey(id)
                if (districtNameOrder[name] !== undefined) return districtNameOrder[name]
                return 999
            }

            const zoneMap = {}
            units.forEach(u => {
                // Skip units whose zone no longer exists (stale zone_id, no zone_name)
                if (u.zone_id && !u.zone_name) return
                const zKey = (u.zone_id != null && u.zone_id !== 0) ? ('id_' + u.zone_id) : ('n_' + (u.zone_name || ''))
                if (!zoneMap[zKey]) {
                    zoneMap[zKey] = {
                        zone_id: u.zone_id || 0,
                        zone_name: u.zone_name || '',
                        district_id: u.district_id || 0,
                        district_name: u.district_name || '',
                        units: [],
                    }
                }
                zoneMap[zKey].units.push(u)
            })
            const zones = Object.values(zoneMap)
                .sort((a, b) => {
                    const dSort = distSort(a.district_id, a.district_name) - distSort(b.district_id, b.district_name)
                    if (dSort !== 0) return dSort
                    return (a.zone_id || 0) !== 0 ? (a.zone_id - b.zone_id) : a.zone_name.localeCompare(b.zone_name)
                })
                .map(zg => ({ ...zg, units: zg.units.sort((a, b) => a.name.localeCompare(b.name)) }))
            const distMap = {}
            zones.forEach(zg => {
                const dKey = (zg.district_id !== 0) ? ('id_' + zg.district_id) : ('n_' + zg.district_name)
                if (!distMap[dKey]) {
                    distMap[dKey] = { district_id: zg.district_id, district_name: zg.district_name, zones: [] }
                }
                distMap[dKey].zones.push(zg)
            })
            return Object.values(distMap).sort((a, b) =>
                distSort(a.district_id, a.district_name) - distSort(b.district_id, b.district_name)
            )
        },

        // Karad report
        loadDistricts() {
            const EXCLUDED = [18, 19, 20, 21, 22, 23, 24, 25, 27, 28, 735]
            UserService.authGetRequest('get-districts').then((response) => {
                if (response.data.status === 'success') {
                    const all = response.data.data.list || response.data.data || []
                    const ORDER = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 26, 11, 12, 13, 14, 15, 16, 17]
                    const orderMap = {}
                    ORDER.forEach((id, idx) => { orderMap[id] = idx })
                    this.districts = all
                        .filter(d => !EXCLUDED.includes(d.id))
                        .sort((a, b) => (orderMap[a.id] !== undefined ? orderMap[a.id] : 999) - (orderMap[b.id] !== undefined ? orderMap[b.id] : 999))
                }
            })
        },
        onDistrictChange() {
            this.zone_id = ''
            this.zones = []
            this.unit_id = ''
            this.unit_options = []
            if (this.district_id) this.loadZones(this.district_id)
        },
        loadZones(districtId) {
            UserService.authGetRequest('get-zones', { district_id: districtId }).then((response) => {
                if (response.data.status === 'success') {
                    this.zones = response.data.data.zones || response.data.data || []
                }
            })
        },
        onZoneChange() {
            this.unit_id = ''
            this.unit_options = []
            if (this.zone_id) this.loadUnits(this.zone_id)
        },
        loadUnits(zoneId) {
            UserService.authGetRequest('get-units', { zone_id: zoneId }).then((response) => {
                if (response.data.status === 'success') {
                    this.unit_options = response.data.data || []
                }
            })
        },
        loadReport() {
            this.loading = true
            this.summary = null
            UserService.authPostRequest('get-karad-list-report', {
                type:        parseInt(this.$route.params.type),
                district_id: this.district_id || null,
                zone_id:     this.zone_id     || null,
            }).then((response) => {
                this.loading = false
                if (response.data.status === 'success') {
                    const EXCL = [735]
                    this.added     = (response.data.data.added     || []).filter(u => !EXCL.includes(u.district_id))
                    this.not_added = (response.data.data.not_added || []).filter(u => !EXCL.includes(u.district_id))
                    this.summary   = response.data.data.summary   || null
                    // Build unit dropdown from loaded data
                    const unitMap = {}
                    ;[...this.added, ...this.not_added].forEach(u => { if (u.id && !unitMap[u.id]) unitMap[u.id] = u.name })
                    this.unit_options = Object.entries(unitMap).map(([id, name]) => ({ id: parseInt(id), name })).sort((a, b) => a.name.localeCompare(b.name))
                    this.unit_id = ''
                    // Collapse all karad zones by default (keyed by zone_name for stability)
                    const collapsed = {}
                    ;[...this.not_added].forEach(u => { collapsed['na_' + (u.zone_name || '')] = true })
                    ;[...this.added].forEach(u => { collapsed['aa_' + (u.zone_name || '')] = true })
                    this.collapsedKaradZones = collapsed
                }
            }).catch(() => { this.loading = false })
        },

        // Target given report
        onTargetDistrictChange() {
            this.tg_zone_id = ''
            this.tg_zones = []
            this.tg_unit_id = ''
            this.tg_unit_options = []
            if (this.tg_district_id) this.loadTargetZones(this.tg_district_id)
        },
        loadTargetZones(districtId) {
            UserService.authGetRequest('get-zones', { district_id: districtId }).then((response) => {
                if (response.data.status === 'success') {
                    this.tg_zones = response.data.data.zones || response.data.data || []
                }
            })
        },
        onTargetZoneChange() {
            this.tg_unit_id = ''
            this.tg_unit_options = []
            if (this.tg_zone_id) this.loadTargetUnits(this.tg_zone_id)
        },
        loadTargetUnits(zoneId) {
            UserService.authGetRequest('get-units', { zone_id: zoneId }).then((response) => {
                if (response.data.status === 'success') {
                    this.tg_unit_options = response.data.data || []
                }
            })
        },
        loadTargetReport() {
            this.tg_loading = true
            this.tg_summary = null
            UserService.authPostRequest('get-fund-collection-target-report', {
                type:        parseInt(this.$route.params.type),
                district_id: this.tg_district_id || null,
                zone_id:     this.tg_zone_id     || null,
            }).then((response) => {
                this.tg_loading = false
                this.tg_loaded = true
                if (response.data.status === 'success') {
                    const EXCL = [735]
                    this.given     = (response.data.data.given     || []).filter(u => !EXCL.includes(u.district_id))
                    this.not_given = (response.data.data.not_given || []).filter(u => !EXCL.includes(u.district_id))
                    this.tg_summary = response.data.data.summary   || null
                    // Build unit dropdown from loaded data
                    const unitMap = {}
                    ;[...this.given, ...this.not_given].forEach(u => { if (u.id && !unitMap[u.id]) unitMap[u.id] = u.name })
                    this.tg_unit_options = Object.entries(unitMap).map(([id, name]) => ({ id: parseInt(id), name })).sort((a, b) => a.name.localeCompare(b.name))
                    this.tg_unit_id = ''
                    // Collapse all target zones by default (keyed by zone_name for stability)
                    const collapsed = {}
                    ;[...this.not_given].forEach(u => { collapsed['tng_' + (u.zone_name || '')] = true })
                    ;[...this.given].forEach(u => { collapsed['tg_' + (u.zone_name || '')] = true })
                    this.collapsedTargetZones = collapsed
                }
            }).catch(() => { this.tg_loading = false })
        },

        // Members report (youth wing)
        onMembersDistrictChange() {
            this.mr_zone_id = ''
            this.mr_zones = []
            this.mr_unit_id = ''
            this.mr_unit_options = []
            if (this.mr_district_id) this.loadMembersZones(this.mr_district_id)
        },
        loadMembersZones(districtId) {
            UserService.authGetRequest('get-zones', { district_id: districtId }).then((response) => {
                if (response.data.status === 'success') {
                    this.mr_zones = response.data.data.zones || response.data.data || []
                }
            })
        },
        onMembersZoneChange() {
            this.mr_unit_id = ''
            this.mr_unit_options = []
            if (this.mr_zone_id) this.loadMembersUnits(this.mr_zone_id)
        },
        loadMembersUnits(zoneId) {
            UserService.authGetRequest('get-units', { zone_id: zoneId }).then((response) => {
                if (response.data.status === 'success') {
                    this.mr_unit_options = response.data.data || []
                }
            })
        },
        loadMembersReport() {
            this.mr_loading = true
            this.mr_summary = null
            UserService.authPostRequest('get-fund-collection-members-report', {
                type:        parseInt(this.$route.params.type),
                category:         this.mr_category,
                wing:             this.mr_category === 'members' ? (this.mr_wing || null) : null,
                exec_level:       this.mr_category === 'executives' ? this.mr_exec_level : null,
                exec_subcategory: this.mr_category === 'executives' ? this.mr_exec_subcategory : null,
                district_id: this.mr_district_id || null,
                zone_id:     this.mr_zone_id     || null,
                unit_id:     this.mr_unit_id     || null,
            }).then((response) => {
                this.mr_loading = false
                this.mr_loaded = true
                if (response.data.status === 'success') {
                    const EXCL = [735]
                    // Executives are always a flat collected/not-collected list (no unit-count
                    // overview — committee positions are far fewer than the general membership,
                    // and state/district/zone level executives have no "unit" to drill into at
                    // all) — normalize to the same 'members' display mode 'units' falls through to.
                    this.mr_mode = response.data.data.mode === 'units' ? 'units' : 'members'
                    this.mr_summary = response.data.data.summary || null
                    if (this.mr_mode === 'units') {
                        // District/zone overview — aggregate per-unit counts.
                        // unit_id is a server-side filter here (unlike the karad/target tabs,
                        // where it's a client-side post-filter), so it's deliberately never
                        // reset after a load — doing so would undo the user's own selection.
                        this.mr_units = (response.data.data.units || []).filter(u => !EXCL.includes(u.district_id))
                        this.mr_collected = []
                        this.mr_not_collected = []
                        this.mr_unit_options = this.mr_units
                            .map(u => ({ id: u.id, name: u.name }))
                            .sort((a, b) => a.name.localeCompare(b.name))
                        const collapsed = {}
                        this.mr_units.forEach(u => { collapsed['mr_' + (u.zone_name || '')] = true })
                        this.collapsedMembersZones = collapsed
                    } else {
                        // A specific unit was selected — member-level detail.
                        this.mr_units = []
                        this.mr_collected = response.data.data.collected || []
                        this.mr_not_collected = response.data.data.not_collected || []
                        this.mr_tab = 'not_collected'
                        if (this.mr_category === 'executives') {
                            // Collapse every district/zone group by default, same as the other
                            // grouped report tabs — otherwise a state-wide executives list would
                            // render every card expanded at once.
                            const collapsed = {}
                            ;[...this.mr_collected, ...this.mr_not_collected].forEach(m => {
                                collapsed['exz_' + (m.zone_name || '')] = true
                            })
                            this.collapsedMembersZones = collapsed
                        }
                    }
                }
            }).catch(() => { this.mr_loading = false })
        },
        exportNotCollectedMembers() {
            this.mr_exporting = true
            UserService.authGetRequest('export-fund-collection-members-report-not-collected', {
                type:        parseInt(this.$route.params.type),
                wing:        this.mr_wing || null,
                district_id: this.mr_district_id || null,
                zone_id:     this.mr_zone_id     || null,
                unit_id:     this.mr_unit_id     || null,
            }, { responseType: 'blob' }).then((response) => {
                this.mr_exporting = false
                this.downloadBlob(response.data, 'not-collected-members-' + Date.now() + '.xlsx')
            }).catch(() => {
                this.mr_exporting = false
                window.alert('Excel export ചെയ്യാൻ കഴിഞ്ഞില്ല.')
            })
        },
        downloadBlob(data, filename) {
            const blob = data instanceof Blob ? data : new Blob([data])
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.href = url
            a.download = filename
            document.body.appendChild(a)
            a.click()
            a.remove()
            window.URL.revokeObjectURL(url)
        },

        // Zones reached but not distributed to units — scoped by the receipt report's filters
        loadUndistributed() {
            this.ud_loading = true
            UserService.authPostRequest('get-zones-reached-no-unit-receipt', {
                type:        parseInt(this.$route.params.type),
                district_id: this.r_district_id || null,
                zone_id:     this.r_zone_id     || null,
            }).then((response) => {
                this.ud_loading = false
                this.ud_loaded = true
                if (response.data.status === 'success') {
                    this.ud_zones = response.data.data.zones || []
                }
            }).catch(() => { this.ud_loading = false })
        },

        // Receipt report
        onReceiptDistrictChange() {
            this.r_zone_id = ''
            this.r_zones = []
            this.r_unit_id = ''
            this.r_unit_options = []
            if (this.r_district_id) this.loadReceiptZones(this.r_district_id)
        },
        onReceiptZoneChange() {
            this.r_unit_id = ''
            this.r_unit_options = []
            if (this.r_zone_id) this.loadReceiptUnits(this.r_zone_id)
        },
        loadReceiptUnits(zoneId) {
            UserService.authGetRequest('get-units', { zone_id: zoneId }).then((response) => {
                if (response.data.status === 'success') {
                    this.r_unit_options = response.data.data || []
                }
            })
        },
        loadReceiptZones(districtId) {
            UserService.authGetRequest('get-zones', { district_id: districtId }).then((response) => {
                if (response.data.status === 'success') {
                    this.r_zones = response.data.data.zones || response.data.data || []
                }
            })
        },
        onTbDistrictChange() {
            this.tb_zone_id = ''
            this.tb_zones = []
            this.tb_unit_id = ''
            this.tb_unit_options = []
            if (this.tb_district_id) this.loadTbZones(this.tb_district_id)
        },
        onTbZoneChange() {
            this.tb_unit_id = ''
            this.tb_unit_options = []
        },
        loadTbZones(districtId) {
            UserService.authGetRequest('get-zones', { district_id: districtId }).then((response) => {
                if (response.data.status === 'success') {
                    this.tb_zones = response.data.data.zones || response.data.data || []
                }
            })
        },
        toggleTbZone(key) {
            this.collapsedTbZones = { ...this.collapsedTbZones, [key]: !this.collapsedTbZones[key] }
        },
        // The 3 stat-card shortcuts (books_done/inspection_done/share_accepted) only make sense
        // at Unit granularity — switching the level pill away from Unit while one is still active
        // left the District/Zone template rendering raw unit rows under district/zone field names
        // (blank stats). Clear back to the plain complete/incomplete/all filter on every level switch.
        setTbLevel(level) {
            this.tb_level = level
            if (['books_done', 'inspection_done', 'share_accepted'].includes(this.tb_status_filter)) {
                this.tb_status_filter = 'all'
            }
        },
        tbBadgeStyle(status) {
            const map = {
                accepted: { background: '#f0fff6', color: '#1DCC70', border: '1px solid #b7f5d0' },
                approved: { background: '#f0fff6', color: '#1DCC70', border: '1px solid #b7f5d0' },
                pending:  { background: '#fff3e0', color: '#e67e22', border: '1px solid #fde0b3' },
                rejected: { background: '#fee', color: '#e74c3c', border: '1px solid #fdc5c5' },
                not_marked: { background: '#eef0f5', color: '#64748b', border: '1px solid #e0e3ec' },
                none: { background: '#eef0f5', color: '#64748b', border: '1px solid #e0e3ec' },
            }
            return { ...(map[status] || map.not_marked), fontSize: '11px', fontWeight: '700', padding: '2px 9px', borderRadius: '8px', flexShrink: '0' }
        },
        tbBookBadgeStyle(u) {
            const status = u.books_total > 0 && u.books_taken_back === u.books_total ? 'accepted'
                : u.books_taken_back > 0 ? 'pending'
                : u.books_total > 0 ? 'rejected' : 'not_marked'
            return this.tbBadgeStyle(status)
        },
        tbStatusLabel(status) {
            const map = {
                accepted: 'സ്വീകരിച്ചു', approved: 'അംഗീകരിച്ചു', pending: 'അവലോകനത്തിലാണ്',
                rejected: 'നിരസിച്ചു', not_marked: 'രേഖപ്പെടുത്തിയിട്ടില്ല', none: 'ഇല്ല',
            }
            return map[status] || status
        },
        loadTakebackReport() {
            this.tb_loading = true
            this.tb_loaded  = false
            UserService.authPostRequest('get-fund-receipt-takeback-report', {
                type:        parseInt(this.$route.params.type),
                district_id: this.tb_district_id || null,
                zone_id:     this.tb_zone_id     || null,
            }).then((response) => {
                this.tb_loading = false
                if (response.data.status === 'success') {
                    this.tb_list = response.data.data.list || []
                    // District/Zone rollups come back in DB order — re-sort to the standard
                    // Kerala geographic order (Thiruvananthapuram → Kasaragod) used everywhere
                    // else in this report and on the main dashboard.
                    this.tb_zones_list = (response.data.data.zones || [])
                        .sort((a, b) => this.districtSortKey(a.district_id) - this.districtSortKey(b.district_id) || a.name.localeCompare(b.name))
                    this.tb_districts_list = (response.data.data.districts || [])
                        .sort((a, b) => this.districtSortKey(a.id) - this.districtSortKey(b.id))
                    this.tb_loaded = true
                    // Collapse all zones by default
                    const collapsed = {}
                    this.tb_list.forEach(u => { if (u.zone_name) collapsed[u.zone_name] = true })
                    this.collapsedTbZones = collapsed
                    // Build unit dropdown from loaded data
                    const tbUnitMap = {}
                    this.tb_list.forEach(u => { if (u.id && !tbUnitMap[u.id]) tbUnitMap[u.id] = u.name })
                    this.tb_unit_options = Object.entries(tbUnitMap).map(([id, name]) => ({ id: parseInt(id), name })).sort((a, b) => a.name.localeCompare(b.name))
                    this.tb_unit_id = ''
                }
            }).catch(() => { this.tb_loading = false })
        },
        loadReceiptReport() {
            this.r_loading = true
            this.r_loaded  = false
            UserService.authPostRequest('get-fund-receipt-report', {
                type:        parseInt(this.$route.params.type),
                district_id: this.r_district_id || null,
                zone_id:     this.r_zone_id     || null,
            }).then((response) => {
                this.r_loading = false
                if (response.data.status === 'success') {
                    const EXCL_R = [735]
                    this.receipt_received_list     = (response.data.data.received     || []).filter(u => !EXCL_R.includes(u.district_id))
                    this.receipt_not_received_list = (response.data.data.not_received || []).filter(u => !EXCL_R.includes(u.district_id))
                    this.r_t_number_count      = response.data.data.t_number_pending_count || 0
                    this.r_show_pending_only   = false
                    this.r_loaded              = true
                    // Collapse all zones by default
                    const collapsed = {}
                    const all = [...this.receipt_received_list, ...this.receipt_not_received_list]
                    all.forEach(u => { if (u.zone_id) collapsed[u.zone_id] = true })
                    this.collapsedZones = collapsed
                    // Build unit dropdown from loaded data
                    const rUnitMap = {}
                    all.forEach(u => { if (u.id && !rUnitMap[u.id]) rUnitMap[u.id] = u.name })
                    this.r_unit_options = Object.entries(rUnitMap).map(([id, name]) => ({ id: parseInt(id), name })).sort((a, b) => a.name.localeCompare(b.name))
                    this.r_unit_id = ''
                    // Preload the undistributed-zones count for the sub-tab badge
                    this.loadUndistributed()
                }
            }).catch(() => { this.r_loading = false })
        },
        // T-number receipts list — same district/zone scope as the receipt report above,
        // sorted greatest-to-smallest T-number by the backend.
        openTNumberListModal() {
            this.tList_show = true
            this.tList_loading = true
            this.tList_rows = []
            UserService.authPostRequest('get-t-number-receipts-list', {
                type:        parseInt(this.$route.params.type),
                district_id: this.r_district_id || null,
                zone_id:     this.r_zone_id     || null,
            }).then((response) => {
                this.tList_loading = false
                if (response.data.status === 'success') {
                    this.tList_rows = response.data.data.list || []
                }
            }).catch(() => { this.tList_loading = false })
        },

        // Not Started report
        toggleNsZone(key) {
            this.collapsedNsZones = { ...this.collapsedNsZones, [key]: !this.collapsedNsZones[key] }
        },
        onNsDistrictChange() {
            this.ns_zone_id = ''
            this.ns_zones = []
            this.ns_unit_id = ''
            this.ns_unit_options = []
            if (this.ns_district_id) this.loadNsZones(this.ns_district_id)
        },
        loadNsZones(districtId) {
            UserService.authGetRequest('get-zones', { district_id: districtId }).then((response) => {
                if (response.data.status === 'success') {
                    this.ns_zones = response.data.data.zones || response.data.data || []
                }
            })
        },
        onNsZoneChange() {
            this.ns_unit_id = ''
            this.ns_unit_options = []
            if (this.ns_zone_id) this.loadNsUnits(this.ns_zone_id)
        },
        loadNsUnits(zoneId) {
            UserService.authGetRequest('get-units', { zone_id: zoneId }).then((response) => {
                if (response.data.status === 'success') {
                    this.ns_unit_options = response.data.data || []
                }
            })
        },
        loadNotStartedReport() {
            this.ns_loading = true
            this.ns_loaded  = false
            UserService.authPostRequest('get-fund-collection-not-started-report', {
                type:        parseInt(this.$route.params.type),
                district_id: this.ns_district_id || null,
                zone_id:     this.ns_zone_id     || null,
            }).then((response) => {
                this.ns_loading = false
                if (response.data.status === 'success') {
                    const EXCL_NS = [735]
                    this.ns_unit_started       = (response.data.data.unit_started       || []).filter(u => !EXCL_NS.includes(u.district_id))
                    this.ns_unit_not_started   = (response.data.data.unit_not_started   || []).filter(u => !EXCL_NS.includes(u.district_id))
                    this.ns_unit_total         = response.data.data.unit_total         || 0
                    this.ns_zone_not_started   = response.data.data.zone_not_started   || []
                    this.ns_zone_percent       = (response.data.data.zone_percent       || []).filter(z => !EXCL_NS.includes(z.district_id))
                    this.ns_zone_total         = response.data.data.zone_total         || 0
                    this.ns_district_not_started = response.data.data.district_not_started || []
                    this.ns_district_percent   = (response.data.data.district_percent   || []).filter(d => !EXCL_NS.includes(d.id))
                    this.ns_district_total     = response.data.data.district_total     || 0
                    this.ns_breakdown = response.data.data.breakdown || null
                    this.ns_level  = 'unit'
                    this.ns_mode   = 'not_started'
                    this.ns_percent_filter = null
                    this.ns_loaded = true
                    // Collapse all zones by default
                    const collapsed = {}
                    this.ns_unit_not_started.forEach(u => { collapsed[u.zone_name || ''] = true })
                    this.ns_unit_started.forEach(u => { collapsed[u.zone_name || ''] = true })
                    this.collapsedNsZones = collapsed
                    // Build unit dropdown from loaded data
                    const nsUnitMap = {}
                    ;[...this.ns_unit_started, ...this.ns_unit_not_started].forEach(u => { if (u.id && !nsUnitMap[u.id]) nsUnitMap[u.id] = u.name })
                    this.ns_unit_options = Object.entries(nsUnitMap).map(([id, name]) => ({ id: parseInt(id), name })).sort((a, b) => a.name.localeCompare(b.name))
                    this.ns_unit_id = ''
                }
            }).catch(() => { this.ns_loading = false })
        },

        // Call & Follow-up
        dial(bearer) {
            const num = (bearer.country_code || '91') + '' + bearer.mobile
            window.location.href = 'tel:+' + num
        },
        openFollowup(unit) {
            this.followupUnit = unit
            this.followupShow = true
            this.followupBearers = []
            this.followupNotes = []
            this.newFollowupNote = ''
            this.followupBearersLoading = true
            UserService.authPostRequest('get-unit-office-bearers', { unit_id: unit.id }).then((response) => {
                this.followupBearersLoading = false
                if (response.data.status === 'success') {
                    this.followupBearers = response.data.data.office_bearers || []
                }
            }).catch(() => { this.followupBearersLoading = false })
            this.loadFollowupNotes()
        },
        loadFollowupNotes() {
            if (!this.followupUnit) return
            this.followupNotesLoading = true
            UserService.authPostRequest('get-unit-followup-notes', {
                unit_id: this.followupUnit.id,
                fund_type: this.$route.params.type,
            }).then((response) => {
                this.followupNotesLoading = false
                if (response.data.status === 'success') {
                    this.followupNotes = response.data.data.notes || []
                }
            }).catch(() => { this.followupNotesLoading = false })
        },
        saveFollowupNote() {
            const note = this.newFollowupNote.trim()
            if (!note || !this.followupUnit) return
            this.savingFollowupNote = true
            UserService.authPostRequest('store-unit-followup-note', {
                unit_id: this.followupUnit.id,
                fund_type: this.$route.params.type,
                note,
            }).then((response) => {
                this.savingFollowupNote = false
                if (response.data.status === 'success') {
                    this.newFollowupNote = ''
                    this.loadFollowupNotes()
                }
            }).catch(() => { this.savingFollowupNote = false })
        },
    },
}
</script>
